/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { orderService, userService, walletService, messengerService, carteraService, internalOrderService, logisticsService } from '../services/api';
import DeliveryRegistrationModal from '../components/DeliveryRegistrationModal';
import DeliveryConfirmationModal from '../components/DeliveryConfirmationModal';

import OrderReviewModal from '../components/OrderReviewModal';
import OrderTimelineModal from '../components/OrderTimelineModal';
import WalletValidationModal from '../components/WalletValidationModal';
import PosValidationModal from '../components/PosValidationModal';
import LogisticsModal from '../components/LogisticsModal';
import { printInternalVoucher } from '../utils/printInternalVoucher';
import RefundModal from '../components/RefundModal';
import PickupPaymentModal from '../components/PickupPaymentModal';
import ReturnToBillingModal from '../components/ReturnToBillingModal';
import DeleteSiigoOrderModal from '../components/DeleteSiigoOrderModal';
import SpecialManagementModal from '../components/SpecialManagementModal';
import ReasonModal from '../components/ReasonModal';
import ChangeShippingModal from '../components/ChangeShippingModal';
import IsolatedSearchInput from '../components/IsolatedSearchInput';
import ReadyForDeliveryGroupTable from '../components/ReadyForDeliveryGroupTable';
import UploadEvidenceModal from '../components/UploadEvidenceModal';
import ShippingLabelModal from '../components/ShippingLabelModal';
import PendingTransportGuides from '../components/PendingTransportGuides';
import AdhocPaymentModal from '../components/AdhocPaymentModal';
import ReconciliationModal from '../components/ReconciliationModal';
import SnapshotViewerModal from '../components/SnapshotViewerModal';
import MultiInvoiceRCDialog from '../components/MultiInvoiceRCDialog';
import AbonoParcialesDialog from '../components/AbonoParcialesDialog';
import api from '../services/api';
import * as Icons from 'lucide-react';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import es from 'date-fns/locale/es';
import { io } from 'socket.io-client';
import audioFeedback from '../utils/audioUtils';

import PendingPaymentsOverview from '../components/PendingPaymentsOverview';
import PendingReconciliationSection from '../components/PendingReconciliationSection';
import BillingHistoryTab from '../components/BillingHistoryTab';
import { getPendingCollectionOrders } from '../utils/orderFilters'; // SECCIÓN NUEVA
import {
  isPaymentReviewRequired,
  computeCollectionAmounts,
  isCreditOrder,
  hasOrderPayment,
  hasShippingFeePaid,
  normalize,
  getPaymentMethodLabel,
  getPaymentBadgeClass,
  getElectronicLabel,
  getElectronicBadgeClass,
  resolveElectronicType,
  getProviderHint,
  detectProviderFromString
} from '../utils/payments';
import { formatCurrencyCOP } from '../utils/formatters';
import { extractRC } from '../utils/rcHelper';

// CustomDropdown para reemplazar selector nativo de estado
const CustomDropdown = ({ value, onChange, options, placeholder, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-left flex items-center justify-between ${className}`}
        style={{ zIndex: 1 }}
      >
        <span className={value ? 'text-gray-900' : 'text-gray-500'}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <Icons.ChevronDown className={`w - 4 h - 4 text - gray - 400 transition - transform ${isOpen ? 'rotate-180' : ''} `} />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-auto">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option.value)}
              className="w-full px-3 py-2 text-left hover:bg-gray-100 transition-colors"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}

      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

    </div>
  );
};

const OrdersPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const socketRef = useRef(null);
  const searchInputRef = useRef(null);
  const socketConnectedRef = useRef(false);
  const lastRequestIdRef = useRef(0);
  const [refundModal, setRefundModal] = useState({ isOpen: false, order: null });
  const [labelModal, setLabelModal] = useState({ isOpen: false, order: null });

  // Tab actual para vista de mensajero: 'asignados' (default) o 'ready'
  const messengerTab = searchParams.get('tab') || 'asignados';
  const setMessengerTab = (tab) => {
    const params = new URLSearchParams(searchParams);
    if (tab === 'asignados') {
      params.delete('tab');
    } else {
      params.set('tab', tab);
    }
    setSearchParams(params, { replace: true });
  };

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [messengers, setMessengers] = useState([]);
  const [carteraCurrentPage, setCarteraCurrentPage] = useState(1);
  const CARTERA_ITEMS_PER_PAGE = 10;

  // ⏱️ Live timer tick (1s for facturacion/logistica, 60s for other views)
  const [timerTick, setTimerTick] = useState(new Date());
  useEffect(() => {
    const v = searchParams.get('view');
    const fastTick = v === 'facturacion' || v === 'logistica';
    const interval = setInterval(() => setTimerTick(new Date()), fastTick ? 1000 : 60000);
    return () => clearInterval(interval);
  }, [searchParams]);


  // Estados para filtros - estado simplificado sin separación de búsqueda
  const [filters, setFilters] = useState(() => ({
    search: searchParams.get('search') || '',
    status: searchParams.get('status') || '',
    paymentMethod: searchParams.get('paymentMethod') || '',
    tags: searchParams.get('tags') || '',
    dateFrom: searchParams.get('dateFrom') || '',
    dateTo: searchParams.get('dateTo') || '',
    page: parseInt(searchParams.get('page')) || 1,
    limit: 10,
    sortBy: 'created_at',
    sortOrder: 'ASC'
  }));

  // Frontend-only filtering for payment status (PAGADO/COBRAR)
  const displayedOrders = useMemo(() => {
    if (!filters.paymentMethod) return orders;

    if (filters.paymentMethod === 'STATUS_PAGADO') {
      return orders.filter(order => {
        const total = Number(order.total_amount || 0);
        const paid = Number(order.paid_amount || 0);
        const balance = total - paid;
        return balance <= 2000; // Considera pagado si balance <= $2,000
      });
    }

    if (filters.paymentMethod === 'STATUS_COBRAR') {
      return orders.filter(order => {
        const total = Number(order.total_amount || 0);
        const paid = Number(order.paid_amount || 0);
        const balance = total - paid;
        return balance > 2000; // Requiere cobro si balance > $2,000
      });
    }

    // Para cualquier otro filtro (métodos de pago normales), devolver todas
    return orders;
  }, [orders, filters.paymentMethod]);

  // Función para abrir guía en nueva pestaña (igual que ReadyToDeliverPage)
  const openGuideInNewTab = (ord, boxCount = 1) => {
    try {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/api/logistics/generate-guide-html';
      form.target = '_blank';

      const formDataGuide = {
        orderId: ord?.id,
        boxCount: boxCount,
        // Notas opcionales
        notes: [ord?.siigo_observations, ord?.observations, ord?.notes].filter(Boolean).join('\n')
      };

      Object.keys(formDataGuide).forEach((key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = formDataGuide[key] || '';
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      form.remove();
    } catch (error) {
      console.error('Error abriendo guía:', error);
      toast.error('Error al generar la guía');
    }
  };

  // Computed variables after state hooks
  const isMessengerPerspective = useMemo(() => {
    return user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && (searchParams.get('view') === 'mensajero'));
  }, [user, searchParams]);

  const isCarteraPerspective = useMemo(() => {
    return searchParams.get('view') === 'cartera' || filters.status === 'revision_cartera';
  }, [searchParams, filters.status]);

  const showMobileCards = useMemo(() => {
    return isMessengerPerspective || isCarteraPerspective;
  }, [isMessengerPerspective, isCarteraPerspective]);

  // Etiquetas disponibles para el filtro
  const [availableTags, setAvailableTags] = useState([]);

  // Función para cargar etiquetas
  const fetchTags = async () => {
    try {
      const tags = await orderService.getTags();
      setAvailableTags(tags);
    } catch (error) {
      console.error('Error al cargar etiquetas:', error);
    }
  };

  // Cargar etiquetas al montar
  useEffect(() => {
    fetchTags();
  }, []);

  const [readyOrders, setReadyOrders] = useState([]);

  // Cash session guard for cartera payments
  const [cashSessionOpen, setCashSessionOpen] = useState(true); // default true to avoid flash

  const [siigoPending, setSiigoPending] = useState([]);
  const [pickupPending, setPickupPending] = useState([]);
  const [pickupPage, setPickupPage] = useState(1);
  const PICKUP_ITEMS_PER_PAGE = 10;
  const [refundsPending, setRefundsPending] = useState([]);
  const [pendingCollection, setPendingCollection] = useState([]); // NUEVO: Pedidos por cobrar (contraentrega/ruta)
  const [reposicionOrders, setReposicionOrders] = useState([]);
  const [paymentReviewList, setPaymentReviewList] = useState([]); // Pedidos reingresando a cartera para validación
  // pendingReconciliation state removed - now managed internally by PendingReconciliationSection component

  const [globalPendingOrders, setGlobalPendingOrders] = useState([]); // NUEVO: Pedidos pendientes globales desde Feb 1
  const [reconciliationModal, setReconciliationModal] = useState({ isOpen: false, order: null });
  const [siigoCloseModal, setSiigoCloseModal] = useState({
    open: false,
    order: null,
    method: 'efectivo', // 'efectivo' | 'transferencia'
    note: '',
    tags: [],
    availableTags: []
  });

  const [reposicionModal, setReposicionModal] = useState({
    open: false,
    order: null,
    notes: '',
    files: [],
    isSubmitting: false
  });

  const [shippingModal, setShippingModal] = useState({
    isOpen: false,
    order: null
  });

  // Estados para modales
  const [deliveryModal, setDeliveryModal] = useState({
    isOpen: false,
    order: null
  });

  const [reviewModal, setReviewModal] = useState({
    isOpen: false,
    order: null
  });

  const [walletModal, setWalletModal] = useState({
    isOpen: false,
    order: null
  });
  const [posModal, setPosModal] = useState({
    isOpen: false,
    order: null
  });
  const [returnToBillingModal, setReturnToBillingModal] = useState({
    isOpen: false,
    order: null
  });
  const [logisticsModal, setLogisticsModal] = useState({
    isOpen: false,
    order: null
  });

  // Cargar pedidos globales pendientes (desde Feb 1, 2026)
  useEffect(() => {
    const loadGlobalPending = async () => {
      // Solo cargar para las vistas relevantes
      if (!['logistica', 'cartera', 'facturacion'].includes(searchParams.get('view'))) return;

      try {
        console.log('🔄 Cargando resumen global de pendientes (full cartera)...');
        // Usar endpoint de cartera que ya tiene la consulta optimizada con balance agregado,
        // ordenes internas, cash_register, y el whitelist de estados correcto
        const response = await walletService.getWalletOrders({
          limit: 5000,
          include_logistica_pending: true
        });

        // Normalizar respuesta del endpoint de cartera
        const payload = response?.data ?? response ?? {};
        let allOrders = payload?.orders ?? payload?.data?.orders ?? [];

        // Fallback adicional
        if (!Array.isArray(allOrders) && Array.isArray(payload?.data)) {
          allOrders = payload.data;
        }

        // Asegurar que sea un array antes de filtrar
        if (!Array.isArray(allOrders)) {
          console.warn('⚠️ allOrders no es un array:', allOrders);
          allOrders = [];
        }

        // Filtrar solo los que tienen deuda > 100 y NO son hijos (Parent-Only)
        // El backend ya calcula calculated_balance_due con internos + cash_register
        const pending = allOrders.filter(o => {
          if (o.parent_order_id) return false; // Ocultar hijos de la lista principal

          // Excluir métodos de pago que no requieren cobro
          const pm = (o.payment_method || '').toLowerCase();
          if (['cliente_credito', 'credito', 'publicidad', 'reposicion', 'saldo_a_favor', 'nota_credito'].includes(pm)) return false;

          // TRUST BACKEND: calculated_balance_due ya incluye INT totals, INT paid, y cash_register
          // No recalcular manualmente para evitar sumar INT totals sin restar INT paid
          const backendBalance = parseFloat(o.calculated_balance_due ?? -1);
          const totalDebt = backendBalance >= 0
            ? backendBalance
            : Math.max(0, parseFloat(o.total_amount || 0) - parseFloat(o.paid_amount || 0));

          // Inyectar propiedades calculadas para el componente visual
          o.calculated_propio_debt = Math.max(0, parseFloat(o.total_amount || 0) - parseFloat(o.paid_amount || 0));
          o.calculated_internal_debt = parseFloat(o.internal_orders_total || 0);
          o.calculated_total_debt = totalDebt;

          return totalDebt > 2000;
        });

        setGlobalPendingOrders(pending);
        console.log(`✅ Resumen global cargado: ${pending.length} pedidos con deuda de ${allOrders.length} total`);
      } catch (error) {
        console.error('Error cargando resumen global:', error);
      }
    };

    loadGlobalPending();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.get('view')]);
  const [deleteSiigoModal, setDeleteSiigoModal] = useState({
    isOpen: false,
    order: null,
    loading: false
  });

  // Check cash session when entering cartera view (non-admin)
  useEffect(() => {
    const view = searchParams.get('view');
    if (!['cartera', 'facturacion'].includes(view)) return;
    if (user?.role === 'admin') { setCashSessionOpen(true); return; }

    const checkSession = async () => {
      try {
        const res = await api.get('/cash-box/current?box_name=Caja%20Principal');
        const hasSession = !!(res?.data?.session);
        setCashSessionOpen(hasSession);
        if (!hasSession) console.warn('⚠️ No hay caja abierta — pagos bloqueados');
      } catch {
        setCashSessionOpen(false);
      }
    };
    checkSession();
    const interval = setInterval(checkSession, 60000); // re-check every 60s
    return () => clearInterval(interval);
  }, [searchParams.get('view'), user?.role]);

  const [deliveryConfirmationModal, setDeliveryConfirmationModal] = useState({
    isOpen: false,
    order: null
  });

  const [pickupPaymentModal, setPickupPaymentModal] = useState({
    isOpen: false,
    order: null
  });

  const [timelineModal, setTimelineModal] = useState({
    isOpen: false,
    order: null
  });

  const [paymentGuardModal, setPaymentGuardModal] = useState({ isOpen: false, order: null, paymentMethod: '' });
  const [specialModal, setSpecialModal] = useState({
    isOpen: false,
    order: null,
    loading: false
  });

  // Modal genérico para razones (rechazar / entrega fallida)
  const [reasonModal, setReasonModal] = useState({
    isOpen: false,
    order: null,
    mode: 'reject',
    loading: false
  });
  // Cancelación por cliente (acción rápida en listado)
  const [cancelModal, setCancelModal] = useState({
    isOpen: false,
    order: null,
    loading: false
  });

  const [uploadEvidenceModal, setUploadEvidenceModal] = useState({
    open: false,
    order: null,
    file: null
  });

  const [adhocPaymentModal, setAdhocPaymentModal] = useState({
    isOpen: false
  });

  const [snapshotModal, setSnapshotModal] = useState({
    isOpen: false,
    orderId: null
  });

  // Multi-Invoice RC Dialog State
  const [multiRcDialogOpen, setMultiRcDialogOpen] = useState(false);
  const [abonoDialogOpen, setAbonoDialogOpen] = useState(false);

  const [syncingOrderId, setSyncingOrderId] = useState(null);
  const [syncRCProgress, setSyncRCProgress] = useState({});



  // Ocultar en tiempo real pedidos ya entregados para evitar reaparición por latencia

  // Efecto para seguimiento GPS en tiempo real (Mensajeros)
  useEffect(() => {
    let watchId = null;
    let lastLogTime = 0;
    let wakeLock = null;
    let handleVisibilityChange = () => { };

    if (user?.role === 'mensajero') {
      const requestWakeLock = async () => {
        if ('wakeLock' in navigator) {
          try {
            wakeLock = await navigator.wakeLock.request('screen');
            // console.log('Screen Wake Lock acquired');
          } catch (err) {
            console.error(`${err.name}, ${err.message}`);
          }
        }
      };

      handleVisibilityChange = () => {
        if (wakeLock !== null && document.visibilityState === 'visible') {
          requestWakeLock();
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      const handlePositionChange = async (position) => {
        try {
          // Throttling: Solo enviar al servidor si ha pasado al menos 1 minuto (60000ms)
          const now = Date.now();
          if (now - lastLogTime < 60000) return;

          // Verificamos si hay pedidos que justifiquen el seguimiento (listos o en ruta)
          const activeOrders = orders.filter(o =>
            ['en_reparto', 'listo_para_entrega'].includes(o.status) &&
            (o.assigned_messenger_id === user.id)
          );

          if (activeOrders.length === 0) {
            if (wakeLock !== null) {
              wakeLock.release().then(() => { wakeLock = null; });
            }
            return;
          }

          // Si hay pedidos activos, aseguramos que la pantalla no se apague
          if (wakeLock === null) {
            requestWakeLock();
          }

          const { latitude, longitude, accuracy } = position.coords;
          await messengerService.updateLocation({ latitude, longitude, accuracy });
          lastLogTime = now;
        } catch (error) {
          console.warn('❌ Error en actualización GPS:', error);
        }
      };

      if (navigator.geolocation) {
        watchId = navigator.geolocation.watchPosition(
          handlePositionChange,
          (err) => console.warn('📍 GPS Watch Error:', err.message),
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
        );
      }
    }

    return () => {
      if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
      }
      if (wakeLock !== null) {
        wakeLock.release().catch(console.error);
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user?.role, user?.id, orders]);

  // Ref para pausar recargas mientras haya modales abiertos (evita reset de LogisticsModal)
  const modalOpenRef = useRef(false);
  useEffect(() => {
    modalOpenRef.current =
      logisticsModal.isOpen ||
      deliveryModal.isOpen ||
      reviewModal.isOpen ||
      walletModal.isOpen ||
      pickupPaymentModal.isOpen ||
      deliveryConfirmationModal.isOpen ||
      timelineModal.isOpen ||
      deleteSiigoModal.isOpen ||
      multiRcDialogOpen;
  }, [
    logisticsModal.isOpen,
    deliveryModal.isOpen,
    reviewModal.isOpen,
    walletModal.isOpen,
    pickupPaymentModal.isOpen,
    deliveryConfirmationModal.isOpen,
    timelineModal.isOpen,
    deleteSiigoModal.isOpen,
    multiRcDialogOpen
  ]);

  // Estado para recarga desde SIIGO por pedido

  // Funciones para mensajeros (moved inside component)
  const handleAcceptOrder = async (orderId) => {
    try {
      const response = await fetch(`/api/messenger/orders/${orderId}/accept`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        let errorMessage = 'Error aceptando pedido';
        try {
          const errData = await response.json();
          errorMessage = errData.message || errorMessage;
        } catch (e) {
          const text = await response.text().catch(() => '');
          errorMessage = `Error ${response.status}: ${text.slice(0, 50) || response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      toast.success(result.message || 'Pedido aceptado exitosamente');
      // Actualizar UI optimistamente sin recargar toda la lista
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('orders:update', { detail: { id: orderId, patch: { messenger_status: 'accepted' } } }));
      }
    } catch (error) {
      console.error('Error aceptando pedido:', error);
      toast.error(`DEBUG: ${error.message || 'Error aceptando pedido'}`);
    }
  };

  const handleRejectOrder = (orderId) => {
    try {
      const orderObj = orders.find(o => o.id === orderId) || null;
      setReasonModal({ isOpen: true, order: orderObj || { id: orderId }, mode: 'reject', loading: false });
    } catch (error) {
      console.error('Error abriendo modal de rechazo:', error);
      toast.error('No se pudo abrir el modal de rechazo');
    }
  };

  const handleStartDelivery = async (orderId) => {
    try {
      const response = await fetch(`/api/messenger/orders/${orderId}/start-delivery`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Error iniciando entrega');
      }

      const result = await response.json();
      toast.success(result.message || 'Entrega iniciada exitosamente');
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('orders:refresh'));
      }
    } catch (error) {
      console.error('Error iniciando entrega:', error);
      toast.error('Error iniciando entrega');
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('orders:refresh'));
      }
    }
  };

  const handleMarkDeliveryFailed = (orderId) => {
    try {
      const orderObj = orders.find(o => o.id === orderId) || null;
      setReasonModal({ isOpen: true, order: orderObj || { id: orderId }, mode: 'failed', loading: false });
    } catch (error) {
      console.error('Error abriendo modal de entrega fallida:', error);
      toast.error('No se pudo abrir el modal');
    }
  };


  // Estados para acciones
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [bulkAction, setBulkAction] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  // Track orders with payment received during this session and in-flight requests
  const [recentlyPaidOrders, setRecentlyPaidOrders] = useState(new Set());
  const [receivingIds, setReceivingIds] = useState(new Set());
  // Track recargas desde SIIGO por pedido para animar ruedita
  const [reloadingIds, setReloadingIds] = useState(new Set());

  // Helpers to robustly determine processing/paid status (handles string/number id mismatches and raw flags)
  const keyForId = useCallback((id) => String(id), []);
  const isProcessing = useCallback((id) => receivingIds.has(keyForId(id)), [receivingIds, keyForId]);
  const isPaidUi = useCallback((order) => {
    const k = keyForId(order?.id);
    // Consider both local session state and raw flags possibly coming from backend payload
    const rawPaid =
      Boolean(order?.payment_received) ||
      Boolean(order?.payment_collected) ||
      Boolean(order?.paymentCollected) ||
      Boolean(order?.has_payment) ||
      Boolean(order?.has_order_payment) ||
      Boolean(order?.hasOrderPayment);
    return hasOrderPayment(order) || recentlyPaidOrders.has(k) || rawPaid;
  }, [recentlyPaidOrders, keyForId]);

  // Delivered state from backend flags or status
  const isDeliveredUi = useCallback((order) => {
    const s = (order?.status || '').toString();
    return (
      ['entregado_cliente', 'entregado_bodega', 'entregado', 'finalizado', 'completado'].includes(s) ||
      Boolean(order?.delivered_at) ||
      Boolean(order?.is_delivered)
    );
  }, []);

  // Optimistic removal from "Ready for Delivery" groups after state change

  // Ref para mantener los filtros actuales accesibles dentro de closures (sockets/timers)
  const filtersRef = useRef(filters);
  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  // Cargar pedidos - memoizado para evitar re-creaciones innecesarias
  // Helper para verificar si un pedido requiere revisión de pago
  const isPaymentReviewRequired = (order) => {
    if (!order) return false;
    const tags = Array.isArray(order.tags)
      ? order.tags.map(t => typeof t === 'string' ? t : t.name).join(' ')
      : (order.tags || '');
    return tags.includes('Revisar Pago') || tags.includes('net_mismatch') || tags.includes('Revalidar Pago');
  };

  const loadOrders = useCallback(async (filtersToUse, showLoading = true) => {
    // Si no se pasan filtros explícitos, usar los actuales del Ref (evita stale closures)
    const actualFilters = filtersToUse || filtersRef.current;
    const currentRequestId = ++lastRequestIdRef.current;
    let list = []; // [FIX] Global function scope to prevent ReferenceErrors
    let payload = {}; // [FIX] Global function scope for pagination access

    try {
      if (showLoading) setLoading(true);

      // Determinar si estamos en la vista de cartera o todos los pedidos
      const view = searchParams.get('view');
      const isWalletView = view === 'cartera' || actualFilters.status === 'revision_cartera';
      const isAllOrdersView = view === 'todos';

      // NO limpiar la lista actual durante carga — los datos previos se mantienen
      // visibles como cache visual hasta que el nuevo fetch complete.
      // Esto evita el "flash vacío" al recargar la página.

      // Si es mensajero o logística/admin con vista de mensajero, usar la vista de mensajero
      if (user?.role === 'mensajero' || ((['logistica', 'admin'].includes(user?.role)) && view === 'mensajero')) {
        console.log('📱 Usuario mensajero/logística/admin - usando vista de mensajero');
        try {
          // Siempre usar el endpoint enriquecido de mensajero para esta vista
          // (incluye flags como is_credit/requires_payment coherentes para UI)
          const searchParam = actualFilters.search ? `?search=${encodeURIComponent(actualFilters.search)}` : '';
          let endpoint = `/api/messenger/orders${searchParam}`;
          if (['logistica', 'admin'].includes(user?.role)) {
            console.log('🏢 Usuario logística/admin - usando endpoint de mensajero para vista de mensajero');
          }

          const response = await fetch(endpoint, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });

          if (!response.ok) {
            throw new Error('Error cargando pedidos de mensajero');
          }

          const data = await response.json();

          // Si es logística o admin, filtrar solo pedidos con mensajeros asignados
          list = data.data?.orders || data.data || [];
          if (['logistica', 'admin'].includes(user?.role)) {
            list = list.filter(order =>
              order.assigned_messenger_id &&
              ['listo_para_entrega', 'en_reparto', 'entregado_cliente'].includes(order.status)
            );
            console.log(`🔍 Logística/Admin - Mostrando ${list.length} pedidos con mensajeros asignados`);
          }

          setOrders(list);
          setPagination({
            page: 1,
            pages: 1,
            total: list.length || 0,
            limit: 50
          });

        } catch (error) {
          console.error('Error cargando pedidos de mensajero:', error);
          toast.error('Error cargando pedidos asignados');
        }
      } else {
        // [REF] list declared at function scope
        // Preparar filtros - si es vista "todos", eliminar filtro de estado
        let finalFilters = { ...actualFilters };
        if (isAllOrdersView) {
          // Forzar LIFO (último primero) solo en vista "Todos los Pedidos"
          // Enviar explícitamente view='todos' al backend para permitir a Cartera ver todo el histórico
          finalFilters = { ...actualFilters, view: 'todos', status: '', sortBy: 'created_at', sortOrder: 'DESC', limit: 100 };
          console.log('📋 Vista "Todos los Pedidos" - mostrando pedidos sin filtrar por estado (LIFO) y limit=100');
        }

        let response;
        if (isWalletView) {
          // Usar el endpoint específico de cartera que garantiza datos correctos
          console.log('🏦 Usando endpoint de cartera para obtener pedidos');
          // Forzar inclusión de pedidos en logística/empaque con saldo pendiente
          // IMPORTANTE: Usar limit alto (5000) para mostrar TODOS los pedidos sin paginación
          const walletFilters = { ...finalFilters, include_logistica_pending: true, limit: 5000 };
          response = await walletService.getWalletOrders(walletFilters);
          console.log('🏦 Respuesta Cartera RAW:', response);
        } else {
          // Usar el endpoint general de pedidos
          // Nota: si el filtro es "pendiente_empaque" (ficha agrupada), NO enviar status al backend,
          // para evitar que el servidor filtre por un estado inexistente y devuelva vacío.
          // En su lugar pedimos una lista más amplia y filtramos en frontend por:
          // ['pendiente_empaque', 'en_preparacion', 'en_empaque'].
          let apiFilters = { ...finalFilters };
          const pseudoGroup = new Set(['pendiente_empaque', 'pendiente_entrega', 'listo_para_entrega_pendientes', 'entregados']);
          if (pseudoGroup.has((finalFilters.status || ''))) {
            // Para pseudo-estados agrupados, no enviar status al backend; filtramos en frontend
            apiFilters.status = '';
            apiFilters.limit = Math.max(Number(finalFilters.limit || 50), 100);
            apiFilters.sortBy = finalFilters.sortBy || 'created_at';
            apiFilters.sortOrder = finalFilters.sortOrder || 'DESC';
          }

          // EXCLUSIÓN DE FILTROS FRONTEND-ONLY
          // STATUS_PAGADO y STATUS_COBRAR son filtros que se aplican SOLO en frontend
          // No deben enviarse al backend porque el backend intentará buscar payment_method='STATUS_PAGADO'
          if (apiFilters.paymentMethod === 'STATUS_PAGADO' || apiFilters.paymentMethod === 'STATUS_COBRAR') {
            delete apiFilters.paymentMethod;
          }

          response = await orderService.getOrders(apiFilters);
        }

        // Normalizar payload de respuesta (wallet suele envolver en data.data)
        payload = response?.data ?? {};
        list = payload?.data?.orders ?? payload?.orders ?? payload?.data ?? [];
        if (!Array.isArray(list) && Array.isArray(payload?.data)) {
          list = payload.data;
        }

        // CONTROL DE CONCURRENCIA: Ignorar si ya hay una petición más reciente en curso
        if (currentRequestId !== lastRequestIdRef.current) {
          console.warn(`⏳ Ignorando respuesta obsoleta de loadOrders (req ${currentRequestId} vs current ${lastRequestIdRef.current})`);
          return;
        }

        // GRABACIÓN GLOBAL PARA CARTERA (Super-prioridad: Ver dinero en calle sin importar filtros)
        // Calculamos esto ANTES de cualquier filtro de estado (como revision_cartera)
        let globalPendingCollection = [];
        if (isWalletView) {
          globalPendingCollection = getPendingCollectionOrders(list);
          console.log(`💰 Global Pending Collection (Pre-Filter): ${globalPendingCollection.length}`);
          setPendingCollection(globalPendingCollection);
        }

        // Filtro defensivo en frontend: si se selecciona un estado específico,
        // asegurar que solo se muestren pedidos con ese estado (independiente de la respuesta del backend).
        // Caso especial: "pendiente_empaque" agrupa todo el flujo de empaque.
        if (finalFilters.status) {
          const desired = String(finalFilters.status);
          if (desired === 'pendiente_empaque') {
            const packagingGroup = new Set(['pendiente_empaque', 'en_preparacion', 'en_empaque']);
            list = list.filter(o => packagingGroup.has(String(o?.status || '')));
          } else if (desired === 'pendiente_entrega') {
            list = list.filter(o => {
              const s = String(o?.status || '').toLowerCase();
              const ms = String(o?.messenger_status || '').toLowerCase();
              return s === 'en_reparto' || ms === 'accepted' || ms === 'in_delivery';
            });
          } else if (desired === 'listo_para_entrega_pendientes') {
            list = list.filter(o => {
              const s = String(o?.status || '').toLowerCase();
              const ms = String(o?.messenger_status || '').toLowerCase();
              return s === 'listo_para_entrega' && !(ms === 'accepted' || ms === 'in_delivery');
            });
          } else if (desired === 'entregados') {
            list = list.filter(o => isDeliveredUi(o));
          } else if (desired === 'revision_cartera' && searchParams.get('view') === 'cartera' && !searchParams.get('status')) {
            // Bifurcación SOLO cuando navegamos a view=cartera sin filtro explícito de status
            // Si el usuario filtra por status=revision_cartera, mostrar TODOS los pedidos sin bifurcar
            const mainList = [];
            const pickupProcessList = [];
            const refundsList = [];
            // const pendingCollectionList = []; // YA CALCULADO GLOBALMENTE ARRIBA
            const paymentReviewList = []; // Pedidos que reingresan a cartera para validar pago

            list.forEach((o) => {
              // [FIX] Ocultar hijos (INT-) en listas principales. Su deuda se consolida en el padre.
              if (o.parent_order_id) return;

              const status = String(o?.status || '').toLowerCase();
              const isPickup = String(o?.delivery_method || '').toLowerCase().includes('bodega');
              const { productDue } = computeCollectionAmounts(o);

              const advancedLogisticsStatuses = new Set(['en_logistica', 'en_empaque', 'en_preparacion', 'empacado', 'listo_para_entrega', 'en_reparto', 'listo_para_recoger', 'entregado_cliente']);


              // 0. Pedidos reingresando con evidencia de pago (Segunda vez en cartera)
              // Prioridad alta: Si tiene evidencia pendiente Y NO está en revisión inicial (o aunque lo esté, si tiene evidencia es prioritario revisar)
              if (o?.is_pending_payment_evidence || String(o?.is_pending_payment_evidence) === '1' || o?.is_pending_payment_evidence === true) {
                paymentReviewList.push(o);
              }
              // 1. Devoluciones (Saldo negativo)
              else if (productDue < -100) {
                refundsList.push(o);
              }
              // 2. Pedidos en estados logísticos avanzados
              else if (
                advancedLogisticsStatuses.has(status) &&
                (productDue > 100 || status === 'listo_para_entrega')
              ) {
                // Pedidos de bodega: solo con saldo pendiente real > 2000
                if (isPickup && productDue > 2000) {
                  pickupProcessList.push(o);
                }
              }
              // 3. Pedidos en revisión estándar (Primera vez)
              else if (status === 'revision_cartera') {
                mainList.push(o);
              }
              // 4. Pickup con saldo en bodega
              else if (isPickup && productDue > 2000) {
                pickupProcessList.push(o);
              }
            });

            console.log(`📊 Bifurcación Cartera: Total=${list.length}, Main=${mainList.length}, PR(Revalidacion)=${paymentReviewList.length}, Pickup=${pickupProcessList.length}`);

            list = mainList;
            setPickupPending(pickupProcessList);
            setRefundsPending(refundsList);
            // setPendingCollection(pendingCollectionList); // ELIMINADO: Usamos el global
            setPaymentReviewList(paymentReviewList);
          } else if (desired === 'money_in_transit') {
            // El backend ya filtra, pero si queremos ser defensivos en frontend:
          } else if (desired === 'pendiente_por_facturacion') {
            // Facturación view: keep both pending invoicing AND returned orders
            const facturacionGroup = new Set(['pendiente_por_facturacion', 'no_entregado']);
            list = list.filter(o => facturacionGroup.has(String(o?.status || '')));
          } else {
            list = list.filter(o => String(o?.status || '') === desired);
          }
        }

        // BIFURCACIÓN PARA CARTERA - Ejecutar siempre que isWalletView sea true
        // Esto asegura que los pedidos se clasifiquen correctamente en diferentes listas
        // IMPORTANTE: Ejecutar SIEMPRE, incluso con filtros, para que las secciones sean consistentes
        if (isWalletView && searchParams.get('view') === 'cartera') {
          console.log('💼 Ejecutando bifurcación de Cartera');
          const mainList = [];
          const pickupProcessList = [];
          const refundsList = [];
          const additionsPendingList = [];
          // [FIX] Use the global pendingCollection already computed at line 839 from the FULL list
          // Do NOT recalculate from the bifurcated list — that drops domicilio+entregado orders
          const globalPendingIds = new Set((globalPendingCollection || []).map(o => o.id));

          const paymentReviewList = [];

          list.forEach((o) => {
            // [FIX] Ocultar hijos (INT-). Regla Parent-Only.
            if (o.parent_order_id) return;

            const status = String(o?.status || '').toLowerCase();
            const isPickup = (o.delivery_method === 'recoge_bodega' || o.delivery_method === 'recoge_posterior' || o.delivery_method === 'recoge_en_punto');
            const { productDue } = computeCollectionAmounts(o);
            const hasRC = extractRC(o).length > 0;

            // Safe tags extraction
            let tagsStr = '';
            if (Array.isArray(o.tags)) {
              tagsStr = o.tags.map(t => typeof t === 'string' ? t : t.name).join(',');
            } else if (typeof o.tags === 'string') {
              tagsStr = o.tags;
            }

            const advancedLogisticsStatuses = new Set(['en_logistica', 'en_empaque', 'en_preparacion', 'preparado', 'empacado', 'listo_para_entrega', 'en_reparto', 'listo_para_recoger', 'entregado_cliente', 'entregado']);

            // PRIORIDAD 1: TODOS los pedidos revision_cartera van a tabla principal
            if (status === 'revision_cartera') {
              mainList.push(o);
            }
            // PRIORIDAD 2: Solo separar pedidos que ya NO están en revision_cartera
            // 1. Devoluciones (Saldo negativo)
            else if (productDue < -100) {
              refundsList.push(o);
            }
            // 2. Pedidos para re-validación (priority)
            else if (
              (isPaymentReviewRequired(o) && productDue > 0) ||
              (tagsStr.includes('Modificado Facturación'))
            ) {
              paymentReviewList.push(o);
            }
            // 3. Pedidos en estados logísticos avanzados
            else if (
              advancedLogisticsStatuses.has(status) &&
              (productDue > 2000 || status === 'listo_para_entrega')
            ) {
              // Pedidos de bodega: solo con saldo pendiente real > 2000
              if (isPickup && productDue > 2000) {
                pickupProcessList.push(o);
              }
              // [FIX] Domicilio orders with pending balance are handled by globalPendingCollection
              // No action needed here — they'll appear in PendingPaymentsOverview
            }
            // 4. Pickup con saldo en bodega
            else if (isPickup && productDue > 2000) {
              pickupProcessList.push(o);
            }
          });


          console.log(`📊 Bifurcación Cartera: Total=${list.length}, Main=${mainList.length}, PR(Revalidacion)=${paymentReviewList.length}, Pickup=${pickupProcessList.length}, PendingGlobal=${globalPendingIds.size}`);


          // Mostrar pedidos de cartera + devoluciones.
          // SIEMPRE aplicar el filtrado correcto, incluso con búsqueda activa
          list = [...mainList, ...paymentReviewList, ...refundsList];

          // Eliminar duplicados
          list = Array.from(new Set(list.map(a => a.id)))
            .map(id => list.find(a => a.id === id));

          // Remover los que ya están en la sección de arriba (globalPendingCollection)
          list = list.filter(o => !globalPendingIds.has(o.id));

          // FILTRO FINAL AGRESIVO: Excluir pickups y asegurar limpieza
          list = list.filter(o =>
            o.status === 'revision_cartera' ||
            !['recoge_bodega', 'recoge_en_punto', 'recoge_posterior'].includes(o.delivery_method)
          );

          console.log(`📋 Vista Cartera ${actualFilters.search ? 'con búsqueda' : 'normal'}: ${list.length} pedidos`);

          setPickupPending(pickupProcessList);
          setRefundsPending(refundsList);
          // [FIX] Do NOT overwrite setPendingCollection here — use the global from line 839
          setPaymentReviewList(paymentReviewList);
        }
        setPaymentReviewList(paymentReviewList);
      } // [FIX] Cerrar bloque if(isWalletView) que quedó abierto tras borrar código duplicado

      // 08:00 - NUEVO: Si estamos en facturación o administrador, poblar 'pendingCollection'
      // de forma independiente del filtro de estado actual (FV-Pendientes, etc).
      if ((view === 'facturacion' || user?.role === 'admin' || user?.role === 'facturador') && !isWalletView) {
        try {
          const collectionResp = await orderService.getOrders({
            status: 'en_logistica,en_empaque,en_preparacion,empacado,listo_para_entrega,en_reparto,listo_para_recoger,entregado_cliente',
            limit: 100
          });
          const collectionItems = collectionResp?.data?.orders ?? collectionResp?.orders ?? [];

          const pColList = [];
          collectionItems.forEach(o => {
            const { productDue } = computeCollectionAmounts(o);
            const status = String(o?.status || '').toLowerCase();
            const advancedLogisticsStatuses = new Set(['en_logistica', 'en_empaque', 'en_preparacion', 'empacado', 'listo_para_entrega', 'en_reparto', 'listo_para_recoger', 'entregado_cliente']);

            // Los que deben dinero al mensajero (pagado = 0)
            if (advancedLogisticsStatuses.has(status) && productDue > 100 && !o.is_pending_payment_evidence && (o.paid_amount || 0) <= 0) {
              pColList.push(o);
            }
          });
          setPendingCollection(pColList);
        } catch (err) {
          console.error('Error fetching facturacion pending collection:', err);
        }
      }

      setOrders(list);

      // Limpiar secciones auxiliares si no estamos en Cartera o Facturación
      if (!isWalletView && view !== 'facturacion') {
        setPickupPending([]);
        setRefundsPending([]);
        setPendingCollection([]);
      }

      const pag = payload?.data?.pagination ?? payload?.pagination ?? {
        page: 1,
        pages: 1,
        total: list.length,
        limit: list.length || 1
      };
      setPagination(pag);

      // Auto-focus removido para evitar interferencias
    } catch (error) {
      console.error('Error cargando pedidos:', error);
      toast.error('Error cargando pedidos');
    } finally {
      setLoading(false);
    }
  }, [searchParams, user?.role]);

  // Cargar mensajeros (para asignación)
  const loadMessengers = async () => {
    if (['admin', 'logistica'].includes(user?.role)) {
      try {
        const response = await userService.getUsers({ role: 'mensajero', active: true });
        // La respuesta viene en response.data.data.users debido a la estructura del backend
        setMessengers(response.data.data?.users || response.data.users || []);
      } catch (error) {
        console.error('Error cargando mensajeros:', error);
      }
    }
  };

  // Cargar pedidos listos para entrega (para vista logística)
  const loadReadyOrders = useCallback(async () => {
    // Solo cargar si es logística o admin y NO estamos en la vista específica de "en_logistica" (que ya filtra)
    // O si queremos mostrar el dashboard superior.
    if (['logistica', 'admin'].includes(user?.role)) {
      try {
        // Usamos un filtro específico para traer solo los listos para entrega
        const response = await orderService.getOrders({
          status: 'listo_para_entrega',
          limit: 100, // Traer suficientes para agrupar
          page: 1
        });
        const payload = response?.data ?? {};
        let list = payload?.data?.orders ?? payload?.orders ?? payload?.data ?? [];
        if (!Array.isArray(list) && Array.isArray(payload?.data)) {
          list = payload.data;
        }
        setReadyOrders(list);
      } catch (error) {
        console.error('Error cargando pedidos listos:', error);
      }
    }
  }, [user?.role]);

  // Cargar pedidos listos al inicio y al recargar
  useEffect(() => {
    loadReadyOrders();
  }, [loadReadyOrders]);

  // Group ready orders by courier/messenger
  const groupedReadyOrders = useMemo(() => {
    const groups = {};
    readyOrders.forEach(order => {
      let key = 'Sin Asignar';
      if (order.carrier_name) {
        key = order.carrier_name;
      } else if (order.assigned_messenger_name) {
        key = order.assigned_messenger_name;
      } else if (order.delivery_method === 'recoge_bodega') {
        key = 'Cliente Físico (Bodega)';
      } else if (order.delivery_method === 'recoge_posterior') {
        key = 'Cliente WhatsApp (Recoge Bodega)';
      }

      if (!groups[key]) groups[key] = [];
      groups[key].push(order);
    });
    return groups;
  }, [readyOrders]);

  // Asignar mensajero a pedido
  const handleAssignMessengerToOrder = async (orderId, messengerId) => {
    try {
      const response = await fetch('/api/logistics/assign-messenger', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ orderId, messengerId })
      });

      if (!response.ok) {
        throw new Error('Error asignando mensajero');
      }

      const result = await response.json();
      toast.success(result.message);

      // Recargar datos
      loadOrders();

    } catch (error) {
      console.error('Error asignando mensajero:', error);
      toast.error('Error asignando mensajero');
    }
  };

  // Marcar pedido como entregado a transportadora
  const handleMarkAsDeliveredToCarrier = async (orderId, carrierName) => {
    try {
      const response = await fetch('/api/logistics/mark-delivered-carrier', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          orderId,
          status: 'entregado_transportadora',
          delivery_notes: `Entregado a ${carrierName} el ${new Date().toLocaleString()}`
        })
      });

      if (!response.ok) {
        throw new Error('Error marcando como entregado');
      }

      const result = await response.json();
      toast.success(`Pedido entregado a ${carrierName}`);

      // Recargar datos
      loadOrders();

    } catch (error) {
      console.error('Error marcando como entregado:', error);
      toast.error('Error marcando como entregado');
    }
  };

  // Marcar pedido listo para recoger
  const handleMarkReadyForPickup = async (orderId) => {
    try {
      const response = await fetch('/api/logistics/mark-ready-pickup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          orderId,
          status: 'listo_para_recoger',
          delivery_notes: `Listo para recoger en bodega - ${new Date().toLocaleString()}`
        })
      });

      if (!response.ok) {
        throw new Error('Error marcando como listo');
      }

      const result = await response.json();
      const msg = String(result?.message || '');
      if (/entregado/i.test(msg)) {
        // Si el backend confirmó entrega en bodega, remover optimistamente de la sección
        toast.success(msg);
      } else {
        toast.success(msg || 'Pedido marcado como listo para recoger');
      }

      // Recargar datos
      loadOrders();

    } catch (error) {
      console.error('Error marcando como listo:', error);
      toast.error('Error marcando como listo');
    }
  };

  // Sincronizar RC Manual
  const handleSyncRC = async (orderId) => {
    setSyncingOrderId(orderId);
    setSyncRCProgress((prev) => ({ ...prev, [orderId]: { progress: 0, message: 'Iniciando...' } }));

    // Modal opens automatically via syncingOrderId state
    setSyncRCProgress((prev) => ({ ...prev, [orderId]: { progress: 0, message: 'Iniciando conexión...' } }));

    // REMOVED TOAST LOADING as requested
    try {
      console.log('🔍 [FRONTEND] Starting sync-rc request for order:', orderId);
      const response = await fetch(`/api/orders/${orderId}/sync-rc`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      console.log('🔍 [FRONTEND] Response status:', response.status);
      const res = await response.json();
      console.log('🔍 [FRONTEND] Response data:', res);
      if (res.success) {
        // Backend started async process. Keep modal open.
        // setSyncRCProgress will be updated by socket.
        console.log('✅ [FRONTEND] Sync started successfully, waiting for socket events...');
      } else {
        console.error('❌ [FRONTEND] Sync failed:', res.message);
        toast.error(res.message || 'No se encontraron RCs');
        setSyncingOrderId(null);
        setSyncRCProgress((prev) => {
          const next = { ...prev };
          delete next[orderId];
          return next;
        });
      }
    } catch (e) {
      console.error('❌ [FRONTEND] Fetch error:', e);
      toast.error('Error de conexión');
      setSyncingOrderId(null);
    }
    // Finally block removed - we want modal to stay open if success=true until socket event
  };

  // Entregar pedido en bodega (cambia a entregado_bodega)
  const handleMarkPickupDelivered = async (orderId) => {
    try {
      const response = await fetch('/api/logistics/mark-pickup-delivered', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          orderId,
          status: 'entregado_bodega',
          delivery_notes: `Entregado en bodega - ${new Date().toLocaleString()}`
        })
      });

      if (!response.ok) {
        const txt = await response.text();
        console.error('Respuesta error entrega bodega:', txt);
        throw new Error('Error entregando en bodega');
      }

      await response.json();
      // Optimistic UI: remover de la sección "Listos para entrega" inmediatamente
      toast.success('Pedido entregado en bodega');
      // Refrescar datos para confirmar estado con backend
      loadOrders();
    } catch (error) {
      console.error('Error entregando en bodega:', error);
      toast.error(error?.message || 'Error entregando en bodega');
    }
  };

  // Devolver pedido a empaque por modificaciones
  const handleReturnToPacking = async (orderId) => {
    try {
      await orderService.updateOrder(orderId, { status: 'en_empaque' });
      toast.success('Pedido devuelto a empaque para revisión');
      loadOrders(); // Recargar lista
    } catch (error) {
      console.error('Error devolviendo a empaque:', error);
      toast.error('Error al devolver pedido a empaque');
    }
  };

  // Reenviar pedido no_entregado a listo_para_entrega
  const handleResendToDelivery = async (order) => {
    if (!window.confirm(`¿Reenviar pedido ${order.order_number} a Listo para Entrega?`)) return;
    try {
      const response = await api.post('/logistics/resend-to-delivery', { orderId: order.id });
      if (response.data.success) {
        toast.success(`Pedido ${order.order_number} reenviado a entrega`);
        loadOrders();
      }
    } catch (error) {
      console.error('Error reenviando a entrega:', error);
      toast.error(error.response?.data?.message || 'Error al reenviar pedido');
    }
  };

  // Abrir modal de "Completar Reposición de Fabricante"
  const handleOpenRepositionModal = (order) => {
    setReposicionModal({
      open: true,
      order,
      notes: '',
      files: [],
      isSubmitting: false
    });
  };

  // Manejar cambio de archivos
  const handleRepositionFilesChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setReposicionModal(prev => ({
      ...prev,
      files: selectedFiles
    }));
  };

  // Confirmar completar reposición
  const handleConfirmReposition = async () => {
    try {
      const { order, notes, files } = reposicionModal;
      if (!order) return;

      const orderId = order.id || order.order_id;
      if (!orderId) {
        toast.error('Pedido inválido');
        return;
      }

      setReposicionModal(prev => ({ ...prev, isSubmitting: true }));

      await carteraService.completeManufacturerReposition(orderId, { notes, files });

      toast.success('Reposición de fabricante completada exitosamente');

      // Remover de la lista local
      setReposicionOrders(prev => prev.filter(o => (o.id || o.order_id) !== orderId));

      // Cerrar modal
      setReposicionModal({
        open: false,
        order: null,
        notes: '',
        files: [],
        isSubmitting: false
      });
    } catch (e) {
      console.error('Error completando reposición:', e);
      toast.error(e.response?.data?.message || 'Error completando reposición de fabricante');
      setReposicionModal(prev => ({ ...prev, isSubmitting: false }));
    }
  };

  // Manejar pegado de imágenes (Ctrl+V) en el modal de reposición
  useEffect(() => {
    if (!reposicionModal.open) return;

    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      const imageFiles = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile();
          if (file) {
            imageFiles.push(file);
          }
        }
      }

      if (imageFiles.length > 0) {
        setReposicionModal(prev => ({
          ...prev,
          files: [...prev.files, ...imageFiles]
        }));
        toast.success(`${imageFiles.length} imagen(es) pegada(s)`);
      }
    };

    document.addEventListener('paste', handlePaste);
    return () => document.removeEventListener('paste', handlePaste);
  }, [reposicionModal.open]);

  // --- FIN SIIGO/REPOSICION ---de recepción de pago en bodega
  const handleReceivePickupPayment = (order) => {
    // Credit orders use their own modal (WalletValidationModal) — no RC generation
    const pm = String(order.payment_method || '').toLowerCase();
    if (pm === 'cliente_credito' || pm === 'credito') {
      setWalletModal({ isOpen: true, order });
      return;
    }
    setPickupPaymentModal({ isOpen: true, order });
  };

  // Confirmación desde el modal: envía FormData al backend
  /* Recibe pagos múltiples desde el modal */
  const confirmPickupPayment = async ({ orderId, payments, cancelOrder, creditNoteId, creditNoteName }) => {
    const fd = new FormData();
    fd.append('orderId', orderId);

    // Convertimos los metadatos de los pagos a JSON (sin los archivos RAW)
    const paymentsMeta = payments.map((p, idx) => ({
      method: p.method,
      amount: p.amount,
      linkedMovementIds: p.linkedMovementIds, // Array de IDs
      photoIndices: p.files.map((_, fIdx) => `${idx}_${fIdx}`)
    }));
    fd.append('payments', JSON.stringify(paymentsMeta));
    fd.append('notes', 'Recepción múltiple en bodega');

    // Credit Note / Cancel Order data
    if (cancelOrder === true) fd.append('cancelOrder', 'true');
    if (creditNoteId) fd.append('creditNoteId', creditNoteId);
    if (creditNoteName) fd.append('creditNoteName', creditNoteName);

    // Adjuntamos todos los archivos con un nombre que los relacione
    payments.forEach((p, pIdx) => {
      p.files.forEach((file, fIdx) => {
        fd.append(`photos`, file); // El backend procesará todos como Photos
        // Opcionalmente podemos usar un naming convention si el middleware es estricto
        // Pero logisticsController usará req.files
      });
    });

    // mark as in-flight to prevent double submissions
    setReceivingIds(prev => {
      const next = new Set(prev);
      next.add(String(orderId));
      return next;
    });

    try {
      const response = await api.post('/logistics/receive-pickup-payment', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // Handle RC Toast with Link (supports multiple)
      const responseData = response.data;
      const vouchers = responseData?.data?.siigo_vouchers || (responseData?.data?.siigo_voucher ? [responseData.data.siigo_voucher] : []);

      if (vouchers.length > 0) {
        toast((t) => (
          <div className="flex flex-col gap-2 min-w-[280px]">
            <span className="font-semibold text-gray-800 border-b pb-1">
              {vouchers.length > 1 ? 'Múltiples Pagos Registrados' : (vouchers[0].message || 'Pago registrado correctamente')}
            </span>

            <div className="flex flex-col gap-1 max-h-[200px] overflow-y-auto">
              {vouchers.map((v, vIdx) => (
                <div key={vIdx} className="flex flex-col text-xs bg-gray-50 p-2 rounded border border-gray-100">
                  <span className="font-medium text-gray-700">{v.name}</span>
                  <span className="text-gray-500 mb-1">{v.payment_label || v.message}</span>
                  {v.link && (
                    <a
                      href={v.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 font-medium underline hover:text-blue-800 transition-colors flex items-center gap-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Icons.ExternalLink className="w-3 h-3" /> Ver Recibo
                    </a>
                  )}
                </div>
              ))}
            </div>

            <button
              onClick={() => toast.dismiss(t.id)}
              className="text-xs text-gray-500 hover:text-gray-700 self-end mt-1 font-medium px-2 py-1 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
            >
              Cerrar
            </button>
          </div>
        ), {
          duration: 10000, // Longer duration for multiple items
          position: 'top-right',
          style: {
            borderLeft: vouchers.some(v => v.reused) ? '6px solid #F59E0B' : '6px solid #22C55E',
            background: '#FFFFFF',
            padding: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }
        });
      } else {
        toast.success(responseData.message || 'Pagos registrados correctamente');
      }

      // Mark as paid in this session so button is disabled immediately
      setRecentlyPaidOrders(prev => {
        const next = new Set(prev);
        next.add(String(orderId));
        return next;
      });

      // Immediate refresh
      loadOrders();

      // Delayed refresh to ensure RC is fully processed
      setTimeout(() => {
        loadOrders();
      }, 1500);
    } catch (err) {
      console.error('Error registrando pago en bodega:', err);

      // Handle specific error types from backend
      const errorData = err.response?.data;

      if (errorData?.error === 'DUPLICATE_PAYMENT') {
        toast.error(
          <div className="flex flex-col gap-1">
            <strong>⚠️ Pago Duplicado</strong>
            <p className="text-sm">{errorData.message}</p>
            <small className="text-xs text-gray-500">Verifica en Siigo si ya existe un RC para este pedido.</small>
          </div>,
          { duration: 8000 }
        );
        return;
      }

      if (errorData?.error === 'MISSING_INVOICE') {
        toast.error(
          <div className="flex flex-col gap-1">
            <strong>❌ Sin Factura en Siigo</strong>
            <p className="text-sm">{errorData.message}</p>
          </div>,
          { duration: 6000 }
        );
        return;
      }

      if (errorData?.error === 'SIIGO_ERROR') {
        toast.error(
          <div className="flex flex-col gap-1">
            <strong>❌ Error de Siigo</strong>
            <p className="text-sm">{errorData.message}</p>
            {errorData.details && (
              <small className="text-xs text-gray-500 mt-1">
                {JSON.stringify(errorData.details.Errors?.[0]?.Message || errorData.details)}
              </small>
            )}
          </div>,
          { duration: 10000 }
        );
        return;
      }

      // El interceptor de api ya muestra toast si viene message del backend
      if (!err?.response) {
        toast.error('Error registrando pago en bodega');
      }
      throw err;
    } finally {
      // clear in-flight flag
      setReceivingIds(prev => {
        const next = new Set(prev);
        next.delete(String(orderId));
        return next;
      });
    }
  };

  // Marcar pedido como en reparto
  const handleMarkInDelivery = async (orderId, messengerId) => {
    try {
      const response = await fetch('/api/logistics/mark-in-delivery', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          orderId,
          messengerId,
          status: 'en_reparto',
          delivery_notes: `En reparto con mensajero - ${new Date().toLocaleString()}`
        })
      });

      if (!response.ok) {
        throw new Error('Error marcando en reparto');
      }

      const result = await response.json();
      toast.success('Pedido enviado a reparto');

      // Recargar datos
      loadOrders();

    } catch (error) {
      console.error('Error marcando en reparto:', error);
      toast.error('Error marcando en reparto');
    }
  };

  // --- Sync Progress Modal State ---
  const [syncModal, setSyncModal] = useState({
    isOpen: false,
    orderId: null,
    progress: 0,
    message: 'Iniciando...',
    status: 'processing' // processing, success, error
  });

  // Listen for sync progress events
  useEffect(() => {
    if (!socketRef.current) return;

    const handleProgress = (data) => {
      // Solo actualizar si el modal está abierto para este pedido
      if (syncModal.isOpen && String(syncModal.orderId) === String(data.orderId)) {
        setSyncModal(prev => ({
          ...prev,
          progress: data.progress,
          message: data.message
        }));

        if (data.progress >= 100) {
          // Success handling is done in the API response promise, 
          // but we can set status here just in case events arrive first
          setSyncModal(prev => ({ ...prev, status: 'success', message: '¡Completado!' }));
        }
      }
    };

    socketRef.current.on('sync-progress', handleProgress);
    return () => {
      socketRef.current.off('sync-progress', handleProgress);
    };
  }, [syncModal.isOpen, syncModal.orderId]);


  // Recargar un pedido desde SIIGO (estado de carga por pedido + animación)
  const handleReloadFromSiigo = async (orderId) => {
    const key = String(orderId);

    // Open modal immediately
    setSyncModal({
      isOpen: true,
      orderId: orderId,
      progress: 5,
      message: 'Conectando con el servidor...',
      status: 'processing'
    });

    setReloadingIds(prev => {
      const s = new Set(prev);
      s.add(key);
      return s;
    });

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/orders/${orderId}/sync`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();

      if (res.ok) {
        setSyncModal(prev => ({ ...prev, progress: 100, status: 'success', message: '¡Sincronización exitosa!' }));
        toast.success('Sincronización inteligente completada');

        // Brief delay before closing and reloading data
        setTimeout(async () => {
          setSyncModal(prev => ({ ...prev, isOpen: false }));
          await loadOrders();
        }, 1500);

      } else {
        throw new Error(data.message || 'Error al sincronizar');
      }
    } catch (error) {
      console.error('Error recargando desde SIIGO:', error);
      setSyncModal(prev => ({ ...prev, status: 'error', message: error.message || 'Error al sincronizar' }));
      // Keep modal open on error for a moment so user can see it, or close manually?
      // Let's close it after 3 seconds or let user close it. 
      // For now, auto-close after delay to not block flow is safer if we don't implement a close button.
      setTimeout(() => {
        setSyncModal(prev => ({ ...prev, isOpen: false }));
      }, 4000);

      toast.error(error.message || 'Error recargando desde SIIGO');
    } finally {
      setReloadingIds(prev => {
        const s = new Set(prev);
        s.delete(key);
        return s;
      });
    }
  };

  // Marcar pedido como "Gestión especial" usando modal (sin prompt nativo)
  const handleMarkSpecial = (orderId) => {
    try {
      const orderObj = orders.find(o => o.id === orderId) || null;
      setSpecialModal({ isOpen: true, order: orderObj || { id: orderId }, loading: false });
    } catch (error) {
      console.error('Error abriendo modal de gestión especial:', error);
      toast.error('No se pudo abrir el modal de gestión especial');
    }
  };

  // Confirmación de gestión especial desde modal bonito
  const handleConfirmSpecial = async ({ orderId, reason }) => {
    setSpecialModal((prev) => ({ ...prev, loading: true }));
    try {
      await orderService.markSpecial(orderId, { reason: String(reason).trim() });
      toast.success('Pedido marcado como gestión especial');
      setSpecialModal({ isOpen: false, order: null, loading: false });
      await loadOrders();
    } catch (error) {
      console.error('Error marcando como gestión especial:', error);
      toast.error('Error marcando como gestión especial');
    } finally {
      setSpecialModal((prev) => ({ ...prev, loading: false }));
    }
  };

  // Confirmación de registro de pago adhoc desde modal
  const handleConfirmAdhocPayment = async ({ amount, description, notes, evidence }) => {
    try {
      const formData = new FormData();
      formData.append('amount', amount);
      formData.append('description', description);
      if (notes) formData.append('notes', notes);
      if (evidence) formData.append('evidence', evidence);

      await messengerService.registerAdhocPayment(formData);
      toast.success('Recepción de dinero registrada correctamente');
      setAdhocPaymentModal({ isOpen: false });
    } catch (error) {
      console.error('Error registrando recepción de dinero:', error);
      toast.error('Error registrando recepción de dinero');
      throw error;
    }
  };

  // Confirmación genérica para ReasonModal (rechazo / entrega fallida)
  const handleReasonConfirm = async ({ reason }) => {
    const orderId = reasonModal?.order?.id;
    if (!orderId) return;

    setReasonModal(prev => ({ ...prev, loading: true }));
    try {
      const url = reasonModal.mode === 'reject'
        ? `/api/messenger/orders/${orderId}/reject`
        : `/api/messenger/orders/${orderId}/mark-failed`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ reason: String(reason).trim() })
      });

      if (!response.ok) {
        throw new Error('Error enviando motivo');
      }

      const result = await response.json().catch(() => ({}));
      toast.success(
        result?.message || (reasonModal.mode === 'reject'
          ? 'Pedido rechazado y devuelto a logística'
          : 'Entrega marcada como fallida')
      );
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('orders:refresh'));
      }
    } catch (error) {
      console.error('Error procesando motivo:', error);
      toast.error(reasonModal.mode === 'reject' ? 'Error rechazando pedido' : 'Error marcando entrega como fallida');
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('orders:refresh'));
      }
    } finally {
      setReasonModal({ isOpen: false, order: null, mode: 'reject', loading: false });
    }
  };

  // Confirmación de cancelación por cliente (acción rápida)
  const handleConfirmCancelByCustomer = async ({ reason }) => {
    const orderId = cancelModal?.order?.id;
    if (!orderId) return;
    setCancelModal(prev => ({ ...prev, loading: true }));
    try {
      await orderService.cancelByCustomer(orderId, { reason: String(reason || '').trim() });
      toast.success('Pedido cancelado por cliente');
      setCancelModal({ isOpen: false, order: null, loading: false });
      // Refrescar lista
      loadOrders();
      loadReadyOrders?.();
      // Disparar evento global para que otras vistas reaccionen si es necesario
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('orders:refresh'));
      }
    } catch (e) {
      if (!e?.response?.data?.message) {
        toast.error('No se pudo cancelar el pedido');
      }
      setCancelModal(prev => ({ ...prev, loading: false }));
    }
  };

  // Configurar WebSocket para notificaciones en tiempo real
  useEffect(() => {
    // Refresco global que incluye pedidos listos
    const refreshAll = () => {
      if (!modalOpenRef.current) {
        loadOrders();
        loadReadyOrders();
      }
    };

    // Conectar a WebSocket (producción: mismo origen detrás de Nginx)
    // IMPORTANTE: Socket.IO corre en la raíz (/), NO en /api
    const socketBase = window.location.origin;
    console.log('🔌 Attempting socket connection to:', socketBase);
    socketRef.current = io(socketBase, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });

    socketRef.current.on('connect', () => {
      console.log('✅ Socket connected! ID:', socketRef.current.id);
      socketConnectedRef.current = true;
      // Suscribirse a actualizaciones de pedidos
      socketRef.current.emit('join-orders-updates');
    });

    socketRef.current.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error);
    });

    socketRef.current.on('disconnect', (reason) => {
      console.warn('⚠️ Socket disconnected:', reason);
      socketConnectedRef.current = false;
    });

    // Refresco seguro: evita recargar si un modal está abierto (no resetear formularios)
    // Solo usado como fallback para listas secundarias (readyOrders, etc.)
    const safeRefresh = () => {
      if (!modalOpenRef.current) {
        loadOrders(undefined, false); // false = sin spinner de carga
        loadReadyOrders();
      }
    };

    // Actualización incremental: obtiene un solo pedido y actualiza la lista sin recargar
    const incrementalUpsert = async (id) => {
      if (modalOpenRef.current) return; // No actualizar lista si hay modal abierto
      const orderObj = await fetchOrderById(id);
      if (orderObj) upsertOrderInList(orderObj);
    };

    // Escuchar notificaciones de nuevos pedidos creados desde Siigo
    socketRef.current.on('order-created', (data) => {
      console.log('📡 Nuevo pedido creado desde Siigo:', data);
      toast.success(`Nuevo pedido creado: ${data.orderNumber}`);
      // Actualización incremental: solo agregar el nuevo pedido
      if (data.orderId) {
        incrementalUpsert(data.orderId);
      }
    });

    // Escuchar notificaciones de facturas procesadas
    socketRef.current.on('invoice-processed', (data) => {
      console.log('📡 Factura procesada como pedido:', data);
      toast.success(`Factura procesada como pedido ${data.orderNumber}`);
      // Actualización incremental
      if (data.orderId) {
        incrementalUpsert(data.orderId);
      }
    });

    // Escuchar progreso de sincronización RC
    socketRef.current.on('sync-rc-progress', (data) => {
      console.log('📊 [SOCKET] Received sync-rc-progress:', data);
      setSyncRCProgress((prev) => ({
        ...prev,
        [data.orderId]: { progress: data.progress, message: data.message }
      }));
    });

    // Escuchar resultado final de sincronización RC (Async)
    socketRef.current.on('sync-rc-result', (data) => {
      console.log('🎯 [SOCKET] Received sync-rc-result:', data);
      const { orderId, success, message, data: results } = data;

      if (success) {
        setSyncRCProgress((prev) => ({ ...prev, [orderId]: { progress: 100, message: '¡Completado!' } }));
        toast.success(message || 'Sincronización finalizada');
        // Actualización incremental del pedido sincronizado
        incrementalUpsert(orderId);

        // Close modal after delay
        setTimeout(() => {
          setSyncingOrderId(null);
          setSyncRCProgress((prev) => {
            const next = { ...prev };
            delete next[orderId];
            return next;
          });
        }, 1500);
      } else {
        toast.error(message || 'Falló la sincronización');
        setSyncingOrderId(null);
        setSyncRCProgress((prev) => {
          const next = { ...prev };
          delete next[orderId];
          return next;
        });
      }
    });

    // Helpers para tiempo real sin refrescar lista completa
    const isLogisticsViewActive = () =>
      (['logistica', 'admin'].includes(user?.role) && (searchParams.get('view') === 'logistica'));
    const fetchOrderById = async (id) => {
      if (!id) return null;
      try {
        const resp = await fetch(`/api/orders/${id}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!resp.ok) return null;
        const json = await resp.json();
        return json?.data || null;
      } catch { return null; }
    };
    const upsertOrderInList = (orderObj) => {
      const currentView = searchParams.get('view') || '';
      setOrders((prev) => {
        const alreadyExists = prev.some(o => o.id === orderObj.id);
        const orderStatus = String(orderObj?.status || '').toLowerCase();

        // [FIX] View-aware guard: When in cartera view, only allow orders that belong there.
        // Orders in non-cartera statuses should only UPDATE existing entries, not be ADDED as new.
        if (currentView === 'cartera' && !alreadyExists) {
          if (orderStatus !== 'revision_cartera') {
            return prev; // Don't inject non-cartera orders into the cartera view
          }
        }

        // If in cartera view and the order changed status AWAY from revision_cartera, remove it
        if (currentView === 'cartera' && alreadyExists && orderStatus !== 'revision_cartera') {
          return prev.filter(o => o.id !== orderObj.id);
        }

        const without = prev.filter(o => o.id !== orderObj.id);
        const next = [...without, orderObj];
        next.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        return next;
      });
    };
    const removeOrderFromList = (id) => {
      setOrders((prev) => prev.filter(o => o.id !== id));
    };

    // Escuchar cambios de estado — actualización incremental para TODAS las vistas
    socketRef.current.on('order-status-changed', (payload) => {
      try {
        const to = String(payload?.to_status || '').toLowerCase();
        const from = String(payload?.from_status || '').toLowerCase();
        const number = payload?.order_number || payload?.orderId || '';
        const id = Number(payload?.orderId || 0) || null;
        const currentView = searchParams.get('view') || '';

        // Si hay modal abierto, no tocar la lista de pedidos
        if (modalOpenRef.current) {
          // Solo mostrar toast informativo sin refrescar
          if (to === 'en_logistica') {
            toast.success(`🆕 Pedido ${number} enviado a Logística`);
          }
          return;
        }

        // Mostrar toast para transiciones importantes
        if (to === 'en_logistica') {
          toast.success(`🆕 Pedido ${number} enviado a Logística`);
        }

        // Actualización incremental: obtener el pedido actualizado y reemplazar en la lista
        if (to === 'cancelado') {
          removeOrderFromList(id);
        } else if (id) {
          // Para cualquier otra transición, actualizar incrementalmente
          incrementalUpsert(id);
        }

        // Actualizar también la lista de ready-for-delivery si es relevante
        if (['en_reparto', 'entregado', 'listo_para_entrega'].includes(to) ||
          ['en_reparto', 'listo_para_entrega'].includes(from)) {
          loadReadyOrders();
        }
      } catch (e) {
        // no-op
      }
    });

    // NUEVO: Escuchar cambios de campos (delivery_method, amounts, etc.)
    socketRef.current.on('order-updated', (payload) => {
      try {
        const { orderId, order } = payload || {};
        if (!orderId) return;

        // console.log(`🔄 [SOCKET] Order ${orderId} updated`, order);

        // Actualizar globalPendingOrders si este pedido está en la lista
        if (typeof setGlobalPendingOrders === 'function') {
          setGlobalPendingOrders(prev => {
            if (!Array.isArray(prev)) return prev;

            // Buscar si ya existe
            const index = prev.findIndex(o => o && o.id === orderId);
            const debt = order ? (parseFloat(order.total_value || order.total_amount || 0) - parseFloat(order.paid_amount || 0)) : 0;
            const isPending = debt > 100 && order?.status !== 'cancelado';

            if (index >= 0) {
              // El pedido ya está en la lista
              if (isPending && order) {
                // Actualizar con nuevos datos manteniendolo en la lista
                const updated = [...prev];
                updated[index] = { ...updated[index], ...order };
                return updated;
              } else {
                // Ya no cumple el criterio - eliminar
                return prev.filter(o => o && o.id !== orderId);
              }
            } else {
              // El pedido no está en la lista - verificar si debe agregarse
              if (isPending && order) {
                return [order, ...prev];
              }
            }
            return prev;
          });
        }

        // También actualizar en la lista principal si está visible
        // GUARD: Skip list updates while a modal is open to prevent re-renders that close it
        if (order && !modalOpenRef.current) {
          upsertOrderInList(order);
        }
      } catch (err) {
        console.error('Error handling order-updated:', err);
      }
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps



  // Cargar datos cuando cambien los filtros
  useEffect(() => {
    loadOrders(filters);
  }, [filters, loadOrders]);

  // Refrescar pedidos cuando se dispare evento global 'orders:refresh'
  useEffect(() => {
    const handler = () => {
      // Reconsultar la lista con los filtros actuales, sin mostrar spinner de carga
      loadOrders(filters, false);
      loadReadyOrders();
    };
    window.addEventListener('orders:refresh', handler);
    return () => {
      window.removeEventListener('orders:refresh', handler);
    };
  }, [loadOrders, loadReadyOrders]);

  // Auto-actualización para Logística:
  // Preferir WebSocket (tiempo real). Usar polling SOLO como fallback cuando no haya socket activo.
  // Además, pausar cualquier refresh si hay un modal abierto para no resetear formularios.
  useEffect(() => {
    const isLogisticsView = user?.role === 'logistica' || (searchParams.get('view') === 'logistica');
    if (!isLogisticsView) return;

    const shouldBlock = modalOpenRef.current;
    const socketAlive = socketConnectedRef.current;

    let interval;
    const tick = () => {
      if (!shouldBlock && !socketAlive) {
        loadOrders(undefined, false);
        loadReadyOrders();
      }
    };

    // Fallback con menor frecuencia, solo si NO hay socket
    if (!shouldBlock && !socketAlive) {
      interval = setInterval(tick, 30000); // 30s fallback
    }

    const onFocus = () => {
      if (!modalOpenRef.current && !socketConnectedRef.current) {
        loadOrders(undefined, false);
        loadReadyOrders();
      }
    };
    const onVisibility = () => {
      if (!document.hidden && !modalOpenRef.current && !socketConnectedRef.current) {
        loadOrders(undefined, false);
        loadReadyOrders();
      }
    };

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      if (interval) clearInterval(interval);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    user?.role,
    loadOrders,
    logisticsModal.isOpen,
    deliveryModal.isOpen,
    reviewModal.isOpen,
    walletModal.isOpen,
    pickupPaymentModal.isOpen,
    deliveryConfirmationModal.isOpen,
    timelineModal.isOpen,
    deleteSiigoModal.isOpen
  ]);

  // Actualizaciones optimistas por evento 'orders:update' (sin recargar toda la lista)
  useEffect(() => {
    const handler = (e) => {
      const detail = e?.detail || {};
      const id = detail.id ?? detail.orderId;
      const patch = detail.patch || {};
      if (!id) return;
      setOrders((prev) => prev.map((o) => (o.id === id ? { ...o, ...patch } : o)));
    };
    window.addEventListener('orders:update', handler);
    return () => {
      window.removeEventListener('orders:update', handler);
    };
  }, []);

  // Cargar mensajeros solo una vez
  useEffect(() => {
    loadMessengers();
  }, []);

  // Cargar "Pedidos por cerrar en Siigo" cuando estamos en vista Cartera
  useEffect(() => {
    const view = searchParams.get('view');
    if (view === 'cartera') {
      (async () => {
        try {
          const res = await carteraService.getPendingSiigoClose({});
          const list = res?.data || [];
          setSiigoPending(list.filter(o => String(o.payment_method || '').toLowerCase() !== 'cliente_credito'));
        } catch (e) {
          // silencioso
        }
      })();
    }
  }, [searchParams]);

  // fetchPendingReconciliation function and related useEffect hooks removed
  // PendingReconciliationSection component now handles its own data fetching and state

  // Cargar "Pedidos de Reposición" cuando estamos en vista Cartera o Facturación
  useEffect(() => {
    const view = searchParams.get('view');
    if (view === 'cartera' || view === 'facturacion') {
      (async () => {
        try {
          const res = await carteraService.getReposicionOrders({});
          setReposicionOrders(res?.data || []);
        } catch (e) {
          // silencioso
        }
      })();
    }
  }, [searchParams]);

  // Cargar pedidos listos para entrega cuando estamos en vista de logística
  // El control de visualización se maneja ahora correctamente via props en el renderizado

  // Helper para filtrar IDs ocultos (evita reaparición por latencia en render)

  // Solo sincronizar filtros desde URL al montar el componente o cambiar la vista
  useEffect(() => {
    const view = searchParams.get('view');
    const urlStatus = searchParams.get('status') || '';
    const urlSearch = searchParams.get('search') || '';

    // Sincronizar si algo en el URL cambió respecto al estado local
    if (urlStatus !== filters.status || urlSearch !== filters.search) {
      console.log('🔄 Sincronizando estado desde URL:', { urlStatus, urlSearch });
      setFilters(prev => ({
        ...prev,
        status: urlStatus,
        search: urlSearch,
        page: parseInt(searchParams.get('page')) || 1
      }));
    }
  }, [searchParams]); // Dependemos de todo searchParams para ser robustos

  // Actualizar URL con filtros (sin dependencia de searchParams para evitar loops)
  useEffect(() => {
    const params = new URLSearchParams(searchParams);

    // Solo actualizar parámetros relacionados con filtros
    if (filters.search) {
      params.set('search', filters.search);
    } else {
      params.delete('search');
    }

    if (filters.status) {
      params.set('status', filters.status);
    } else {
      params.delete('status');
    }

    if (filters.paymentMethod && !filters.paymentMethod.startsWith('STATUS_')) {
      params.set('paymentMethod', filters.paymentMethod);
    } else {
      params.delete('paymentMethod');
    }

    if (filters.tags) {
      params.set('tags', filters.tags);
    } else {
      params.delete('tags');
    }

    if (filters.dateFrom) {
      params.set('dateFrom', filters.dateFrom);
    } else {
      params.delete('dateFrom');
    }

    if (filters.dateTo) {
      params.set('dateTo', filters.dateTo);
    } else {
      params.delete('dateTo');
    }

    if (filters.page > 1) {
      params.set('page', filters.page.toString());
    } else {
      params.delete('page');
    }

    // Solo actualizar si realmente cambió
    const newParamsString = params.toString();
    const currentParamsString = searchParams.toString();

  }, [filters.search, filters.status, filters.paymentMethod, filters.tags, filters.dateFrom, filters.dateTo, filters.page]); // eslint-disable-line react-hooks/exhaustive-deps

  // Manejar cambios en filtros - memoizado para evitar re-creaciones
  const handleFilterChange = useCallback((key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: key !== 'page' ? 1 : value // Reset page when other filters change
    }));
  }, []);

  // Manejar búsqueda independiente
  const handleSearch = useCallback((searchValue) => {
    setFilters(prev => ({
      ...prev,
      search: searchValue,
      page: 1 // Reset page when search changes
    }));
  }, []);

  // Acciones en lote para logística
  const handleBulkAction = async () => {
    try {
      if (!bulkAction || selectedOrders.length === 0) {
        toast.error('Selecciona una acción y al menos un pedido');
        return;
      }

      const mapping = {
        confirm: 'confirmado',
        prepare: 'en_preparacion',
        ready: 'empacado'
      };
      const newStatus = mapping[bulkAction];
      if (!newStatus) {
        toast.error('Acción no válida');
        return;
      }

      await Promise.all(
        selectedOrders.map((orderId) =>
          orderService.updateOrder(orderId, { status: newStatus })
        )
      );

      toast.success(`Acción aplicada a ${selectedOrders.length} pedidos`);
      setSelectedOrders([]);
      setBulkAction('');
      loadOrders();
    } catch (error) {
      console.error('Error aplicando acción en lote:', error);
      toast.error('Error aplicando acción en lote');
    }
  };

  // Eliminar TODOS los pedidos (solo admin)
  const handleDeleteAllOrders = async () => {
    try {
      if (!window.confirm('Esta acción eliminará TODOS los pedidos y registros relacionados. Esta operación no se puede deshacer. ¿Deseas continuar?')) return;
      const code = window.prompt("Para confirmar, escribe EXACTAMENTE: RESET_ALL_ORDERS");
      if (code !== 'RESET_ALL_ORDERS') {
        toast.error('Confirmación inválida');
        return;
      }
      setResetLoading(true);
      await orderService.deleteAllOrders('RESET_ALL_ORDERS');
      toast.success('Se eliminaron todos los pedidos correctamente');
      setSelectedOrders([]);
      // Recargar lista (quedará vacía)
      loadOrders();
    } catch (error) {
      console.error('Error eliminando todos los pedidos:', error);
      toast.error('No se pudieron eliminar todos los pedidos');
    } finally {
      setResetLoading(false);
    }
  };

  // Manejar cambio de estado de pedido
  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await orderService.updateOrder(orderId, { status: newStatus });
      toast.success('Estado actualizado exitosamente');
      loadOrders();
    } catch (error) {
      console.error('Error actualizando estado:', error);
      toast.error('Error actualizando estado');
    }
  };

  // Manejar asignación de mensajero
  const handleAssignMessenger = async (orderId, messengerId) => {
    try {
      await orderService.assignOrder(orderId, { messengerId });
      toast.success('Pedido asignado exitosamente');
      loadOrders();
    } catch (error) {
      console.error('Error asignando pedido:', error);
      toast.error('Error asignando pedido');
    }
  };

  // Manejar eliminación de pedido SIIGO con modal
  const handleDeleteSiigoOrderConfirm = async (orderId) => {
    try {
      setDeleteSiigoModal(prev => ({ ...prev, loading: true }));

      await orderService.deleteSiigoOrder(orderId);
      toast.success('Pedido eliminado exitosamente. La factura volverá a estar disponible en SIIGO.');

      setDeleteSiigoModal({ isOpen: false, order: null, loading: false });
      loadOrders();
    } catch (error) {
      console.error('Error eliminando pedido SIIGO:', error);
      toast.error('Error eliminando pedido SIIGO');
      setDeleteSiigoModal(prev => ({ ...prev, loading: false }));
    }
  };


  // Abrir modal de "Cerrar en Siigo" (vista Cartera)
  const handleOpenSiigoClose = async (order) => {
    // Determinar método predeterminado basado en el pedido
    const pm = (order.payment_method || '').toLowerCase();
    let defaultMethod = 'otros';

    if (['efectivo', 'contraentrega'].includes(pm)) {
      defaultMethod = 'efectivo';
    } else if (['mercadopago', 'pago_electronico'].includes(pm)) {
      defaultMethod = 'mercadopago';
    } else if (['transferencia', 'nequi', 'bancolombia', 'daviplata'].includes(pm)) {
      defaultMethod = 'transferencia';
    } else if (['reposicion'].includes(pm)) {
      defaultMethod = 'reposicion';
    } else if (['cliente_credito', 'credito'].includes(pm)) {
      defaultMethod = 'credito';
    } else {
      // Si no coincide con ninguno conocido, intentar mapear directo o dejar 'otros'
      if (['efectivo', 'transferencia', 'credito', 'reposicion', 'mercadopago'].includes(pm)) {
        defaultMethod = pm;
      }
    }

    // Cargar tags disponibles
    let availableTags = [];
    try {
      const res = await api.get('/cartera/tags');
      if (res.data && res.data.success) {
        availableTags = res.data.data;
      }
    } catch (e) {
      console.error('Error cargando tags:', e);
    }

    setSiigoCloseModal({
      open: true,
      order,
      method: defaultMethod,
      note: '',
      tags: Array.isArray(order.tags) ? order.tags.filter(t => t && typeof t === 'string' && t.trim() !== '') : [],
      availableTags
    });
  };

  // Confirmar cierre en Siigo (vista Cartera)
  const handleConfirmSiigoClose = async () => {
    try {
      const { order, method, note, tags } = siigoCloseModal;
      if (!order) return;
      const orderId = order.id || order.order_id || order.orderId;
      if (!orderId) {
        toast.error('Pedido inválido');
        return;
      }
      if (!['efectivo', 'transferencia', 'credito', 'reposicion', 'otros', 'mercadopago', 'pago_electronico', 'contraentrega', 'publicidad'].includes(String(method))) {
        toast.error('Selecciona un método válido');
        return;
      }
      await carteraService.closeOrderInSiigo(orderId, { method, note, tags });
      toast.success('Pedido cerrado en Siigo');
      // Remover de la lista local
      setSiigoPending(prev => prev.filter(o => (o.id || o.order_id) !== orderId));
      setSiigoCloseModal({ open: false, order: null, method: 'efectivo', note: '', tags: [], availableTags: [] });
      // Refrescar pedidos (por si cambia chip de estado)
      setSiigoCloseModal({ open: false, order: null, method: 'efectivo', note: '', tags: [], availableTags: [] });
      // Refrescar pedidos (por si cambia chip de estado)
      loadOrders();
      // Refrescar etiquetas (por si se crearon nuevas)
      fetchTags();
    } catch (e) {
      // interceptor maneja errores; mantener modal abierto para corrección
    }
  };

  // Manejar registro de entrega (flujo de mensajero)
  const handleDeliveryRegistration = async (deliveryData) => {
    try {
      // Usar coordenadas capturadas previamente en el modal
      const coords = {
        latitude: deliveryData.latitude || null,
        longitude: deliveryData.longitude || null
      };
      console.log('📍 Using coordinates from modal:', coords);

      // 1) Subir evidencias fotográficas (opcional pero recomendado)
      if (deliveryData.paymentPhoto) {
        const fd1 = new FormData();
        fd1.append('photo', deliveryData.paymentPhoto);
        fd1.append('description', 'Pago recibido');
        if (coords.latitude) {
          fd1.append('gps_latitude', String(coords.latitude));
          fd1.append('gps_longitude', String(coords.longitude));
          console.log('📤 Sending payment photo with GPS:', coords.latitude, coords.longitude);
        }
        await messengerService.uploadEvidence(deliveryData.orderId, fd1);
      }

      if (deliveryData.deliveryPhoto) {
        const fd2 = new FormData();
        fd2.append('photo', deliveryData.deliveryPhoto);
        fd2.append('description', 'Evidencia de entrega');
        if (coords.latitude) {
          fd2.append('gps_latitude', String(coords.latitude));
          fd2.append('gps_longitude', String(coords.longitude));
          console.log('📤 Sending delivery photo with GPS:', coords.latitude, coords.longitude);
        }
        await messengerService.uploadEvidence(deliveryData.orderId, fd2);
      }

      // 2) Completar entrega usando el endpoint específico de mensajeros
      console.log('📦 Processing order registration for ID:', deliveryData.orderId);
      const orderObj = orders.find(o => (o.id || o.order_id) === deliveryData.orderId);
      if (!orderObj) {
        console.error('❌ Order object not found in local state for ID:', deliveryData.orderId);
        toast.error('Error interno: No se encontró la información del pedido');
        return;
      }

      const requiresPayment =
        orderObj?.requires_payment === true ||
        orderObj?.requires_payment === 1 ||
        orderObj?.requires_payment === '1';

      const shouldCollectFee =
        Boolean(orderObj?.should_collect_delivery_fee) ||
        ((orderObj?.shipping_payment_method || '').toLowerCase() === 'contraentrega' &&
          !(orderObj?.delivery_fee_exempt === true || orderObj?.delivery_fee_exempt === 1 || orderObj?.delivery_fee_exempt === '1'));

      const payload = {
        paymentCollected: Number(deliveryData.amountReceived || 0),
        deliveryFeeCollected: Number(deliveryData.deliveryFeeCollected || 0),
        ...(requiresPayment
          ? {
            paymentMethod: (deliveryData.productPaymentMethod || orderObj?.payment_method || 'efectivo'),
            transferAmount: Number(deliveryData.transferAmount || 0),
            transferBank: deliveryData.transferBank || null,
            transferReference: deliveryData.transferReference || null,
            transferDate: deliveryData.transferDate || null
          }
          : {}),
        ...(shouldCollectFee
          ? { deliveryFeePaymentMethod: (deliveryData.deliveryFeePaymentMethod || 'efectivo') }
          : {}),
        deliveryNotes: deliveryData.notes || null,
        latitude: coords.latitude,
        longitude: coords.longitude
      };

      console.log('🚀 Sending completeDelivery request with GPS:', { lat: coords.latitude, lng: coords.longitude });
      await messengerService.completeDelivery(deliveryData.orderId, payload);
      console.log('✅ Delivery registered successfully in backend');

      toast.success('Entrega registrada exitosamente');
      loadOrders();
    } catch (error) {
      console.error('Error registrando entrega:', error);
      toast.error('Error registrando entrega');
      throw error;
    }
  };

  // Manejar revisión de pedido
  const handleOrderReview = async (reviewData) => {
    try {
      const { orderId, action, ...updateData } = reviewData;

      console.log('🔍 HandleOrderReview - Datos recibidos:', { orderId, action, updateData });

      // Mapeo directo de acciones a estados
      const statusMapping = {
        'send_to_wallet': 'revision_cartera',
        'send_to_logistics': 'en_logistica'
      };

      const newStatus = statusMapping[action];

      if (!newStatus) {
        console.error('❌ Acción no reconocida:', action);
        toast.error('Acción no válida: ' + action);
        return;
      }

      console.log('✅ Mapeando acción:', { action, newStatus });
      console.log('📤 Actualizando pedido:', { orderId, newStatus, updateData });

      await orderService.updateOrder(orderId, {
        ...updateData,
        status: newStatus
      });

      const successMessage = newStatus === 'revision_cartera' ? 'enviado a cartera' : 'enviado a logística';
      toast.success(`Pedido ${successMessage} exitosamente`);
      loadOrders();
    } catch (error) {
      console.error('Error procesando revisión:', error);
      toast.error('Error actualizando pedido: ' + error.message);
      throw error;
    }
  };

  // Manejar validación de cartera
  const handleWalletValidation = async (validationData) => {
    try {
      console.log('🏦 HandleWalletValidation - Datos recibidos:', validationData);

      // Detectar si hay archivos en el FormData
      let hasFiles = false;
      let jsonData = {}; // Declarar en scope externo

      if (validationData instanceof FormData) {
        // Verificar si tiene archivos adjuntos
        for (let pair of validationData.entries()) {
          if (pair[1] instanceof File) {
            hasFiles = true;
            break;
          }
        }
      }

      let requestBody;
      let headers = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      };

      if (hasFiles) {
        // Si hay archivos, enviar como FormData (multipart)
        console.log('📎 Enviando con archivos adjuntos (multipart/form-data)');
        requestBody = validationData;
        // No setear Content-Type - el navegador lo hace automáticamente con boundary
      } else {
        // Si NO hay archivos, convertir FormData a JSON
        console.log('📝 Enviando sin archivos (application/json)');
        for (let pair of validationData.entries()) {
          jsonData[pair[0]] = pair[1];
        }
        requestBody = JSON.stringify(jsonData);
        headers['Content-Type'] = 'application/json';
      }

      const response = await fetch('/api/wallet/validate-payment', {
        method: 'POST',
        headers: headers,
        body: requestBody
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error('❌ Error en respuesta de validación:', errorData);
        throw new Error('Error validando pago: ' + response.status);
      }

      const responseData = await response.json();
      console.log('✅ Validación exitosa:', responseData);

      // Determinar el nuevo estado según el tipo de validación
      const validationType = hasFiles
        ? validationData.get('validationType')
        : jsonData.validationType;
      let successMessage = '';

      if (validationType === 'approved') {
        successMessage = responseData.message || 'Pago validado exitosamente';
      } else if (validationType === 'rejected') {
        successMessage = 'Pedido marcado como no apto para logística';
      } else {
        successMessage = 'Validación procesada exitosamente';
      }

      toast.success(successMessage);
      loadOrders();
      return responseData; // Retornar datos para uso en modal (RC info)
    } catch (error) {
      console.error('Error validando pago:', error);
      toast.error('Error validando pago: ' + error.message);
      throw error;
    }
  };

  // Manejar validación POS
  const handlePosValidation = async (data) => {
    try {
      console.log('🏪 HandlePosValidation - Datos:', data);
      const response = await fetch('/api/wallet/validate-pos-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Error validando pago POS');
      }

      toast.success('✅ Venta POS validada exitosamente');
      loadOrders();
    } catch (error) {
      console.error('Error validando POS:', error);
      toast.error(error.message);
    }
  };

  // Manejar procesamiento de logística
  const handleLogisticsProcess = async (processData) => {
    try {
      console.log('🚚 HandleLogisticsProcess - Datos recibidos:', processData);

      const response = await fetch('/api/logistics/process-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(processData)
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error('❌ Error en respuesta de logística:', errorData);
        throw new Error('Error procesando pedido: ' + response.status);
      }

      const responseData = await response.json();
      console.log('✅ Procesamiento de logística exitoso:', responseData);

      toast.success('Pedido procesado y enviado a empaque exitosamente');
      loadOrders();
    } catch (error) {
      console.error('Error procesando pedido:', error);
      toast.error('Error procesando pedido: ' + error.message);
      throw error;
    }
  };

  // Imprimir voucher interno desde la lista
  const handlePrintInternal = async (order) => {
    if (!order) return;
    try {
      // 1. Fetch internal orders
      const response = await internalOrderService.getByParent(order.id);
      if (!response || !response.success || !response.data || response.data.length === 0) {
        toast.error('No se encontraron pedidos internos');
        return;
      }

      const internalOrders = response.data;
      // 2. Aggregate items
      const allItems = internalOrders.flatMap(io => io.items || []);

      // 3. Print
      // Collect IDs
      const internalDisplayNumber = internalOrders.length === 1
        ? internalOrders[0].order_number
        : internalOrders.map(io => io.order_number).join(', ');

      const orderForPrint = {
        ...order,
        order_number: internalDisplayNumber,
        related_external_order: order.order_number
      };

      printInternalVoucher(orderForPrint, allItems);

    } catch (error) {
      console.error('Error imprimiendo voucher interno:', error);
      toast.error('Error al generar voucher');
    }
  };

  // Imprimir voucher de pedido INT-* directamente (mismo que Productos Especiales)
  const handlePrintINTOrder = async (order) => {
    if (!order) return;
    try {
      let itemsToPrint = order.items || [];
      if (itemsToPrint.length === 0) {
        try {
          const fullOrderRes = await internalOrderService.getById(order.id);
          if (fullOrderRes.success && fullOrderRes.data.items) {
            itemsToPrint = fullOrderRes.data.items;
          } else {
            toast('No se encontraron items para este pedido', { icon: '⚠️' });
          }
        } catch (err) {
          console.error('Error fetching INT order details:', err);
          toast('Imprimiendo sin detalle de items', { icon: '⚠️' });
        }
      }
      printInternalVoucher(order, itemsToPrint);
    } catch (e) {
      console.error(e);
      toast.error('Error al imprimir pedido interno');
    }
  };

  // Función para descargar planilla de envío en PDF
  const downloadLocalManifest = async (orderId) => {
    try {
      const params = orderId ? { orderId } : {};
      const resp = await logisticsService.downloadLocalManifest(params);
      const blob = new Blob([resp.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const filename = (() => {
        const cd = resp.headers?.['content-disposition'] || '';
        const m = cd.match(/filename="?([^"]+)"?/i);
        if (m) return m[1];
        const date = new Date().toISOString().slice(0, 10);
        const suffix = orderId ? `pedido_${String(orderId)}` : 'planilla';
        return `planilla-${suffix}-${date}.pdf`;
      })();
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Planilla de envío descargada');
    } catch (e) {
      toast.error(e?.response?.data?.message || 'No se pudo descargar la planilla de envío');
    }
  };

  // Verificar permisos para acciones
  const canChangeStatus = (order, newStatus) => {
    const { role } = user;
    const currentStatus = order.status;

    if (role === 'admin') return true;

    if (role === 'facturador') {
      return currentStatus === 'pendiente' && newStatus === 'confirmado';
    }

    if (role === 'logistica') {
      return ['confirmado', 'en_preparacion', 'listo'].includes(currentStatus);
    }

    if (role === 'mensajero') {
      return currentStatus === 'enviado' && newStatus === 'entregado';
    }

    return false;
  };

  // formatDateShort: Formatea fecha base yyyy-mm-dd o datetime
  // NOTA: Todos los timestamps del backend ya están en hora local Colombia (COT).
  // No se necesita conversión UTC → COT.
  const formatDateShort = useCallback((value) => {
    if (!value) return null;
    const v = typeof value === 'string' ? value.trim() : value;

    // Si viene en formato YYYY-MM-DD...
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) {
      // Solo fecha YYYY-MM-DD (sin hora): cortar directamente
      if (v.length === 10) {
        const [y, m, d] = v.split('-');
        return `${d}/${m}/${y}`;
      }

      // Timestamp MySQL 'YYYY-MM-DD HH:mm:ss' → hora local, extraer fecha directamente
      if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(v)) {
        const [y, m, d] = v.substring(0, 10).split('-');
        return `${d}/${m}/${y}`;
      }

      // ISO con T → extraer la porción de fecha
      if (v.includes('T')) {
        const [y, m, d] = v.substring(0, 10).split('-');
        return `${d}/${m}/${y}`;
      }
    }

    let d;
    if (v instanceof Date) {
      d = new Date(v.getTime());
    } else if (typeof v === 'string') {
      d = new Date(v);
      if (isNaN(d.getTime()) && v.includes(' ')) {
        d = new Date(v.replace(' ', 'T'));
      }
    } else {
      d = new Date(v);
    }

    if (isNaN(d.getTime())) return null;

    return format(d, 'dd/MM/yyyy', { locale: es });
  }, []);

  // Vista especial: Logística gestionando pedidos en Logística (icons +30%, separación +10%)
  const isLogisticsActionsView =
    user?.role === 'logistica' &&
    (searchParams.get('view') === 'logistica') &&
    (searchParams.get('status') === 'en_logistica');

  // Vista especial: Cartera
  const isWalletView =
    (user?.role === 'cartera' || user?.role === 'admin') &&
    (searchParams.get('view') === 'cartera' || filters.status === 'revision_cartera');

  // Solo mostrar skeleton si es la carga inicial y no hay pedidos
  if (loading && orders.length === 0 && !filters.search) {
    return (
      <div className="p-6">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-64 mb-4"></div>
          <div className="h-64 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-gray-50 min-h-screen">


      {/* Header y Filtros */}
      <div className="mb-6 space-y-4">

        {/* ⚠️ Cash Session Guard Banner */}
        {!cashSessionOpen && user?.role !== 'admin' && ['cartera', 'facturacion'].includes(searchParams.get('view')) && (
          <div style={{
            background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
            border: '2px solid #f59e0b',
            borderRadius: '12px',
            padding: '14px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 2px 8px rgba(245, 158, 11, 0.2)'
          }}>
            <Icons.AlertTriangle size={24} color="#d97706" />
            <div style={{ flex: 1 }}>
              <strong style={{ color: '#92400e', fontSize: '14px' }}>Sin caja abierta</strong>
              <p style={{ color: '#a16207', fontSize: '13px', margin: '2px 0 0' }}>
                Debe abrir una caja antes de registrar pagos. Los botones de pago están deshabilitados.
              </p>
            </div>
            <button
              onClick={() => window.open('/cash-box', '_blank')}
              style={{
                background: '#f59e0b',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap'
              }}
            >
              <Icons.Landmark size={16} />
              Ir a Caja
            </button>
          </div>
        )}
        <div>
          <h1 className={`text-xl sm:text-3xl font-bold text-gray-900 ${(user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && (searchParams.get('view') === 'mensajero'))) ? 'hidden sm:block' : ''}`}>
            {filters.status === 'revision_cartera'
              ? 'Pedidos que vienen desde facturación por primera vez'
              : searchParams.get('view') === 'historial_facturacion'
                ? 'Historial de Facturación y Cierres'
                : 'Gestión de Pedidos'}
          </h1>
          <p className={`text-gray-600 mt-2 ${(user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && (searchParams.get('view') === 'mensajero'))) ? 'hidden sm:block' : ''}`}>
            {filters.status === 'revision_cartera'
              ? 'Pedidos enviados por facturación para validación de pago'
              : searchParams.get('view') === 'historial_facturacion'
                ? 'Panel de conciliación, auditoría de recibos de bodega y cierres diarios'
                : 'Administra todos los pedidos del sistema'}
          </p>
        </div>

        <div className="flex items-center space-x-2">
          {user?.role === 'admin' && searchParams.get('view') !== 'historial_facturacion' && (
            <button
              onClick={handleDeleteAllOrders}
              disabled={resetLoading}
              className="px-3 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 flex items-center disabled:opacity-60"
              title="Eliminar todos los pedidos"
            >
              <Icons.Trash2 className="w-5 h-5 mr-2" />
              {resetLoading ? 'Eliminando...' : 'Eliminar todos'}
            </button>
          )}
          {/* Multi-Invoice RC Button (only in cartera view) */}
          {searchParams.get('view') === 'cartera' && (
            <button
              onClick={() => setMultiRcDialogOpen(true)}
              className="btn btn-success flex items-center"
              title="Crear RC para múltiples pedidos del mismo cliente"
            >
              <Icons.FileCheck className="w-4 h-4 mr-2" />
              RC Multi-Pedido
            </button>
          )}
          {/* Abono Parcial Button (cartera view, roles: cartera/admin) */}
          {searchParams.get('view') === 'cartera' && ['cartera', 'admin'].includes(user?.role) && (
            <button
              onClick={() => setAbonoDialogOpen(true)}
              className="btn btn-warning flex items-center"
              title="Registrar abono parcial de un cliente crédito"
            >
              <Icons.Coins className="w-4 h-4 mr-2" />
              Pago Cliente Crédito
            </button>
          )}
          {/* 🆕 Download Cartera Report */}
          {searchParams.get('view') === 'cartera' && ['cartera', 'admin'].includes(user?.role) && (
            <button
              onClick={async () => {
                try {
                  const token = localStorage.getItem('token');
                  const resp = await fetch('/api/cartera/export-report', {
                    headers: { 'Authorization': `Bearer ${token}` }
                  });
                  if (!resp.ok) throw new Error('Error descargando reporte');
                  const blob = await resp.blob();
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `cartera_${new Date().toISOString().slice(0,10)}.csv`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                  toast.success('Reporte de cartera descargado');
                } catch (e) {
                  toast.error('Error descargando reporte de cartera');
                }
              }}
              className="btn flex items-center"
              style={{ background: '#059669', color: 'white' }}
              title="Descargar reporte completo de cartera en CSV"
            >
              <Icons.Download className="w-4 h-4 mr-2" />
              Reporte Cartera
            </button>
          )}
          {user?.role === 'facturador' && (
            <button
              onClick={() => navigate('/orders/create')}
              className="btn btn-primary"
            >
              <Icons.Plus className="w-5 h-5 mr-2" />
              Nuevo Pedido
            </button>
          )}
        </div>
      </div>

      {/* Controles de pestañas para Mensajero (se elimina pestaña "Listos para Entregar") */}
      {(user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && (searchParams.get('view') === 'mensajero'))) && (
        <div className="mb-4 hidden sm:flex items-center justify-between">
          <div>
            <div className="inline-flex rounded-md shadow-sm overflow-hidden border border-gray-300">
              <button
                type="button"
                onClick={() => setMessengerTab('asignados')}
                className="px-4 py-2 text-sm font-medium bg-blue-600 text-white"
              >
                Asignados
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-1 hidden sm:block">
              Mostrando todos tus pedidos asignados
            </p>
          </div>
          {user?.role === 'mensajero' && (
            <button
              onClick={() => setAdhocPaymentModal({ isOpen: true })}
              className="btn btn-success flex items-center shadow-lg hover:shadow-xl transition-shadow"
            >
              <Icons.Wallet className="w-5 h-5 mr-2" />
              <span className="font-semibold">Dinero de Clientes a Crédito</span>
            </button>
          )}
        </div>
      )}

      {/* Botón flotante para móvil (solo mensajero) */}
      {user?.role === 'mensajero' && (
        <button
          onClick={() => setAdhocPaymentModal({ isOpen: true })}
          className="sm:hidden fixed bottom-20 right-4 z-40 bg-green-600 hover:bg-green-700 text-white rounded-full p-4 shadow-2xl flex items-center justify-center transition-all active:scale-95"
          style={{ width: '64px', height: '64px' }}
        >
          <Icons.Wallet className="w-7 h-7" />
        </button>
      )}

      {/* Botón superior para móvil (solo mensajero) */}
      {user?.role === 'mensajero' && (
        <div className="sm:hidden mb-2 px-1">
          <button
            onClick={() => setAdhocPaymentModal({ isOpen: true })}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md flex items-center justify-center transition-colors"
          >
            <Icons.Wallet className="w-5 h-5 mr-2" />
            <span>Dinero de Clientes a Crédito</span>
          </button>
        </div>
      )}

      {isMessengerPerspective && (
        <div className="mb-3">
          <IsolatedSearchInput
            onSearch={handleSearch}
            initialValue={filters.search}
            placeholder="Nombre de cliente o código de pedido..."
            className="w-full h-11 text-sm font-bold px-4 py-2 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
          />
        </div>
      )}
      {!isMessengerPerspective && (
        <div className="card mb-4">
          <div className="card-content p-3 sm:p-4">
            <div className="grid grid-cols-3 gap-1.5 sm:grid-cols-6">
              {/* Búsqueda */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Buscar
                </label>
                <IsolatedSearchInput
                  ref={searchInputRef}
                  onSearch={handleSearch}
                  initialValue={filters.search}
                  placeholder="Cliente/Tel..."
                  className="w-full h-9 sm:h-10 text-xs sm:text-sm px-1.5 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Estado */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Estado
                </label>
                <CustomDropdown
                  value={filters.status}
                  onChange={(value) => handleFilterChange('status', value)}
                  options={[
                    { value: '', label: 'Todos' },
                    { value: 'pendiente_por_facturacion', label: 'Pend. Facturación' },
                    { value: 'revision_cartera', label: 'Revisión Cartera' },
                    { value: 'en_logistica', label: 'En Logística' },
                    { value: 'pendiente_empaque', label: 'Pend. Empaque' },
                    { value: 'en_empaque', label: 'En Empaque' },
                    { value: 'en_preparacion', label: 'En Preparación' },
                    { value: 'empacado', label: 'Empacado' },
                    { value: 'listo_para_recoger', label: 'Listo Recoger' },
                    { value: 'en_reparto', label: 'En Reparto' },
                    { value: 'pendiente_entrega', label: 'Pend. Entrega' },
                    { value: 'listo_para_entrega_pendientes', label: 'Listo Entregar' },
                    { value: 'entregados', label: 'Entregados' },
                    { value: 'entregado_transportadora', label: 'Entr. Transportadora' },
                    { value: 'entregado_cliente', label: 'Entr. Cliente' },
                    { value: 'entregado_bodega', label: 'Entr. Bodega' },
                    { value: 'no_entregado', label: 'No Entregado' },
                    { value: 'gestion_especial', label: 'Gestión Esp.' },
                    { value: 'cancelado', label: 'Cancelado' }
                  ]}
                  placeholder="Estado"
                  className="w-full h-9 sm:h-10 text-xs sm:text-sm px-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Forma de Pago */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Pago
                </label>
                <CustomDropdown
                  value={filters.paymentMethod}
                  onChange={(value) => handleFilterChange('paymentMethod', value)}
                  options={[
                    { value: '', label: 'Todos' },
                    { value: 'STATUS_PAGADO', label: '✅ Pagado' },
                    { value: 'STATUS_COBRAR', label: '💰 Cobrar' },
                    { value: 'credito', label: 'Crédito' },
                    { value: 'efectivo', label: 'Efectivo' },
                    { value: 'mercadopago', label: 'Mercado Pago' },
                    { value: 'pago_electronico', label: 'Pago Elec.' },
                    { value: 'transferencia', label: 'Transferencia' },
                    { value: 'contraentrega', label: 'Contraentrega' },
                    { value: 'publicidad', label: 'Publicidad' },
                    { value: 'reposicion', label: 'Reposición' }
                  ]}
                  placeholder="Pago"
                  className="w-full h-9 sm:h-10 text-xs sm:text-sm px-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Etiquetas */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Etiquetas
                </label>
                <CustomDropdown
                  value={filters.tags}
                  onChange={(value) => handleFilterChange('tags', value)}
                  options={[
                    { value: '', label: 'Todas' },
                    ...availableTags.map(tag => ({ value: tag, label: tag }))
                  ]}
                  placeholder="Etiquetas"
                  className="w-full h-9 sm:h-10 px-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
                />
              </div>

              {/* Fecha desde */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Desde
                </label>
                <input
                  type="date"
                  className="w-full h-9 sm:h-10 text-xs sm:text-sm px-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filters.dateFrom}
                  onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
                />
              </div>

              {/* Fecha hasta */}
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-0.5">
                  Hasta
                </label>
                <input
                  type="date"
                  className="w-full h-9 sm:h-10 text-xs sm:text-sm px-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={filters.dateTo}
                  onChange={(e) => handleFilterChange('dateTo', e.target.value)}
                />
              </div>
            </div>

            {/* Acciones en lote - Solo para logística */}
            {selectedOrders.length > 0 && user?.role === 'logistica' && (
              <div className="mt-4 flex items-center space-x-3 p-3 bg-blue-50 rounded-lg">
                <span className="text-sm font-medium text-blue-800">
                  {selectedOrders.length} pedidos seleccionados
                </span>
                <select
                  value={bulkAction}
                  onChange={(e) => setBulkAction(e.target.value)}
                  className="px-3 py-1 border border-blue-300 rounded-md text-sm"
                >
                  <option value="">Seleccionar acción</option>
                  <option value="confirm">Confirmar</option>
                  <option value="prepare">Poner en preparación</option>
                  <option value="ready">Marcar como listo</option>
                </select>
                <button
                  onClick={handleBulkAction}
                  disabled={!bulkAction}
                  className="btn btn-primary btn-sm"
                >
                  Aplicar
                </button>
                <button
                  onClick={() => setSelectedOrders([])}
                  className="btn btn-secondary btn-sm"
                >
                  Cancelar
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {(['admin', 'logistica'].includes(user?.role) &&
        (isLogisticsActionsView || filters.status === 'en_logistica') &&
        searchParams.get('view') !== 'historial_facturacion' &&
        orders.length > 0) && (() => {
          const deliveryCounts = orders.reduce((acc, o) => {
            const dm = o.delivery_method || 'domicilio';
            acc[dm] = (acc[dm] || 0) + 1;
            return acc;
          }, {});
          const total = orders.length;
          const recogeBodega = deliveryCounts['recoge_bodega'] || 0;
          const recogePosterior = deliveryCounts['recoge_posterior'] || 0;
          const domicilio = deliveryCounts['domicilio'] || 0;
          const nacional = deliveryCounts['nacional'] || 0;
          const msgUrbana = deliveryCounts['mensajeria_urbana'] || 0;

          return (
            <div className="mb-3 flex gap-2 overflow-x-auto">
              {/* Total */}
              <div className="bg-white rounded-lg border-2 border-purple-200 px-3 py-2 flex items-center gap-2 min-w-0 flex-1">
                <Icons.Package className="w-4 h-4 text-purple-600 flex-shrink-0" />
                <span className="text-lg font-bold text-purple-700">{total}</span>
                <span className="text-[11px] text-gray-500 font-medium truncate">Por Gestionar</span>
              </div>

              {/* Domicilio */}
              <div className={`rounded-lg border px-3 py-2 flex items-center gap-2 min-w-0 flex-1 ${domicilio > 0 ? 'bg-white border-blue-200' : 'bg-gray-50 border-gray-200'}`}>
                <Icons.Truck className={`w-4 h-4 flex-shrink-0 ${domicilio > 0 ? 'text-blue-600' : 'text-gray-400'}`} />
                <span className={`text-lg font-bold ${domicilio > 0 ? 'text-blue-700' : 'text-gray-400'}`}>{domicilio}</span>
                <span className={`text-[11px] font-medium truncate ${domicilio > 0 ? 'text-gray-500' : 'text-gray-400'}`}>Domicilio</span>
              </div>

              {/* Nacional */}
              <div className={`rounded-lg border px-3 py-2 flex items-center gap-2 min-w-0 flex-1 ${nacional > 0 ? 'bg-white border-indigo-200' : 'bg-gray-50 border-gray-200'}`}>
                <Icons.Globe className={`w-4 h-4 flex-shrink-0 ${nacional > 0 ? 'text-indigo-600' : 'text-gray-400'}`} />
                <span className={`text-lg font-bold ${nacional > 0 ? 'text-indigo-700' : 'text-gray-400'}`}>{nacional}</span>
                <span className={`text-[11px] font-medium truncate ${nacional > 0 ? 'text-gray-500' : 'text-gray-400'}`}>Nacional</span>
              </div>

              {/* Mensajería Urbana */}
              <div className={`rounded-lg border px-3 py-2 flex items-center gap-2 min-w-0 flex-1 ${msgUrbana > 0 ? 'bg-white border-teal-200' : 'bg-gray-50 border-gray-200'}`}>
                <Icons.Bike className={`w-4 h-4 flex-shrink-0 ${msgUrbana > 0 ? 'text-teal-600' : 'text-gray-400'}`} />
                <span className={`text-lg font-bold ${msgUrbana > 0 ? 'text-teal-700' : 'text-gray-400'}`}>{msgUrbana}</span>
                <span className={`text-[11px] font-medium truncate ${msgUrbana > 0 ? 'text-gray-500' : 'text-gray-400'}`}>Msg. Urbana</span>
              </div>

              {/* Recoge en Bodega - DESTACADO */}
              <div className={`rounded-lg border-2 px-3 py-2 flex items-center gap-2 min-w-0 flex-1 ${recogeBodega > 0 ? 'bg-amber-50 border-amber-400 ring-1 ring-amber-300' : 'bg-gray-50 border-gray-200'}`}>
                <Icons.Store className={`w-4 h-4 flex-shrink-0 ${recogeBodega > 0 ? 'text-amber-700' : 'text-gray-400'}`} />
                <span className={`text-lg font-bold ${recogeBodega > 0 ? 'text-amber-700' : 'text-gray-400'}`}>{recogeBodega}</span>
                <span className={`text-[11px] font-semibold truncate ${recogeBodega > 0 ? 'text-amber-600' : 'text-gray-400'}`}>Recoge Bodega</span>
              </div>

              {/* Cliente en Punto - DESTACADO */}
              <div className={`rounded-lg border-2 px-3 py-2 flex items-center gap-2 min-w-0 flex-1 ${recogePosterior > 0 ? 'bg-orange-50 border-orange-400 ring-1 ring-orange-300' : 'bg-gray-50 border-gray-200'}`}>
                <Icons.MapPin className={`w-4 h-4 flex-shrink-0 ${recogePosterior > 0 ? 'text-orange-700' : 'text-gray-400'}`} />
                <span className={`text-lg font-bold ${recogePosterior > 0 ? 'text-orange-700' : 'text-gray-400'}`}>{recogePosterior}</span>
                <span className={`text-[11px] font-semibold truncate ${recogePosterior > 0 ? 'text-orange-600' : 'text-gray-400'}`}>Cliente en Punto</span>
              </div>
            </div>
          );
        })()}

      {(['admin', 'logistica'].includes(user?.role) &&
        !isMessengerPerspective &&
        searchParams.get('view') !== 'historial_facturacion' &&
        !['cartera', 'facturacion', 'todos', 'logistica', ''].includes(searchParams.get('view') || '')) && (
          <div className="mb-8 space-y-6 !hidden sm:!block">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Icons.PackageCheck className="w-5 h-5 text-green-600" />
              Pedidos Listos para Entrega ({readyOrders.length})
            </h2>

            {Object.entries(groupedReadyOrders).map(([groupName, groupOrders]) => (
              <div key={groupName} className="card overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
                  <h3 className="font-medium text-gray-800 flex items-center gap-2">
                    {groupName === 'Recoge en Bodega' ? <Icons.Store className="w-5 h-5" /> :
                      groupName === 'Sin Asignar' ? <Icons.HelpCircle className="w-5 h-5" /> :
                        <Icons.Truck className="w-5 h-5" />}
                    {groupName}
                    <span className="ml-2 text-xs bg-white border border-gray-300 px-2 py-0.5 rounded-full text-gray-600">
                      {groupOrders.length}
                    </span>
                  </h3>
                </div>

                <ReadyForDeliveryGroupTable
                  orders={groupOrders}
                  columns={[
                    { header: 'Pedido', render: (o) => <span className="font-medium text-blue-600 cursor-pointer" onClick={() => navigate(`/orders/${o.id}`)}>{o.order_number}</span> },
                    {
                      header: 'Cliente', render: (o) => (
                        <div className="flex flex-col">
                          <span className="font-medium text-gray-900">{o.customer_name || o.client_name}</span>
                          <span className="text-xs text-gray-500">{o.city || o.customer_city}</span>
                        </div>
                      )
                    },
                    {
                      header: 'Pago', render: (o) => {
                        const { productDue } = computeCollectionAmounts(o);
                        const hasPay = hasOrderPayment(o) || isPaidUi(o);
                        if (isCreditOrder(o)) return <span className="badge badge-blue">Crédito</span>;
                        if (productDue <= 0 || hasPay) return <span className="badge badge-green">Pagado/Sin Cobro</span>;
                        return <span className="badge badge-red">Cobrar: ${formatCurrencyCOP(productDue)}</span>;
                      }
                    },
                    {
                      header: 'Envío', render: (o) => (
                        <span className={`badge ${hasShippingFeePaid(o) ? 'badge-blue' : 'badge-orange'}`}>
                          {hasShippingFeePaid(o) ? 'Flete Pagado' : 'Cobrar Flete'}
                        </span>
                      )
                    },
                    { header: 'Fecha', render: (o) => <span className="text-xs text-gray-500">{formatDateShort(o.created_at)}</span> }
                  ]}
                  getActions={(order) => (
                    <div className="flex justify-end gap-2">
                      {/* Acciones contextuales según el grupo */}
                      {groupName === 'Recoge en Bodega' && (
                        <>
                          <button
                            onClick={() => setSpecialModal({ isOpen: true, order, loading: false })}
                            className="text-red-600 hover:text-red-900 w-5 h-5 flex items-center justify-center"
                            title="Marcar gestión especial (sale del flujo)"
                          >
                            <Icons.Flag className="w-5 h-5" />
                          </button>
                          {!!order.is_modified_after_packing ? (
                            <button
                              onClick={() => handleReturnToPacking(order.id)}
                              className="px-2 py-1 text-xs font-bold text-white bg-red-600 hover:bg-red-700 rounded flex items-center gap-1 animate-pulse shadow-sm"
                              title="Este pedido fue modificado en SIIGO después de empacado. Debe volver a empaque para revisión."
                            >
                              <Icons.AlertTriangle className="w-3 h-3" />
                              Devolver a Empaque
                            </button>
                          ) : (
                            <button
                              onClick={() => handleMarkPickupDelivered(order.id)}
                              className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                              title="Entregar"
                            >
                              <Icons.CheckCircle className="w-5 h-5" />
                            </button>
                          )}
                        </>
                      )}

                      {(order.delivery_method !== 'recoge_bodega' && !order.assigned_messenger_id && !order.carrier_name) && (
                        <button
                          onClick={() => setLogisticsModal({ isOpen: true, order })}
                          className="p-1 text-purple-600 hover:bg-purple-50 rounded"
                          title="Asignar Logística"
                        >
                          <Icons.Truck className="w-5 h-5" />
                        </button>
                      )}

                      {/* Modificar Envío (Facturador/Admin) */}
                      {(user?.role === 'admin' || user?.role === 'facturador') && !['entregado_cliente', 'entregado_transportadora', 'cancelado'].includes(String(order.status || '').toLowerCase()) && (
                        <button
                          onClick={() => setShippingModal({ isOpen: true, order })}
                          className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                          title="Modificar Envío"
                        >
                          <Icons.Settings className="w-5 h-5" />
                        </button>
                      )}

                      {/* Para mensajeros asignados, permitir marcar en reparto */}
                      {order.assigned_messenger_id && (
                        <button
                          onClick={() => handleMarkInDelivery(order.id, order.assigned_messenger_id)}
                          className="p-1 text-indigo-600 hover:bg-indigo-50 rounded"
                          title="Enviar a Reparto"
                        >
                          <Icons.Send className="w-5 h-5" />
                        </button>
                      )}

                      {/* Para transportadoras, permitir marcar entregado a transportadora si aún no lo está */}
                      {order.carrier_name && order.status !== 'entregado_transportadora' && (
                        <button
                          onClick={() => handleMarkAsDeliveredToCarrier(order.id, order.carrier_name)}
                          className="p-1 text-indigo-600 hover:bg-indigo-50 rounded"
                          title="Marcar Entregado a Transportadora"
                        >
                          <Icons.CheckSquare className="w-5 h-5" />
                        </button>
                      )}
                    </div>
                  )}
                />
              </div>
            ))}
          </div>
        )
      }

      {/* VARIABLES DE VISIBILIDAD DE VISTAS */}
      {/* Lista de pedidos MÓVIL (para Mensajero y Cartera) - Siempre disponible en móvil */}
      <div className="sm:hidden">
        {showMobileCards ? (
          <div className="card mb-4">
            <div className="space-y-3">
              {displayedOrders.map((order) => (
                <div key={order.id} className="bg-white rounded-lg border border-gray-200 shadow-sm relative overflow-hidden">
                  {/* Barra lateral de color según estado */}
                  <div className={`absolute left-0 top-0 bottom-0 w-1 ${getStatusColor(order.status).replace('bg-', 'bg-').replace('text-', 'bg-').split(' ')[0]}`}></div>

                  <div className="p-3 pl-4">
                    <div className="flex items-start justify-between gap-2">

                      {/* Col 1: Información Principal */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-1">
                          <span className="text-[13px] font-bold text-gray-900">#{order.order_number}</span>
                          <span className="text-[11px] text-gray-500">{formatDateShort(order.created_at)}</span>
                        </div>

                        {/* Cliente */}
                        <div className="text-[13px] text-gray-800 font-medium truncate">
                          {order.customer_name || order.client_name}
                        </div>
                        <div className="text-[11px] text-gray-500 truncate mb-2">
                          {order.city || order.customer_city || getOrderCity(order)}
                        </div>

                        {/* ESTADO + MONTO (Para mensajeros mostrar Saldo a Cobrar) */}
                        <div className="flex flex-wrap items-center gap-2 mb-2">
                          <span className={`px-2 py-0.5 inline-flex text-[10px] uppercase font-bold rounded-full ${getStatusColor(order.status, order)}`}>
                            {getStatusLabel(order.status, order)}
                          </span>
                          {(() => {
                            const { totalDue } = computeCollectionAmounts(order);
                            const isMessenger = user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && searchParams.get('view') === 'mensajero');

                            if (isMessenger) {
                              if (totalDue > 0) {
                                return (
                                  <span className="text-[13px] font-bold text-orange-600 bg-orange-50 px-2 py-0.5 rounded border border-orange-100 animate-pulse">
                                    POR COBRAR: {formatCurrencyCOP(totalDue)}
                                  </span>
                                );
                              } else if (isDeliveredUi(order)) {
                                return (
                                  <span className="text-[13px] font-bold text-gray-900">
                                    {formatCurrencyCOP(getOrderAmount(order))}
                                  </span>
                                );
                              } else {
                                return (
                                  <span className="text-[13px] font-bold text-green-700 bg-green-50 px-2 py-0.5 rounded border border-green-100">
                                    PAGADO / ENTREGAR
                                  </span>
                                );
                              }
                            }

                            return (
                              <span className="text-[13px] font-bold text-gray-900">
                                {formatCurrencyCOP(getOrderAmount(order))}
                              </span>
                            );
                          })()}
                        </div>

                        {/* CARTERA: FORMA DE PAGO DESTACADA */}
                        {((searchParams.get('view') === 'cartera' || filters.status === 'revision_cartera')) && (
                          <div className="mt-2 bg-blue-50 p-2 rounded border border-blue-100">
                            <div className="flex flex-col gap-1">
                              <div className="flex justify-between items-center">
                                <span className="text-[11px] font-semibold text-blue-800 uppercase tracking-wide">Forma de Pago</span>
                                {/* Badges de estado de pago */}
                                <div className="flex gap-1">
                                  {(() => {
                                    const { productDue } = computeCollectionAmounts(order);
                                    const isPickup = String(order.delivery_method || '').toLowerCase().includes('bodega');
                                    if (isCreditOrder(order)) return <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-100 text-purple-700">CRÉDITO</span>;
                                    if (productDue <= 0 || hasOrderPayment(order)) return <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-green-100 text-green-700">PAGADO</span>;
                                    if (isPickup && productDue > 0) return <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-600 text-white animate-pulse">PENDIENTE PAGO</span>;
                                    return <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-100 text-red-700">PENDIENTE</span>;
                                  })()}
                                </div>
                              </div>
                              <div className="text-[13px] font-bold text-gray-800">
                                {getPaymentMethodLabel(order.payment_method)}
                              </div>
                              {/* Detalle Pago Electrónico si existe */}
                              {order.electronic_payment_type && (
                                <div className="text-[11px] text-gray-600">
                                  Tipo: {order.electronic_payment_type}
                                </div>
                              )}
                              {/* Detalle Flete */}
                              <div className="mt-1 pt-1 border-t border-blue-200 flex justify-between items-center">
                                <span className="text-[11px] text-gray-600">Envío:</span>
                                <span className={`text-[10px] font-bold ${hasShippingFeePaid(order) ? 'text-green-600' : 'text-orange-600'}`}>
                                  {hasShippingFeePaid(order) ? 'FLETE PAGADO' : 'COBRAR FLETE'}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Tags display (mobile) */}
                        {(() => {
                          let tags = [];
                          try {
                            if (typeof order.tags === 'string' && order.tags.trim()) {
                              tags = JSON.parse(order.tags);
                            } else if (Array.isArray(order.tags)) {
                              tags = order.tags;
                            }
                          } catch (e) { }
                          if (Array.isArray(tags) && tags.length > 0) {
                            return (
                              <div className="flex flex-wrap gap-1 mt-2">
                                {tags.map((tag, idx) => (
                                  <span key={idx} className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-600 border border-gray-200">
                                    {tag}
                                  </span>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>

                      {/* Col 2: Acciones (Vertical) */}
                      <div className="flex flex-col gap-2 pl-2 border-l border-gray-100 ml-1">
                        <button type="button" onClick={() => navigate(`/orders/${order.id}`)} className="p-2 text-blue-600 bg-blue-50 rounded-full active:bg-blue-100">
                          <Icons.Eye className="w-5 h-5" />
                        </button>
                        <button type="button" onClick={() => setTimelineModal({ isOpen: true, order })} className="p-2 text-gray-600 bg-gray-50 rounded-full active:bg-gray-100">
                          <Icons.History className="w-5 h-5" />
                        </button>

                        {/* Ver Factura (Cartera) */}
                        {((searchParams.get('view') === 'cartera' || filters.status === 'revision_cartera') && order.siigo_public_url) && (
                          <a
                            href={order.siigo_public_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2 text-purple-600 bg-purple-50 rounded-full active:bg-purple-100"
                            title="Ver factura"
                          >
                            <Icons.FileText className="w-5 h-5" />
                          </a>
                        )}

                        {/* Cartera Actions (Matches Desktop) */}
                        {(['admin', 'cartera'].includes(user?.role) && (order.status === 'revision_cartera' || (order.status === 'listo_para_entrega' && (order.requires_payment || String(order.payment_method || '').toLowerCase().includes('transferencia'))))) && (
                          order.sale_channel === 'pos' ? (
                            <button
                              onClick={() => setPosModal({ isOpen: true, order })}
                              className="p-2 text-blue-600 bg-blue-50 rounded-full active:bg-blue-100"
                              title="Validar Venta POS"
                            >
                              <Icons.Store className="w-5 h-5" />
                            </button>
                          ) : (
                            // UNIFICADO: Todos los pedidos de Cartera usan PickupPaymentModal
                            <button
                              onClick={() => handleReceivePickupPayment(order)}
                              className="p-2 text-green-600 bg-green-50 rounded-full active:bg-green-100"
                              title="Aplicar Pago"
                            >
                              <Icons.DollarSign className="w-5 h-5" />
                            </button>
                          )
                        )}

                        {/* Upload Evidence (Matches Desktop) */}
                        {(['admin', 'cartera', 'logistica'].includes(user?.role) && (order.is_pending_payment_evidence === true || order.is_pending_payment_evidence === 1)) && (
                          <button
                            onClick={() => setUploadEvidenceModal({ open: true, order, file: null })}
                            className="p-2 text-blue-600 bg-blue-50 rounded-full active:bg-blue-100"
                            title="Subir comprobante"
                          >
                            <Icons.Upload className="w-5 h-5" />
                          </button>
                        )}
                        {/* Acciones específicas de mensajero */}
                        {((user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && searchParams.get('view') === 'mensajero'))) && order.assigned_messenger_id === user.id && (
                          <>
                            {order.messenger_status === 'assigned' && !['entregado', 'entregado_cliente'].includes(order.status) && (
                              <button type="button" onClick={() => handleAcceptOrder(order.id)} className="p-2 text-green-600 bg-green-50 rounded-full">
                                <Icons.Check className="w-5 h-5" />
                              </button>
                            )}
                            {order.messenger_status === 'accepted' && (
                              <button type="button" onClick={() => setDeliveryConfirmationModal({ isOpen: true, order })} className="p-2 text-blue-600 bg-blue-50 rounded-full">
                                <Icons.Play className="w-5 h-5" />
                              </button>
                            )}
                            {order.messenger_status === 'in_delivery' && (
                              <button type="button" onClick={() => setDeliveryModal({ isOpen: true, order })} className="p-2 text-purple-600 bg-purple-50 rounded-full">
                                <Icons.Package className="w-5 h-5" />
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Footer: Dirección (solo si no es Cartera o si se desea mostrar) */}
                    {!((searchParams.get('view') === 'cartera' || filters.status === 'revision_cartera')) && (
                      <div className="mt-2 text-[11px] text-gray-500 border-t border-gray-100 pt-2 truncate">
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${getOrderAddress(order)}, ${getOrderCity(order)}, Colombia`)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center hover:text-blue-600 active:text-blue-800"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Icons.MapPin className="w-3 h-3 inline mr-1 flex-shrink-0" />
                          <span className="truncate">{getOrderAddress(order) || 'Sin dirección'}</span>
                        </a>
                      </div>
                    )}

                  </div>
                </div>
              ))}
              {displayedOrders.length === 0 && (
                <div className="p-8 text-center bg-gray-50 rounded-lg border border-dashed border-gray-300">
                  <Icons.Inbox className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                  <p className="text-gray-500 text-sm">No se encontraron pedidos.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="card mb-4 p-8 text-center bg-gray-50 border-2 border-dashed border-gray-200 rounded-xl">
            <Icons.Layout className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-500 font-medium">Usa la vista de escritorio para gestión avanzada o selecciona una vista móvil (Mensajero/Cartera).</p>
          </div>
        )}
      </div>

      {/* Vista de tabla (desktop/tablet) - Siempre oculta en móvil */}
      {searchParams.get('view') !== 'historial_facturacion' && (
        <div className="!hidden sm:!block">
        <div className="card">
          {/* Compact table for better fit */}
          <div className="card-content p-0">
            <div className="overflow-x-auto">
              {/* Apply compact styles specifically for logistics view */}
              <table className={`w-full table-fixed divide-y divide-gray-200 ${searchParams.get('view') === 'logistica' ? 'logistics-compact-table' : ''}`}>
                <thead className="bg-gray-700">
                  <tr>
                    {user?.role === 'logistica' && (
                      <th className="px-2 py-3 text-left w-[3%]">
                        <input
                          type="checkbox"
                          checked={selectedOrders.length === orders.length && orders.length > 0}
                          onChange={() => {
                            if (selectedOrders.length === orders.length) {
                              setSelectedOrders([]);
                            } else {
                              setSelectedOrders(orders.map(order => order.id));
                            }
                          }}
                          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                      </th>
                    )}
                    {searchParams.get('view') === 'cartera' && (
                      <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-12">
                        #
                      </th>
                    )}
                    <th className="px-1 py-2 text-left text-xs font-semibold text-white uppercase tracking-wider w-[7%] border-r border-gray-600">
                      Pedido
                    </th>
                    <th className="px-1 py-2 text-left text-xs font-semibold text-white uppercase tracking-wider w-[10%] border-r border-gray-600">
                      Cliente
                    </th>
                    <th className="px-1 py-2 text-left text-xs font-semibold text-white uppercase tracking-wider w-[8%] border-r border-gray-600">
                      Estado
                    </th>
                    <th className="px-1 py-2 text-right text-xs font-semibold text-white uppercase tracking-wider w-[7%] border-r border-gray-600">
                      Monto
                    </th>
                    <th className="px-1 py-2 text-left text-xs font-semibold text-white uppercase tracking-wider w-[9%] border-r border-gray-600">
                      Pago
                    </th>
                    <th className="px-1 py-2 text-center text-xs font-semibold text-white uppercase tracking-wider w-[9%] border-r border-gray-600">
                      RC
                    </th>
                    {user?.role === 'mensajero' && (
                      <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[10%]">
                        Método Envío
                      </th>
                    )}
                    {searchParams.get('view') === 'logistica' && (
                      <>
                        <th className="px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[6%]">
                          M. Pago
                        </th>
                        <th className="px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[6%]">
                          P. Elect.
                        </th>
                      </>
                    )}
                    {['admin', 'logistica', 'mensajero', 'facturador', 'cartera'].includes(user?.role) && (
                      <th className="px-2 py-2 text-center text-xs font-semibold text-white uppercase tracking-wider w-[8%] border-r border-gray-600">
                        Envío
                      </th>
                    )}
                    {['logistica', 'facturacion', 'cartera'].includes(searchParams.get('view')) && (
                      <th className="px-2 py-2 text-center text-xs font-semibold text-white uppercase tracking-wider w-[7%] border-r border-gray-600">
                        ⏱️ Tiempo
                      </th>
                    )}
                    <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[7%]">
                      F. Factura
                    </th>
                    <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[7%]">
                      F. Entrega
                    </th>
                    <th className="px-2 py-2 text-center text-xs font-semibold text-white uppercase tracking-wider w-[7%]">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {(() => {
                    // USAR displayedOrders en lugar de orders para que los filtros frontend funcionen
                    // displayedOrders ya tiene aplicados los filtros STATUS_PAGADO y STATUS_COBRAR
                    let ordersToShow = displayedOrders;

                    return ordersToShow.map((order, index) => {
                      const isReturned = order.status === 'pendiente_por_facturacion' && order.validation_notes;

                      let tags = [];
                      try {
                        if (typeof order.tags === 'string' && order.tags.trim()) tags = JSON.parse(order.tags);
                        else if (Array.isArray(order.tags)) tags = order.tags;
                      } catch (e) { }
                      const isPriority = Array.isArray(tags) && tags.includes('Modificado Facturación');

                      return (
                        <tr
                          key={order.id}
                          className={isPriority
                            ? "bg-red-50 hover:bg-red-100 border-2 border-red-500 shadow-sm transition-colors duration-300"
                            : isReturned
                              ? "bg-purple-50 hover:bg-purple-100 shadow-[inset_0_0_10px_rgba(139,92,246,0.2)] animate-pulse border-l-4 border-purple-500 transition-colors duration-500"
                              : `${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors duration-150`
                          }
                        >
                          {user?.role === 'logistica' && (
                            <td className="px-2 py-2">
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(order.id)}
                                onChange={() => {
                                  setSelectedOrders(prev =>
                                    prev.includes(order.id)
                                      ? prev.filter(id => id !== order.id)
                                      : [...prev, order.id]
                                  );
                                }}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                              />
                            </td>
                          )}

                          {searchParams.get('view') === 'cartera' && (
                            <td className="px-2 py-4 text-center whitespace-nowrap">
                              <span className="text-sm font-semibold text-gray-700">{displayedOrders.indexOf(order) + 1}</span>
                            </td>
                          )}

                          <td className="px-2 py-2 border-r border-gray-200">
                            <div className="min-w-[80px]">
                              <div className="flex flex-wrap items-center gap-1">
                                <span className="text-sm font-medium text-gray-900">
                                  {order.order_number}
                                </span>
                                {order.internal_order_numbers && (
                                  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-orange-100 text-orange-800 border border-orange-200">
                                    {order.internal_order_numbers}
                                  </span>
                                )}
                              </div>
                              <div className="text-sm text-gray-500">
                                {(Array.isArray(order.items) ? order.items.length : (order.items_count ?? order.itemsCount ?? 0))} items
                              </div>
                              {/* Tags display */}
                              {(() => {
                                let tags = [];
                                try {
                                  if (typeof order.tags === 'string' && order.tags.trim()) {
                                    tags = JSON.parse(order.tags);
                                  } else if (Array.isArray(order.tags)) {
                                    tags = order.tags;
                                  }
                                } catch (e) {
                                  // Ignore parse errors
                                }
                                if (Array.isArray(tags) && tags.length > 0) {
                                  return (
                                    <div className="flex flex-wrap gap-1 mt-1">
                                      {tags.map((tag, idx) => {
                                        const isPriority = tag === 'Modificado Facturación';
                                        return (
                                          <span
                                            key={idx}
                                            className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-bold border ${isPriority
                                              ? 'bg-red-100 text-red-800 border-red-200 animate-pulse'
                                              : 'bg-blue-100 text-blue-800 border-blue-200'
                                              }`}
                                          >
                                            {isPriority && <Icons.AlertTriangle className="w-3 h-3 mr-1" />}
                                            {tag}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  );
                                }
                                return null;
                              })()}
                            </div>
                          </td>

                          <td className="px-3 py-2 border-r border-gray-200">
                            <div className="max-w-[180px]">
                              <div className="text-sm font-medium text-gray-900 break-words leading-tight">
                                {order.customer_name || order.client_name}
                              </div>
                              {order.sale_channel && (
                                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200 mt-0.5">
                                  {order.sale_channel === 'pos' ? 'POS' : order.sale_channel}
                                </span>
                              )}
                              <div className="text-xs text-gray-500 mt-0.5">
                                {order.customer_phone || order.client_phone}
                              </div>
                            </div>
                          </td>

                          <td className="px-2 py-2 max-w-[200px] border-r border-gray-200">
                            <div className="flex flex-col space-y-1">
                              <span
                                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${((['recoge_bodega', 'recoge_posterior', 'recogida_tienda'].includes(order.delivery_method)) &&
                                  (
                                    ['entregado_cliente', 'entregado', 'completado', 'finalizado'].includes(order.status) ||
                                    order.delivered_at || order.is_delivered
                                  )
                                )
                                  ? 'bg-green-100 text-green-800'
                                  : getStatusColor(order.status)
                                  }`}
                              >
                                {((['recoge_bodega', 'recoge_posterior', 'recogida_tienda'].includes(order.delivery_method)) &&
                                  (
                                    ['entregado_cliente', 'entregado', 'completado', 'finalizado'].includes(order.status) ||
                                    order.delivered_at || order.is_delivered
                                  )
                                )
                                  ? 'Entregado en Bodega'
                                  : (order.status === 'entregado_transportadora' && order.carrier_name)
                                    ? `Entregado a ${order.carrier_name}`
                                    : getStatusLabel(order.status)}
                              </span>
                              {(order.is_service === 1 || order.is_service === true) && (
                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                                  Servicio
                                </span>
                              )}
                              {(order.is_pending_payment_evidence === true || order.is_pending_payment_evidence === 1 || order.is_pending_payment_evidence === '1') && (
                                <span className="block text-xs font-bold text-red-600 mt-1">
                                  Falta subir comprobante
                                </span>
                              )}
                              {/* Motivo visible para Gestión Especial */}
                              {order.status === 'gestion_especial' && getSpecialReason(order) && (
                                <span className="text-xs font-semibold text-red-600 line-clamp-2">
                                  Motivo: {getSpecialReason(order)}
                                </span>
                              )}
                              {order.validation_status === 'rejected' && (
                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                                  ❌ Rechazado por Cartera
                                </span>
                              )}
                              {order.siigo_closed ? (
                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                                  Cerrado en Siigo
                                </span>
                              ) : null}
                            </div>
                          </td>

                          <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-900 border-r border-gray-200">
                            <div className="flex flex-col">
                              <span className="font-semibold">
                                ${getOrderAmount(order).toLocaleString('es-CO')}
                              </span>
                              {order.internal_orders_total > 0 && (
                                <>
                                  <span className="text-[10px] font-bold text-orange-700 bg-orange-50 px-1 rounded border border-orange-100 w-fit mb-1">
                                    + {formatCurrencyCOP(order.internal_orders_total)} (Internos)
                                  </span>
                                  <div className="border-t border-gray-200 my-0.5 w-full"></div>
                                  <span className="text-xs font-black text-gray-800">
                                    Total: {formatCurrencyCOP(getOrderAmount(order) + (parseFloat(order.internal_orders_total) || 0))}
                                  </span>
                                </>
                              )}

                              {order.linked_reconciliation_count > 0 && (
                                <div className="mt-1">
                                  {(() => {
                                    let details = [];
                                    try {
                                      details = typeof order.linked_reconciliation_details === 'string'
                                        ? JSON.parse(order.linked_reconciliation_details)
                                        : (order.linked_reconciliation_details || []);
                                    } catch (e) {
                                      console.error('Error parsing linked details', e);
                                    }

                                    const totalLinked = details.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);
                                    const tooltipText = details.map(d =>
                                      `📅 ${d.date ? format(new Date(d.date), 'dd/MM/yyyy') : '-'} 💰 ${formatCurrencyCOP(d.amount)}`
                                    ).join('\n');

                                    return (
                                      <span
                                        className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-100 text-blue-800 border border-blue-200 w-fit cursor-help"
                                        title={`Pagos vinculados:\n${tooltipText}`}
                                      >
                                        <Icons.Link className="w-3 h-3 mr-1" />
                                        {details.length > 1 ? `Pagos Banco (${details.length}): ` : 'Pago Banco: '}
                                        {formatCurrencyCOP(totalLinked)}
                                      </span>
                                    );
                                  })()}
                                </div>
                              )}
                              {/* Indicadores de método de pago */}
                              <div className="flex space-x-1 mt-1">
                                {(() => {
                                  // PRIORIDAD 1: Indicadores POS
                                  if (order.sale_channel === 'pos') {
                                    if (order.status === 'pending_payment') {
                                      return (
                                        <span className="px-1 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-800 rounded animate-pulse border border-yellow-200">
                                          ⏳ PENDIENTE PAGO
                                        </span>
                                      );
                                    }
                                    if (order.status === 'payment_rejected') {
                                      return (
                                        <span className="px-1 py-0.5 text-xs font-medium bg-red-100 text-red-800 rounded border border-red-200">
                                          ❌ PAGO RECHAZADO
                                        </span>
                                      );
                                    }
                                  }

                                  // Si es cliente a crédito, siempre mostrar "CRÉDITO" sin importar totalDue (el flete se muestra en el chip de envío)
                                  if (isCreditOrder(order)) {
                                    return (
                                      <span className="px-1 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 rounded">
                                        🧾 CRÉDITO
                                      </span>
                                    );
                                  }
                                  // Mostrar coherencia en el flujo: el chip principal de Monto refleja SOLO el producto,
                                  // y el estado del flete se muestra en el chip de envío aparte.
                                  const { productDue, totalDue } = computeCollectionAmounts(order);
                                  const isMessenger = user?.role === 'mensajero' || (['logistica', 'admin'].includes(user?.role) && searchParams.get('view') === 'mensajero');
                                  const isPickup = String(order.delivery_method || '').toLowerCase().includes('bodega');

                                  if (isMessenger && totalDue === 0 && !isPickup) {
                                    return (
                                      <span className="px-1 py-0.5 text-xs font-bold bg-green-100 text-green-700 rounded border border-green-200">
                                        ✅ ENTREGAR
                                      </span>
                                    );
                                  }

                                  // Removed duplicate PENDIENTE PAGO badge for pickup - we already show COBRAR below

                                  if (productDue <= 0) {
                                    // CRITICAL FIX: Verify actual unpaid balance before showing "SIN COBRO"
                                    const totalAmount = Number(order?.total_amount || 0);
                                    const paidAmount = Number(order?.paid_amount || 0);
                                    const unpaidBalance = totalAmount - paidAmount;

                                    // If there's significant unpaid balance (>$2,000), must show COBRAR
                                    // UNLESS it's an explicit no-charge method
                                    if (unpaidBalance > 2000 && !isCreditOrder(order)) {
                                      const pm = String(order?.payment_method || '').toLowerCase();
                                      // Only these explicit methods can be SIN COBRO with high amounts
                                      if (pm === 'sin_cobro' || pm === 'reposicion' || pm === 'publicidad') {
                                        return (
                                          <span className="px-1 py-0.5 text-xs font-medium bg-gray-100 text-gray-700 rounded">
                                            ✅ SIN COBRO
                                          </span>
                                        );
                                      }
                                      // Otherwise, show COBRAR
                                      return (
                                        <span className={`px-1 py-0.5 text-xs font-bold rounded border ${isMessenger ? 'bg-orange-100 text-orange-700 border-orange-200 animate-pulse' : 'bg-red-100 text-red-700 border-red-200'}`}>
                                          💰 COBRAR ${formatCurrencyCOP(unpaidBalance)}
                                        </span>
                                      );
                                    }

                                    // Small or zero balance: show PAGADO or SIN COBRO
                                    if (hasOrderPayment(order)) {
                                      return (
                                        <span className="px-1 py-0.5 text-xs font-medium bg-green-100 text-green-700 rounded">
                                          ✅ PAGADO
                                        </span>
                                      );
                                    }
                                    return (
                                      <span className="px-1 py-0.5 text-xs font-medium bg-green-100 text-green-700 rounded">
                                        ✅ SIN COBRO
                                      </span>
                                    );
                                  }
                                  return (
                                    <span className={`px-1 py-0.5 text-xs font-bold rounded border ${isMessenger ? 'bg-orange-100 text-orange-700 border-orange-200 animate-pulse' : 'bg-red-100 text-red-700 border-red-200'}`}>
                                      💰 COBRAR ${formatCurrencyCOP(totalDue)}
                                    </span>
                                  );
                                })()}


                                {/* Proveedor de pago electrónico en crudo (sin helpers), oculto si hay columna dedicada en logística */}
                                {(() => {
                                  if (searchParams.get('view') === 'logistica') return null;
                                  const text = getRawElectronicProvider(order);
                                  if (!text) return null;
                                  return (
                                    <span className="px-1 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-800">
                                      {text}
                                    </span>
                                  );
                                })()}
                              </div>
                            </div>
                          </td>

                          <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
                            {(() => {
                              const paidVal = Number(order.paid_amount || 0);
                              const hasBreakdown = order.payments_breakdown && order.payments_breakdown.length > 0;

                              // Caso A: Hay desgloses manuales (ej: Mixto, varias consignaciones)
                              if (hasBreakdown) {
                                return (
                                  <div className="flex flex-col gap-1">
                                    {order.payment_method === 'mixto' && (
                                      <span className="inline-flex px-2 py-0.5 text-xs font-bold rounded-full bg-indigo-100 text-indigo-800 w-fit">
                                        MIXTO
                                      </span>
                                    )}
                                    {order.payments_breakdown.map((pay, idx) => (
                                      <span key={pay.id || idx} className="text-xs text-gray-700 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-md whitespace-nowrap w-fit">
                                        {getPaymentMethodLabel(pay.payment_method)}: {formatCurrencyCOP(pay.amount)}
                                      </span>
                                    ))}
                                  </div>
                                );
                              }

                              // Caso B: No hay desglose manual pero HAY un pago validado por Cartera/Siigo
                              if (paidVal > 2000) {
                                return (
                                  <div className="flex flex-col gap-1">
                                    <span className="text-xs text-gray-700 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-md whitespace-nowrap w-fit">
                                      {getPaymentMethodLabel(order.payment_method)}: {formatCurrencyCOP(order.paid_amount)}
                                    </span>
                                  </div>
                                );
                              }

                              // Caso C: Default (Pago pendiente o monto insignificante)
                              return (
                                <>
                                  <span className="capitalize">{getPaymentMethodLabel(order.payment_method)}</span>
                                  {order.electronic_payment_type && (
                                    <span className="block text-xs text-gray-400">
                                      ({order.electronic_payment_type})
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </td>

                          <td className="px-2 py-2 whitespace-nowrap text-sm text-center border-r border-gray-200">
                            {(() => {
                              const rcList = extractRC(order);

                              return (
                                <div className="flex flex-col gap-1 items-center justify-center w-full">
                                  <button
                                    onClick={(e) => { e.stopPropagation(); handleSyncRC(order.id); }}
                                    className="text-[10px] text-blue-500 hover:text-blue-700 hover:bg-blue-50 px-2 py-0.5 rounded flex items-center justify-center gap-1 mb-1 transition-colors border border-transparent hover:border-blue-100 disabled:opacity-50 mx-auto"
                                    title="Consultar y Sincronizar RCs desde Siigo"
                                    disabled={syncingOrderId !== null}
                                  >
                                    {/* Disable ALL buttons while one is syncing per "Solo un indicador a la vez" */}
                                    <Icons.RefreshCw size={10} />
                                    Sync
                                  </button>

                                  {(!rcList || rcList.length === 0) ? (
                                    <span className="text-gray-400 text-xs">-</span>
                                  ) : (
                                    rcList.map((rc, idx) => {
                                      const { name, id, value, payment_method, type } = rc;
                                      const isNC = type === 'credit_note';
                                      const isGreen = !isNC && name !== '[RC-EXISTENTE]';

                                      // Formatter for RC value
                                      const formattedValue = value ? formatCurrencyCOP(value) : '';

                                      return (
                                        <div key={idx} className="flex flex-col items-center gap-1 mb-2">
                                          <div className="flex items-center gap-2">
                                            <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full ${isNC ? 'bg-orange-100 text-orange-800' : isGreen ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'}`}>
                                              {name}
                                            </span>

                                            {formattedValue && (
                                              <span className="text-xs font-bold text-gray-700">
                                                {formattedValue}
                                              </span>
                                            )}
                                          </div>

                                          {payment_method && (
                                            <span className="text-[10px] text-gray-500 bg-gray-50 px-1.5 py-0.5 rounded border border-gray-200">
                                              {payment_method}
                                            </span>
                                          )}
                                        </div>
                                      );

                                    }))}
                                </div>
                              );
                            })()}
                          </td>

                          {
                            searchParams.get('view') === 'logistica' && (
                              <>
                                <td className="px-2 py-2 whitespace-nowrap">
                                  {(() => {
                                    // Columna específica de Logística: "Método de Pago"
                                    const raw = getRawPaymentMethod(order);
                                    return raw ? (
                                      <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                                        {raw}
                                      </span>
                                    ) : (
                                      <span className="text-xs text-gray-500">-</span>
                                    );
                                  })()}
                                </td>
                                <td className="px-2 py-2 whitespace-nowrap">
                                  {(() => {
                                    if (isCreditOrder(order)) return <span className="text-xs text-gray-500">-</span>;
                                    // Mostrar valor en crudo desde base de datos, sin funciones ni filtros
                                    const text = getRawElectronicProvider(order);

                                    return text
                                      ? (
                                        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                                          {text}
                                        </span>
                                      )
                                      : <span className="text-xs text-gray-500">-</span>;
                                  })()}
                                </td>
                              </>
                            )
                          }

                          {/* Método de envío - Solo visible para mensajeros */}
                          {
                            user?.role === 'mensajero' && (
                              <td className="px-2 py-2 whitespace-nowrap">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getDeliveryMethodColor(order.delivery_method)}`}>
                                  {getDeliveryMethodLabel(order.delivery_method)}
                                </span>
                              </td>
                            )
                          }

                          {/* Columna Forma de Envío — must render BEFORE timer to match header order */}
                          {
                            ['admin', 'logistica', 'mensajero', 'facturador', 'cartera'].includes(user?.role) && (
                              <td className="px-1 py-2 max-w-[120px] text-center border-r border-gray-200">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getDeliveryMethodColor(order.delivery_method)}`}>
                                  {getDeliveryMethodLabel(order.delivery_method)}
                                </span>
                                {order.assigned_messenger_id && (
                                  <div className="text-xs text-gray-500 mt-1">
                                    🏍️ {getCourierDisplay(order)}
                                    {order.handoff_at && (
                                      <div className="text-[10px] text-gray-400 mt-0.5">
                                        📅 {new Date(order.handoff_at).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {order.carrier_id && (
                                  <div className="text-xs text-gray-500 mt-1">
                                    🚚 {order.carrier_name || 'Transportadora'}
                                  </div>
                                )}
                              </td>
                            )
                          }

                          {/* ⏱️ Timer column — unified for all views, rendered AFTER Envío */}
                          {['logistica', 'facturacion', 'cartera'].includes(searchParams.get('view')) && (
                            <td className="px-1 py-2 whitespace-nowrap text-center">
                              {(() => {
                                const view = searchParams.get('view');
                                const now = timerTick || new Date();
                                const fmtMin = (m) => { if (m === null || m === undefined) return '-'; const h = Math.floor(m / 60); const mi = m % 60; return h > 0 ? `${h}h ${String(mi).padStart(2, '0')}m` : `${mi}m`; };
                                const fmtSec = (totalSeconds) => { const h = Math.floor(totalSeconds / 3600); const m = Math.floor((totalSeconds % 3600) / 60); const s = totalSeconds % 60; return h > 0 ? `${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s` : `${m}m ${String(s).padStart(2, '0')}s`; };

                                // Facturacion/Cartera: show time in current stage
                                if (view === 'facturacion' || view === 'cartera') {
                                  const stageEnteredAt = order.status_entered_at || order.created_at;
                                  if (!stageEnteredAt) return <span className="text-xs text-gray-400">-</span>;
                                  const stageDate = new Date(stageEnteredAt);
                                  const totalSec = Math.max(0, Math.floor((now - stageDate) / 1000));
                                  const min = Math.floor(totalSec / 60);
                                  const sec = totalSec % 60;
                                  const h = Math.floor(min / 60);
                                  const mi = min % 60;
                                  const isFact = view === 'facturacion';
                                  const label = isFact
                                    ? (h > 0 ? `${h}h ${String(mi).padStart(2, '0')}m ${String(sec).padStart(2, '0')}s` : `${mi}m ${String(sec).padStart(2, '0')}s`)
                                    : (h > 0 ? `${h}h ${String(mi).padStart(2, '0')}m` : `${mi}m`);
                                  const color = isFact
                                    ? (min > 10 ? 'bg-red-100 text-red-700 border-red-200' : min > 5 ? 'bg-yellow-100 text-yellow-700 border-yellow-200' : 'bg-green-100 text-green-700 border-green-200')
                                    : (min > 240 ? 'bg-red-100 text-red-700 border-red-200' : min > 60 ? 'bg-yellow-100 text-yellow-700 border-yellow-200' : 'bg-green-100 text-green-700 border-green-200');
                                  const entryTime = stageDate.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', hour12: true });
                                  return (
                                    <div className="flex flex-col items-center gap-0.5">
                                      <span className={`inline-flex px-1.5 py-0.5 text-xs font-bold rounded-full border ${color}`}>
                                        ⏱️ {label}
                                      </span>
                                      <span className="text-[10px] text-gray-400">🚪 {entryTime}</span>
                                    </div>
                                  );
                                }

                                // Logistica: show lead time with stage breakdown
                                const logEnteredAt = order.logistica_entered_at || order.created_at;
                                const empaqueEnteredAt = order.empaque_entered_at;
                                const stageEnteredAt = order.status_entered_at;
                                if (!logEnteredAt && !stageEnteredAt) return <span className="text-xs text-gray-400">-</span>;
                                const logDate = logEnteredAt ? new Date(logEnteredAt) : null;
                                const empDate = empaqueEnteredAt ? new Date(empaqueEnteredAt) : null;
                                const stageDate = stageEnteredAt ? new Date(stageEnteredAt) : null;
                                const totalSec = logDate ? Math.max(0, Math.floor((now - logDate) / 1000)) : 0;
                                const totalMin = Math.floor(totalSec / 60);
                                const totalColor = totalMin > 120 ? 'bg-red-100 text-red-700 border-red-200' : totalMin > 30 ? 'bg-yellow-100 text-yellow-700 border-yellow-200' : 'bg-green-100 text-green-700 border-green-200';

                                if (order.status === 'listo_para_entrega' && logDate) {
                                  const logMin = empDate ? Math.max(0, Math.floor((empDate - logDate) / 60000)) : null;
                                  const empMin = (empDate && stageDate) ? Math.max(0, Math.floor((stageDate - empDate) / 60000)) : null;
                                  const totMin = stageDate ? Math.max(0, Math.floor((stageDate - logDate) / 60000)) : totalMin;
                                  return (
                                    <div className="flex flex-col items-center gap-0.5">
                                      {logMin !== null && <span className="text-[10px] text-gray-500">📋 {fmtMin(logMin)}</span>}
                                      {empMin !== null && <span className="text-[10px] text-gray-500">📦 {fmtMin(empMin)}</span>}
                                      <span className={`inline-flex px-1.5 py-0.5 text-xs font-bold rounded-full border ${totalColor}`}>
                                        🏁 {fmtSec(Math.max(0, Math.floor((now - logDate) / 1000)))}
                                      </span>
                                    </div>
                                  );
                                }
                                if (order.status === 'en_empaque' && logDate && empDate) {
                                  const logMin = Math.max(0, Math.floor((empDate - logDate) / 60000));
                                  const empMin = Math.max(0, Math.floor((now - empDate) / 60000));
                                  return (
                                    <div className="flex flex-col items-center gap-0.5">
                                      <span className="text-[10px] text-gray-500">📋 {fmtMin(logMin)}</span>
                                      <span className="text-[10px] text-blue-600 font-medium">📦 {fmtMin(empMin)}</span>
                                      <span className={`inline-flex px-1.5 py-0.5 text-xs font-bold rounded-full border ${totalColor}`}>
                                        ⏱️ {fmtSec(totalSec)}
                                      </span>
                                    </div>
                                  );
                                }
                                const entryTime = (logDate || stageDate).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', hour12: true });
                                return (
                                  <div className="flex flex-col items-center gap-0.5">
                                    <span className={`inline-flex px-1.5 py-0.5 text-xs font-bold rounded-full border ${totalColor}`}>
                                      ⏱️ {fmtSec(totalSec)}
                                    </span>
                                    <span className="text-[10px] text-gray-400">🚪 {entryTime}</span>
                                  </div>
                                );
                              })()}
                            </td>
                          )}

                          <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-500" title={order.siigo_invoice_created_at || order.created_at || ''}>
                            {formatDateShort(order.siigo_invoice_created_at) ||
                              formatDateShort(order.created_at) ||
                              '-'}
                          </td>

                          <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-500">
                            {(() => {
                              const dateVal = order.delivery_date || order.shipping_date;
                              if (!dateVal) return '-';
                              const d = new Date(dateVal);
                              const adjusted = new Date(d.valueOf() + d.getTimezoneOffset() * 60000);
                              return format(adjusted, 'dd/MM/yyyy', { locale: es });
                            })()}
                          </td>

                          <td className="px-2 py-2 whitespace-nowrap text-center text-sm font-medium">
                            <div className={`grid grid-cols-3 gap-1 max-w-[90px] mx-auto justify-items-center actions-cell ${isLogisticsActionsView ? 'actions-lgx' : ''}`}>
                              {/* Fila 1: Ver detalles - SIEMPRE presente */}
                              <button
                                type="button"
                                onClick={() => navigate(`/orders/${order.id}`)}
                                className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                title="Ver detalles"
                              >
                                <Icons.Eye className="w-5 h-5" />
                              </button>

                              {/* Fila 1: Descargar/Ver factura SIIGO */}
                              {order.siigo_public_url ? (
                                <a
                                  href={order.siigo_public_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-purple-600 hover:text-purple-900 w-5 h-5 flex items-center justify-center"
                                  title="Ver factura SIIGO"
                                >
                                  <Icons.FileText className="w-5 h-5" />
                                </a>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Imprimir Voucher INT (Solo pedidos internos INT-*) */}
                              {String(order.order_number || '').startsWith('INT') && (
                                <button
                                  type="button"
                                  onClick={() => handlePrintINTOrder(order)}
                                  className="text-orange-600 hover:text-orange-900 w-5 h-5 flex items-center justify-center"
                                  title="Imprimir Voucher Interno"
                                >
                                  <Icons.FileText className="w-5 h-5" />
                                </button>
                              )}

                              {/* Fila 1: Imprimir Interno (Solo si tiene internos) */}
                              {order.internal_orders_total > 0 && (
                                <button
                                  type="button"
                                  onClick={() => handlePrintInternal(order)}
                                  className="text-orange-600 hover:text-orange-900 w-5 h-5 flex items-center justify-center"
                                  title="Imprimir Voucher Interno"
                                >
                                  <Icons.Printer className="w-5 h-5" />
                                </button>
                              )}

                              {/* Fila 1: Imprimir Guías/Rótulos */}
                              <button
                                type="button"
                                onClick={() => setLabelModal({ isOpen: true, order })}
                                className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                title="Imprimir rótulos de envío"
                              >
                                <Icons.Printer className="w-5 h-5" />
                              </button>

                              {/* Fila 2: Ver línea de tiempo */}
                              <button
                                type="button"
                                onClick={() => setTimelineModal({ isOpen: true, order })}
                                className="text-gray-700 hover:text-gray-900 w-5 h-5 flex items-center justify-center"
                                title="Ver línea de tiempo"
                              >
                                <Icons.History className="w-5 h-5" />

                              </button>

                              {/* Fila 2: Ver Snapshot de Empaque (Solo Logística/Admin/Empaque) */}
                              {['admin', 'logistica', 'facturador', 'empaque'].includes(user?.role) && (
                                <button
                                  type="button"
                                  onClick={() => setSnapshotModal({ isOpen: true, orderId: order.id })}
                                  className="text-indigo-600 hover:text-indigo-900 w-5 h-5 flex items-center justify-center"
                                  title="Ver Snapshot de Empaque"
                                >
                                  <Icons.Camera className="w-5 h-5" />
                                </button>
                              )}

                              {/* Acción rápida: Cliente canceló pedido (Admin/Facturación) */}
                              {(['admin', 'facturador'].includes(user?.role) &&
                                ['en_preparacion', 'en_empaque', 'empacado', 'listo', 'listo_para_entrega', 'listo_para_recoger', 'en_logistica', 'en_reparto'].includes(String(order.status || '').toLowerCase())) ? (
                                <button
                                  type="button"
                                  onClick={() => setCancelModal({ isOpen: true, order, loading: false })}
                                  className="text-red-600 hover:text-red-900 w-5 h-5 flex items-center justify-center"
                                  title="Cliente canceló pedido"
                                >
                                  <Icons.XCircle className="w-5 h-5" />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Modificar Envío (Facturador/Admin) */}
                              {(user?.role === 'admin' || user?.role === 'facturador') && !['entregado_cliente', 'entregado_transportadora', 'cancelado'].includes(String(order.status || '').toLowerCase()) && (
                                <button
                                  type="button"
                                  onClick={() => setShippingModal({ isOpen: true, order })}
                                  className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                  title="Modificar Envío"
                                >
                                  <Icons.Settings className="w-5 h-5" />
                                </button>
                              )}

                              {/* Slot 3: Acción principal del estado */}
                              {order.status === 'no_entregado' && ['admin', 'facturador'].includes(user?.role) ? (
                                <button
                                  onClick={() => handleResendToDelivery(order)}
                                  className="text-green-600 hover:text-green-900 w-5 h-5 flex items-center justify-center"
                                  title="Reenviar a Entrega"
                                >
                                  <Icons.RotateCcw className="w-5 h-5" />
                                </button>
                              ) : order.status === 'gestion_especial' ? (
                                <span
                                  className="text-gray-500 w-5 h-5 flex items-center justify-center"
                                  title="Pedido en gestión especial"
                                >
                                  <Icons.Flag className="w-5 h-5" />
                                </span>
                              ) : (['admin', 'facturador'].includes(user?.role) && (order.status === 'pendiente_por_facturacion' || order.status === 'pendiente_facturacion')) ? (
                                <>
                                  <button
                                    onClick={() => {
                                      // ─── GUARD: Validar método de pago SIIGO (debe ser 5672 - Pago a Crédito) ───
                                      // Si la factura tiene otro método de pago en SIIGO, no se puede avanzar
                                      // porque se marcaría como pagada e impediría crear RCs después.
                                      const siigoPayMethod = order.siigo_invoice_payment_method;
                                      if (siigoPayMethod && !siigoPayMethod.startsWith('5672')) {
                                        setPaymentGuardModal({ isOpen: true, order, paymentMethod: siigoPayMethod });
                                        return;
                                      }
                                      setReviewModal({ isOpen: true, order });
                                    }}
                                    className="text-orange-600 hover:text-orange-900 w-5 h-5 flex items-center justify-center"
                                    title="Revisar y aprobar pedido"
                                  >
                                    <Icons.FileSearch className="w-5 h-5" />
                                  </button>
                                  <button
                                    onClick={() => setSpecialModal({ isOpen: true, order, loading: false })}
                                    className="text-red-600 hover:text-red-900 w-5 h-5 flex items-center justify-center"
                                    title="Marcar gestión especial (sale del flujo)"
                                  >
                                    <Icons.Flag className="w-5 h-5" />
                                  </button>
                                </>
                              ) : (['admin', 'cartera'].includes(user?.role) && (order.status === 'revision_cartera' || (order.status === 'listo_para_entrega' && (order.requires_payment || String(order.payment_method || '').toLowerCase().includes('transferencia'))))) ? (
                                order.sale_channel === 'pos' ? (
                                  <button
                                    onClick={() => setPosModal({ isOpen: true, order })}
                                    className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                    title="Validar Venta POS"
                                  >
                                    <Icons.Store className="w-5 h-5" />
                                  </button>
                                ) : (
                                  // UNIFICADO: Todos los pedidos de Cartera usan PickupPaymentModal (mobile)
                                  <button
                                    onClick={() => handleReceivePickupPayment(order)}
                                    className="text-green-600 hover:text-green-900 w-5 h-5 flex items-center justify-center"
                                    title="Aplicar Pago"
                                  >
                                    <Icons.DollarSign className="w-5 h-5" />
                                  </button>
                                )
                              ) : (['admin', 'cartera', 'logistica'].includes(user?.role) && (order.is_pending_payment_evidence)) ? (
                                <button
                                  onClick={() => setUploadEvidenceModal({ open: true, order, file: null })}
                                  className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                  title="Subir comprobante (Pendiente)"
                                >
                                  <Icons.Upload className="w-5 h-5" />
                                </button>
                              ) : (['admin', 'logistica'].includes(user?.role) && order.status === 'en_logistica') ? (
                                <button
                                  onClick={() => setLogisticsModal({ isOpen: true, order })}
                                  className="text-purple-600 hover:text-purple-900 w-5 h-5 flex items-center justify-center"
                                  title="Procesar envío"
                                >
                                  <Icons.Truck className="w-5 h-5" />
                                </button>
                              ) : (['admin', 'logistica'].includes(user?.role) && order.status === 'en_empaque') ? (
                                <button
                                  onClick={() => navigate(`/packaging?orderId=${order.id}`)}
                                  className="text-green-600 hover:text-green-900 w-5 h-5 flex items-center justify-center"
                                  title="Procesar Empaque"
                                >
                                  <Icons.Box className="w-5 h-5" />
                                </button>
                              ) : (user?.role === 'mensajero' && order.assigned_messenger_id === user.id && order.messenger_status === 'assigned' && !['entregado', 'entregado_cliente', 'entregado_transportadora', 'entregado_bodega'].includes(order.status)) ? (
                                <button
                                  type="button"
                                  onClick={() => handleAcceptOrder(order.id)}
                                  className="text-green-600 hover:text-green-900 w-5 h-5 flex items-center justify-center"
                                  title="Aceptar pedido"
                                >
                                  <Icons.Check className="w-5 h-5" />
                                </button>
                              ) : (user?.role === 'mensajero' && order.assigned_messenger_id === user.id && order.messenger_status === 'accepted') ? (
                                <button
                                  type="button"
                                  onClick={() => setDeliveryConfirmationModal({ isOpen: true, order })}
                                  className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                  title="Iniciar entrega"
                                >
                                  <Icons.Play className="w-5 h-5" />
                                </button>
                              ) : (user?.role === 'mensajero' && order.assigned_messenger_id === user.id && order.messenger_status === 'in_delivery') ? (
                                <button
                                  type="button"
                                  onClick={() => setDeliveryModal({ isOpen: true, order })}
                                  className="text-purple-600 hover:text-purple-900 w-5 h-5 flex items-center justify-center"
                                  title="Completar entrega"
                                >
                                  <Icons.Package className="w-5 h-5" />
                                </button>
                              ) : (order.status === 'en_reparto' && user?.role === 'mensajero') ? (
                                <button
                                  onClick={() => setDeliveryModal({ isOpen: true, order })}
                                  className="text-purple-600 hover:text-purple-900 w-5 h-5 flex items-center justify-center"
                                  title="Registrar entrega"
                                >
                                  <Icons.Package className="w-5 h-5" />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Slot 4: Devolver a Facturación (Cartera/Admin only, revision_cartera status) */}
                              {(['admin', 'cartera'].includes(user?.role) && order.status === 'revision_cartera') ? (
                                <button
                                  onClick={() => setReturnToBillingModal({ isOpen: true, order })}
                                  className="text-orange-600 hover:text-orange-900 w-5 h-5 flex items-center justify-center"
                                  title="Devolver a Facturación"
                                >
                                  <Icons.ArrowLeft className="w-5 h-5" />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Slot 5: Acción secundaria */}
                              {(['admin', 'logistica'].includes(user?.role) && order.status === 'en_empaque') ? (
                                <button
                                  onClick={() => handleStatusChange(order.id, 'empacado')}
                                  className="text-blue-600 hover:text-blue-900 w-5 h-5 flex items-center justify-center"
                                  title="Finalizar Empaque"
                                >
                                  <Icons.CheckCircle className="w-5 h-5" />
                                </button>
                              ) : (user?.role === 'mensajero' && order.assigned_messenger_id === user.id && order.messenger_status === 'assigned') ? (
                                <button
                                  type="button"
                                  onClick={() => handleRejectOrder(order.id)}
                                  className="text-red-600 hover:text-red-900 w-5 h-5 flex items-center justify-center"
                                  title="Rechazar pedido"
                                >
                                  <Icons.X className="w-5 h-5" />
                                </button>
                              ) : (user?.role === 'mensajero' && order.assigned_messenger_id === user.id && order.messenger_status === 'in_delivery') ? (
                                <button
                                  type="button"
                                  onClick={() => handleMarkDeliveryFailed(order.id)}
                                  className="text-orange-600 hover:text-orange-900 w-5 h-5 flex items-center justify-center"
                                  title="Marcar entrega fallida"
                                >
                                  <Icons.AlertTriangle className="w-5 h-5" />
                                </button>
                              ) : (order.status === 'pendiente' && canChangeStatus(order, 'confirmado')) ? (
                                <button
                                  onClick={() => handleStatusChange(order.id, 'confirmado')}
                                  className="text-green-600 hover:text-green-900 w-5 h-5 flex items-center justify-center"
                                  title="Confirmar"
                                >
                                  <Icons.Check className="w-5 h-5" />
                                </button>
                              ) : (['admin', 'cartera', 'logistica'].includes(user?.role) && ['efectivo', 'contraentrega'].includes(String(order.payment_method || '').toLowerCase()) && !order.is_pending_payment_evidence) ? (
                                <button
                                  onClick={() => setUploadEvidenceModal({ open: true, order, file: null })}
                                  className="text-gray-400 hover:text-blue-600 w-5 h-5 flex items-center justify-center"
                                  title="Subir comprobante (Opcional)"
                                >
                                  <Icons.Upload className="w-5 h-5" />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Slot 4.5: Recargar desde SIIGO (visible si hay siigo_invoice_id) */}
                              {(['admin', 'facturador', 'logistica', 'cartera'].includes(user?.role) && order.siigo_invoice_id) ? (
                                <button
                                  onClick={() => handleReloadFromSiigo(order.id)}
                                  disabled={reloadingIds.has(String(order.id))}
                                  className="text-emerald-600 hover:text-emerald-900 w-5 h-5 flex items-center justify-center disabled:opacity-50"
                                  title="Recargar desde SIIGO"
                                >
                                  <Icons.RefreshCw className={`w-5 h-5 ${reloadingIds.has(String(order.id)) ? 'animate-spin' : ''}`} />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}

                              {/* Slot 5: Eliminar pedido SIIGO - Solo admin y pedidos de SIIGO */}
                              {(user?.role === 'admin' && order.siigo_invoice_id && !['entregado_cliente', 'entregado_transportadora'].includes(order.status)) ? (
                                <button
                                  onClick={() => setDeleteSiigoModal({ isOpen: true, order, loading: false })}
                                  className="text-red-600 hover:text-red-900 w-5 h-5 flex items-center justify-center"
                                  title="Eliminar pedido SIIGO (vuelve a SIIGO para reimportación)"
                                >
                                  <Icons.Trash2 className="w-5 h-5" />
                                </button>
                              ) : (
                                <div className="w-5 h-5"></div>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  })()}
                </tbody>
              </table>
            </div>

            {/* Paginación para Cartera */}
            {(searchParams.get('view') === 'cartera' || searchParams.get('status') === 'revision_cartera') && displayedOrders.length > CARTERA_ITEMS_PER_PAGE && (
              <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50">
                <div className="flex-1 flex justify-between sm:hidden">
                  <button
                    onClick={() => setCarteraCurrentPage(p => Math.max(1, p - 1))}
                    disabled={carteraCurrentPage === 1}
                    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={() => setCarteraCurrentPage(p => Math.min(Math.ceil(displayedOrders.length / CARTERA_ITEMS_PER_PAGE), p + 1))}
                    disabled={carteraCurrentPage >= Math.ceil(displayedOrders.length / CARTERA_ITEMS_PER_PAGE)}
                    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Siguiente
                  </button>
                </div>
                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm text-gray-700">
                      Mostrando <span className="font-medium">{(carteraCurrentPage - 1) * CARTERA_ITEMS_PER_PAGE + 1}</span> a{' '}
                      <span className="font-medium">{Math.min(carteraCurrentPage * CARTERA_ITEMS_PER_PAGE, displayedOrders.length)}</span> de{' '}
                      <span className="font-medium">{displayedOrders.length}</span> pedidos
                    </p>
                  </div>
                  <div>
                    <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                      <button
                        onClick={() => setCarteraCurrentPage(p => Math.max(1, p - 1))}
                        disabled={carteraCurrentPage === 1}
                        className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <Icons.ChevronLeft className="h-5 w-5" />
                      </button>
                      <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
                        Página {carteraCurrentPage} de {Math.ceil(displayedOrders.length / CARTERA_ITEMS_PER_PAGE)}
                      </span>
                      <button
                        onClick={() => setCarteraCurrentPage(p => Math.min(Math.ceil(displayedOrders.length / CARTERA_ITEMS_PER_PAGE), p + 1))}
                        disabled={carteraCurrentPage >= Math.ceil(displayedOrders.length / CARTERA_ITEMS_PER_PAGE)}
                        className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <Icons.ChevronRight className="h-5 w-5" />
                      </button>
                    </nav>
                  </div>
                </div>
              </div>
            )}

            {displayedOrders.length === 0 && (
              <div className="text-center py-12">
                <Icons.Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-500 text-lg">No se encontraron pedidos</p>
                <p className="text-gray-400">Intenta ajustar los filtros de búsqueda</p>
              </div>
            )}
          </div>

          {/* Paginación */}
          {pagination.pages > 1 && (
            <div className="px-6 py-3 border-t border-gray-200 flex items-center justify-between">
              <div className="text-sm text-gray-700">
                {/* Para Cartera, usar orders.length ya que la bifurcación filtra la lista */}
                {searchParams.get('view') === 'cartera' ? (
                  <>
                    Mostrando <span className="font-medium">{Math.min(orders.length, pagination.limit)}</span> de{' '}
                    <span className="font-medium">{displayedOrders.length}</span> resultados
                  </>
                ) : (
                  <>
                    Mostrando {((pagination.page - 1) * pagination.limit) + 1} a{' '}
                    {Math.min(pagination.page * pagination.limit, pagination.total)} de{' '}
                    {pagination.total} resultados
                  </>
                )}
              </div>

              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handleFilterChange('page', pagination.page - 1)}
                  disabled={pagination.page <= 1}
                  className="btn btn-secondary btn-sm"
                >
                  <Icons.ChevronLeft className="w-5 h-5" />
                </button>

                <span className="text-sm text-gray-700">
                  Página {pagination.page} de {pagination.pages}
                </span>

                <button
                  onClick={() => handleFilterChange('page', pagination.page + 1)}
                  disabled={pagination.page >= pagination.pages}
                  className="btn btn-secondary btn-sm"
                >
                  <Icons.ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    )}


      {/* PEDIDOS PENDIENTES POR REVISAR PAGO (REINGRESO) - Segunda vez en cartera (evidencia nueva) */}
      {
        searchParams.get('view') === 'cartera' && paymentReviewList.length > 0 && (
          <div className="card mt-6 border-l-4 border-l-blue-500 shadow-md">
            <div className="card-header bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex justify-between items-center w-full">
                <h2 className="text-lg font-bold text-gray-900 flex items-center">
                  <Icons.Repeat className="w-5 h-5 mr-2 text-blue-600" />
                  Pedidos para Revalidación de Pago
                  <span className="ml-2 px-2 py-1 text-xs font-bold bg-blue-100 text-blue-700 rounded-full animate-pulse">
                    {paymentReviewList.length}
                  </span>
                </h2>
              </div>
              <p className="text-sm text-gray-500 mt-1 ml-7">
                Pedidos que ya tenían un proceso avanzado pero requieren nueva validación de pago (Pagos registrados desde facturación, correcciones, etc).
              </p>
            </div>
            <div className="card-content p-0">
              <div className="!hidden sm:!block overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-blue-50 border-b border-blue-100">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Pedido</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Cliente</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-700">Monto</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-700">Forma Pago</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-700">Estado Logístico</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-700">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {paymentReviewList.map((order) => {
                      const tagsStr = typeof order.tags === 'string' ? order.tags : JSON.stringify(order.tags || []);
                      const isPriority = tagsStr.includes('Modificado Facturación');
                      return (
                        <tr key={order.id} className={isPriority ? "bg-red-50 border-2 border-red-500 hover:bg-red-100" : "hover:bg-blue-50/30"}>
                          <td className="px-4 py-3">
                            <span className="font-bold text-gray-900 block">#{order.order_number}</span>
                            <span className="text-[10px] text-gray-500 block">{new Date(order.created_at).toLocaleDateString()}</span>
                          </td>
                          <td className="px-4 py-3 text-gray-700">{order.customer_name}</td>
                          <td className="px-4 py-3 text-right font-bold text-blue-600">
                            {formatCurrencyCOP(order.total_amount)}
                            {!hasShippingFeePaid(order) && <span className="ml-1 text-[10px] bg-orange-100 text-orange-700 px-1 rounded">+FLETE</span>}
                            {/* Render Tags */}
                            {(() => {
                              let tags = [];
                              try {
                                if (typeof order.tags === 'string' && order.tags.trim()) tags = JSON.parse(order.tags);
                                else if (Array.isArray(order.tags)) tags = order.tags;
                              } catch (e) { }

                              return Array.isArray(tags) && tags.map((tag, idx) => {
                                if (tag === 'Modificado Facturación') {
                                  return (
                                    <span key={idx} className="block mt-1 text-[10px] bg-red-100 text-red-800 border border-red-200 animate-pulse px-1 rounded font-bold uppercase flex items-center justify-end gap-1">
                                      <Icons.AlertTriangle className="w-3 h-3" />
                                      {tag}
                                    </span>
                                  );
                                }
                                // Omit known hardcoded tags to avoid potential display duplications if handled elsewhere, or just render all
                                if (tag === 'SIN COBRO' || tag === '+FLETE') return <span key={idx} className="ml-1 text-[10px] bg-gray-100 text-gray-800 px-1 rounded">{tag}</span>;
                                return null;
                              });
                            })()}
                          </td>
                          <td className="px-4 py-3 text-right text-xs uppercase text-gray-500">
                            {order.payment_method}
                            {order.is_pending_payment_evidence && (
                              <span className="block text-[10px] text-green-600 font-bold mt-1">EVIDENCIA NUEVA</span>
                            )}
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(order.status)}`}>
                              {(order.status || '').replace('_', ' ')}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <div className="flex justify-center gap-2">
                              <button
                                onClick={() => setPickupPaymentModal({ isOpen: true, order })}
                                className="p-2 text-green-600 bg-green-100 rounded-lg hover:bg-green-200 transition-colors shadow-sm"
                                title="Revalidar Pago"
                              >
                                <Icons.DollarSign className="w-5 h-5" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* MOBILE UI for Payment Review */}
              <div className="sm:hidden space-y-3 p-3 bg-gray-50 border-t border-gray-100">
                {paymentReviewList.map((order) => {
                  const tagsStr = typeof order.tags === 'string' ? order.tags : JSON.stringify(order.tags || []);
                  const isPriority = tagsStr.includes('Modificado Facturación');
                  return (
                    <div key={order.id} className={isPriority ? "bg-red-50 rounded-lg border-2 border-red-500 shadow-md p-3" : "bg-white rounded-lg border-l-4 border-l-blue-500 shadow-sm p-3"}>
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <span className="text-sm font-bold text-gray-900">#{order.order_number}</span>
                          <span className="ml-2 text-[10px] bg-blue-100 text-blue-700 px-1 rounded font-bold">RE-VALIDAR</span>
                        </div>
                        <span className="text-blue-600 font-bold">
                          {formatCurrencyCOP(order.total_amount)}
                          {(() => {
                            let tags = [];
                            try {
                              if (typeof order.tags === 'string' && order.tags.trim()) tags = JSON.parse(order.tags);
                              else if (Array.isArray(order.tags)) tags = order.tags;
                            } catch (e) { }

                            return Array.isArray(tags) && tags.map((tag, idx) => {
                              if (tag === 'Modificado Facturación') {
                                return (
                                  <span key={idx} className="block mt-1 text-[10px] bg-red-100 text-red-800 border border-red-200 animate-pulse px-1 rounded font-bold uppercase flex items-center justify-end gap-1">
                                    <Icons.AlertTriangle className="w-3 h-3" />
                                    {tag}
                                  </span>
                                );
                              }
                              return null;
                            });
                          })()}
                        </span>
                      </div>
                      <div className="text-xs text-gray-600 mb-2">{order.customer_name}</div>
                      <div className="flex justify-between items-center mb-2">
                        <span className={`px-2 py-0.5 text-[10px] rounded-full ${getStatusColor(order.status)}`}>
                          {(order.status || '').replace('_', ' ')}
                        </span>
                      </div>
                      <button
                        onClick={() => setPickupPaymentModal({ isOpen: true, order })}
                        className="w-full p-2 bg-green-600 text-white rounded font-medium text-xs shadow-sm"
                      >
                        Revalidar Pago
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )
      }


      {/* REMOVED: Pedidos con Adiciones section */}

      {/* NUEVO: Resumen Global de Pagos Pendientes (Segmentado) */}
      {/* NUEVO: Resumen Global de Pagos Pendientes (Segmentado) */}
      {
        (() => {
          const view = searchParams.get('view');
          const shouldRender = view === 'cartera';
          console.log(`[DEBUG-RENDER] PendingPaymentsOverview check. View: ${view}, Role: ${user?.role}, ShouldRender: ${shouldRender}, Count: ${globalPendingOrders.length}`);
          return shouldRender && (
            <PendingPaymentsOverview
              orders={globalPendingOrders}
              onOpenPaymentModal={(order) => setPickupPaymentModal({ isOpen: true, order })}
              onOpenHistory={(order) => setTimelineModal({ isOpen: true, order })}
              cashSessionOpen={cashSessionOpen}
            />
          );
        })()
      }

      {/* Pedidos pendientes por conciliar (solo vista Cartera) */}
      {/* Componente autónomo - no requiere props */}
      {searchParams.get('view') === 'cartera' && <PendingReconciliationSection />}
      {
        searchParams.get('view') === 'logistica' && (
          <PendingTransportGuides
            onGuideUploaded={() => {
              loadOrders(undefined, false);
              // Also refresh ready orders just in case
              loadReadyOrders();
              // Trigger global refresh to update pending guides list itself (redundant but safe)
              window.dispatchEvent(new Event('orders:refresh'));
            }}
          />
        )
      }




      {/* DEVOLUCIONES PENDIENTES -  Pedidos con saldo negativo (cliente pag\u00f3 de m\u00e1s) */}
      {
        searchParams.get('view') === 'cartera' && refundsPending.length > 0 && (
          <div className="card mt-6 border-l-4 border-l-purple-600 shadow-md">
            <div className="card-header bg-gradient-to-r from-purple-50 to-pink-50">
              <h2 className="text-lg font-bold text-gray-900 flex items-center">
                <Icons.Undo className="w-5 h-5 mr-2 text-purple-600" />
                Devoluciones Pendientes
                <span className="ml-2 px-2 py-1 text-xs font-bold bg-purple-100 text-purple-700 rounded-full animate-pulse">
                  {refundsPending.length}
                </span>
              </h2>
              <p className="text-sm text-gray-500 mt-1 ml-7">Pedidos donde el cliente pag\u00f3 de m\u00e1s. Requieren devoluci\u00f3n de dinero.</p>
            </div>
            <div className="card-content p-0">
              {/* VISTA M\u00d3VIL */}
              <div className="sm:hidden space-y-3 p-3 bg-gray-50">
                {refundsPending.map((order) => {
                  const { productDue } = computeCollectionAmounts(order);
                  const refundAmount = Math.abs(productDue);
                  return (
                    <div key={order.id} className="bg-white rounded-lg border-2 border-purple-200 shadow-sm p-3">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <span className="text-sm font-bold text-gray-900 block">#{order.order_number}</span>
                          <span className="text-xs text-gray-700 font-medium bg-purple-50 px-1 rounded block">{order.customer_name}</span>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => setTimelineModal({ isOpen: true, order })}
                            className="p-1.5 text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200"
                          >
                            <Icons.History className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                      <div className="flex justify-between items-center text-xs mt-3 pt-2 border-t border-purple-100">
                        <div>
                          <span className="text-gray-500">A Devolver:</span>
                          <span className="ml-1 font-bold text-purple-600">{formatCurrencyCOP(refundAmount)}</span>
                        </div>
                        <div className="flex items-center text-gray-500">
                          <Icons.Package className="w-3 h-3 mr-1" />
                          <span className="capitalize">{String(order.status || '').replace('_', ' ')}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* VISTA DESKTOP */}
              <div className="!hidden sm:!block overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-purple-50 border-b border-purple-100">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Pedido</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Cliente</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-700">Monto a Devolver</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-700">Estado Actual</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-700">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {refundsPending.map((order) => {
                      const { productDue } = computeCollectionAmounts(order);
                      const refundAmount = Math.abs(productDue);
                      return (
                        <tr key={order.id} className="hover:bg-purple-50/30">
                          <td className="px-4 py-3 font-medium text-gray-900">#{order.order_number}</td>
                          <td className="px-4 py-3 text-gray-700">{order.customer_name}</td>
                          <td className="px-4 py-3 text-right">
                            <span className="font-bold text-purple-600">{formatCurrencyCOP(refundAmount)}</span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-700 rounded-full capitalize">
                              {String(order.status || '').replace('_', ' ')}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <div className="flex items-center justify-center gap-2">
                              <button
                                onClick={() => setTimelineModal({ isOpen: true, order })}
                                className="p-2 text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200"
                                title="Ver historial"
                              >
                                <Icons.History className="w-5 h-5" />
                              </button>
                              <button
                                onClick={() => setRefundModal({ isOpen: true, order })}
                                className="px-3 py-1.5 text-white bg-purple-600 rounded-md hover:bg-purple-700 shadow-sm text-xs font-medium"
                              >
                                Registrar Devolución
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      }

      {/* Pedidos de Bodega en Proceso (con saldo pendiente) */}
      {
      }

      {/* SECCIÓN SIIGO ELIMINADA */}

      {/* NUEVO: Historial de Facturación y Cierres (Vista dedicada) */}
      {searchParams.get('view') === 'historial_facturacion' && (
        <div className="mb-6">
          <BillingHistoryTab user={user} />
        </div>
      )}

      {/* Pedidos de Reposición (vista Cartera y Facturación) */}
      {
        (searchParams.get('view') === 'cartera' || searchParams.get('view') === 'facturacion') && (
          <div className="card mt-6">
            <div className="card-header">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center">
                <Icons.Package className="w-5 h-5 mr-2 text-orange-600" />
                Pedidos de Reposición
                <span className="ml-2 px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-full">
                  {reposicionOrders.length}
                </span>
              </h2>
            </div>
            <div className="card-content p-0">
              {/* VISTA MÓVIL: LISTA DE TARJETAS */}
              <div className="sm:hidden">
                <div className="space-y-3 p-3 bg-gray-50">
                  {reposicionOrders.length === 0 ? (
                    <div className="px-2 py-6 text-center text-sm text-gray-500">
                      No hay pedidos de reposición.
                    </div>
                  ) : (
                    reposicionOrders.map((row) => (
                      <div key={row.id || row.order_id} className="bg-white rounded-lg border border-gray-200 shadow-sm p-3">
                        {/* Header: Pedido y Monto */}
                        <div className="flex justify-between items-start mb-2">
                          <div>
                            <span className="text-sm font-bold text-gray-900 block">#{row.order_number}</span>
                            <span className="text-xs font-bold text-gray-900 block mt-0.5">${Number(row.total_amount || 0).toLocaleString('es-CO')}</span>
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={() => setTimelineModal({ isOpen: true, order: row })}
                              className="p-1.5 text-blue-600 bg-blue-50 rounded-full"
                              title="Ver Historial"
                            >
                              <Icons.History className="w-5 h-5" />
                            </button>
                            <button
                              onClick={() => handleOpenRepositionModal(row)}
                              className="p-1.5 text-green-600 bg-green-50 rounded-full"
                              title="Gestionar Reposición"
                            >
                              <Icons.CheckCircle className="w-5 h-5" />
                            </button>
                          </div>
                        </div>

                        {/* Cliente */}
                        <div className="mb-2">
                          <div className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Cliente</div>
                          <div className="text-sm text-gray-900">{row.customer_name}</div>
                        </div>

                        {/* Estado y Etiquetas */}
                        <div className="flex flex-wrap gap-2 mb-2">
                          <span className="px-2 py-0.5 text-[10px] font-bold rounded-full bg-orange-100 text-orange-800 uppercase">
                            {row.status}
                          </span>
                          {(row.is_service === 1 || row.is_service === true) && (
                            <span className="px-2 py-0.5 text-[10px] font-bold rounded-full bg-blue-100 text-blue-800 uppercase">
                              Servicio
                            </span>
                          )}
                        </div>

                        {/* Info Grid: Entrega, Factura, Fecha */}
                        <div className="grid grid-cols-2 gap-2 text-xs border-t border-gray-100 pt-2 mt-2">
                          <div>
                            <span className="text-gray-500 block mb-0.5">Entrega</span>
                            <span className="font-medium text-gray-800">{row.delivery_channel || '-'}</span>
                          </div>
                          <div>
                            <span className="text-gray-500 block mb-0.5">Factura</span>
                            <div className="font-medium text-gray-800">{row.siigo_invoice_number || '-'}</div>
                            <div className="text-[10px] text-gray-500 mt-0.5">
                              {row.siigo_invoice_created_at ? new Date(row.siigo_invoice_created_at).toLocaleDateString('es-CO') : '-'}
                            </div>
                          </div>
                        </div>
                      </div>
                    )))}
                </div>
              </div>

              {/* VISTA TABLET/DESKTOP: TABLA CLÁSICA */}
              <div className="!hidden sm:!block overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase">Pedido</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Estado</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Entrega</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Factura</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Fecha Factura</th>
                      <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Monto</th>
                      <th className="px-2 py-1 text-right text-xs font-medium text-gray-500 uppercase">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {reposicionOrders.map((row) => (
                      <tr key={row.id || row.order_id} className="hover:bg-gray-50">
                        <td className="px-2 py-1">
                          <div className="text-sm font-medium text-gray-900">{row.order_number}</div>
                        </td>
                        <td className="px-2 py-1">
                          <div className="text-xs sm:text-sm text-gray-900 whitespace-normal break-words">{row.customer_name}</div>
                        </td>
                        <td className="px-2 py-1 hidden lg:table-cell">
                          <div className="flex flex-col items-start gap-1">
                            <span className="px-2 py-1 text-xs font-semibold rounded-full bg-orange-100 text-orange-800">
                              {row.status}
                            </span>
                            {(row.is_service === 1 || row.is_service === true) && (
                              <span className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                                Servicio
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="px-2 py-1 hidden lg:table-cell">
                          <span className="text-xs sm:text-sm text-gray-900">
                            {row.delivery_channel || '-'}
                          </span>
                        </td>
                        <td className="px-2 py-1 hidden lg:table-cell">
                          <div className="text-xs sm:text-sm text-gray-900">
                            {row.siigo_invoice_number || '-'}
                          </div>
                        </td>
                        <td className="px-2 py-1 hidden lg:table-cell">
                          <div className="text-xs text-gray-500">
                            {row.siigo_invoice_created_at ? new Date(row.siigo_invoice_created_at).toLocaleDateString('es-CO') : '-'}
                          </div>
                        </td>
                        <td className="px-2 py-1 hidden lg:table-cell">
                          <div className="text-xs sm:text-sm font-medium text-gray-900">
                            ${Number(row.total_amount || 0).toLocaleString('es-CO')}
                          </div>
                        </td>
                        <td className="px-2 py-1 text-right">
                          <button
                            onClick={() => setTimelineModal({ isOpen: true, order: row })}
                            className="mr-2 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded inline-flex items-center"
                            title="Ver Historial"
                          >
                            <Icons.History className="w-3 h-3" />
                          </button>
                          <button
                            onClick={() => handleOpenRepositionModal(row)}
                            className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white text-xs rounded inline-flex items-center"
                            title="Gestionar Reposición"
                          >
                            <Icons.CheckCircle className="w-3 h-3" />
                            <span className="ml-1 hidden sm:inline">Gestionar</span>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {reposicionOrders.length === 0 && (
                      <tr>
                        <td className="px-2 py-6 text-center text-sm text-gray-500" colSpan={8}>
                          No hay pedidos de reposición.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Cerrar en Siigo */}
      {
        siigoCloseModal.open && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4 overflow-y-auto">
            <div className="bg-white rounded shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto flex flex-col">
              <div className="p-4 border-b flex items-center justify-between shrink-0">
                <h3 className="text-lg font-semibold">Cerrar en Siigo</h3>
                <button onClick={() => setSiigoCloseModal({ open: false, order: null, method: 'efectivo', note: '', tags: [], availableTags: [] })} className="text-gray-600 hover:text-gray-900">
                  <Icons.X className="w-5 h-5" />
                </button>
              </div>
              <div className="p-4 space-y-4 grow overflow-y-auto">
                <div className="text-sm text-gray-700">
                  Pedido: <span className="font-semibold">{siigoCloseModal.order?.order_number}</span>
                </div>

                {/* Evidencia de pago (si existe y es transferencia/electrónico) */}
                {/* Evidencia de pago (si existe y es transferencia/electrónico) */}
                {(() => {
                  const raw = siigoCloseModal.order?.payment_evidence_path;
                  if (!raw) return null;

                  console.log('🖼️ Debug Evidencia Raw:', raw);

                  let paths = [];
                  try {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) paths = parsed;
                    else paths = [raw];
                  } catch {
                    if (raw.includes(',')) paths = raw.split(',').map(s => s.trim());
                    else paths = [raw];
                  }
                  paths = paths.filter(p => p && p !== 'null' && p !== 'undefined');

                  console.log('🖼️ Debug Evidencia Parsed:', paths);

                  if (paths.length === 0) return null;

                  return (
                    <div className="border rounded p-2 bg-gray-50">
                      <p className="text-xs font-medium text-gray-700 mb-2">Comprobante(s) de Pago:</p>
                      <div className="flex flex-col gap-2">
                        {paths.map((path, idx) => {
                          // Limpiar path para evitar dobles slashes o prefijos incorrectos
                          let cleanPath = path;
                          if (cleanPath.startsWith('/')) cleanPath = cleanPath.slice(1);
                          if (cleanPath.startsWith('uploads/')) cleanPath = cleanPath.replace('uploads/', '');

                          // Construir URL final
                          const src = path.startsWith('http') ? path : `/uploads/${cleanPath}`;
                          console.log(`🖼️ Debug Image ${idx} Src:`, src);

                          return (
                            <div key={idx} className="relative h-48 w-full bg-gray-200 rounded overflow-hidden flex items-center justify-center group">
                              <img
                                src={src}
                                alt={`Comprobante ${idx + 1}`}
                                className="max-h-full max-w-full object-contain"
                                onError={(e) => {
                                  console.error('❌ Error cargando imagen:', src);
                                  e.target.onerror = null;
                                  e.target.src = 'https://via.placeholder.com/300?text=Error+imagen';
                                }}
                              />
                              <a
                                href={src}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all opacity-0 group-hover:opacity-100"
                              >
                                <span className="bg-white text-gray-900 text-xs px-2 py-1 rounded shadow">Ver original</span>
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Método de Pago</label>
                  <select
                    value={siigoCloseModal.method}
                    onChange={(e) => setSiigoCloseModal(prev => ({ ...prev, method: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="efectivo">Efectivo</option>
                    <option value="transferencia">Transferencia</option>
                    <option value="credito">Cliente a Crédito</option>
                    <option value="pago_electronico">Pago Electrónico</option>
                    <option value="mercado_pago">Mercado Pago</option>
                    <option value="contraentrega">Contraentrega (Solo Bogotá)</option>
                    <option value="mercadopago">MercadoPago</option>
                    <option value="publicidad">Publicidad (sin validación)</option>
                    <option value="reposicion">Reposición (sin validación)</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>

                {/* Etiquetas con Autocomplete */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Etiquetas</label>
                  <Autocomplete
                    multiple
                    freeSolo
                    options={siigoCloseModal.availableTags}
                    value={siigoCloseModal.tags}
                    onChange={(event, newValue) => {
                      setSiigoCloseModal(prev => ({
                        ...prev,
                        tags: newValue
                      }));
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" color="primary" />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Seleccionar o crear etiqueta..."
                        size="small"
                      />
                    )}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nota (opcional)</label>
                  <textarea
                    value={siigoCloseModal.note}
                    onChange={(e) => setSiigoCloseModal(prev => ({ ...prev, note: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    rows={3}
                    placeholder="Observaciones del cierre"
                  />
                </div>
              </div>
              <div className="p-4 border-t flex items-center justify-end space-x-2 shrink-0">
                <button
                  onClick={() => setSiigoCloseModal({ open: false, order: null, method: 'efectivo', note: '', tags: [], availableTags: [] })}
                  className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleConfirmSiigoClose}
                  className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Completar Reposición de Fabricante */}
      {
        reposicionModal.open && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4 overflow-y-auto">
            <div className="bg-white rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto flex flex-col">
              <div className="p-4 border-b flex items-center justify-between shrink-0">
                <h3 className="text-lg font-semibold">Gestionar Reposición de Fabricante</h3>
                <button
                  onClick={() => setReposicionModal({ open: false, order: null, notes: '', files: [], isSubmitting: false })}
                  className="text-gray-600 hover:text-gray-900"
                  disabled={reposicionModal.isSubmitting}
                >
                  <Icons.X className="w-5 h-5" />
                </button>
              </div>

              <div className="p-4 flex-1 overflow-y-auto">
                <div className="mb-4">
                  <p className="text-sm text-gray-600 mb-2">
                    Pedido: <span className="font-semibold">{reposicionModal.order?.order_number}</span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Cliente: <span className="font-semibold">{reposicionModal.order?.customer_name}</span>
                  </p>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Notas / Observaciones
                  </label>
                  <textarea
                    value={reposicionModal.notes}
                    onChange={(e) => setReposicionModal(prev => ({ ...prev, notes: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows={4}
                    placeholder="Agrega detalles sobre la reposición, comunicación con el cliente, etc."
                    disabled={reposicionModal.isSubmitting}
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Evidencias (Imágenes de chats con cliente)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleRepositionFilesChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    disabled={reposicionModal.isSubmitting}
                  />
                  {reposicionModal.files.length > 0 && (
                    <p className="mt-2 text-sm text-green-600">
                      {reposicionModal.files.length} archivo(s) seleccionado(s)
                    </p>
                  )}
                  <p className="mt-1 text-xs text-gray-500">
                    Máximo 10 imágenes, 10MB por archivo. También puedes pegar imágenes con Ctrl+V
                  </p>
                </div>

                {/* Vista previa de imágenes */}
                {reposicionModal.files.length > 0 && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Vista Previa
                    </label>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                      {reposicionModal.files.map((file, idx) => (
                        <div key={idx} className="relative">
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Previa ${idx + 1}`}
                            className="w-full h-32 object-cover rounded border"
                          />
                          <p className="text-xs text-gray-500 truncate mt-1">{file.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="p-4 border-t flex justify-end gap-2 shrink-0 bg-gray-50">
                <button
                  onClick={() => setReposicionModal({ open: false, order: null, notes: '', files: [], isSubmitting: false })}
                  className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                  disabled={reposicionModal.isSubmitting}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleConfirmReposition}
                  className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={reposicionModal.isSubmitting}
                >
                  {reposicionModal.isSubmitting ? 'Guardando...' : 'Guardar Gestión'}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal de registro de entrega */}
      <DeliveryRegistrationModal
        isOpen={deliveryModal.isOpen}
        onClose={() => setDeliveryModal({ isOpen: false, order: null })}
        order={deliveryModal.order}
        onConfirm={handleDeliveryRegistration}
      />

      {/* Modal de revisión de pedido */}
      <OrderReviewModal
        isOpen={reviewModal.isOpen}
        onClose={() => setReviewModal({ isOpen: false, order: null })}
        order={reviewModal.order}
        onConfirm={handleOrderReview}
      />

      {/* Modal de validación de cartera */}
      <WalletValidationModal
        isOpen={walletModal.isOpen}
        onClose={() => setWalletModal({ isOpen: false, order: null })}
        order={walletModal.order}
        onValidate={handleWalletValidation}
        cashSessionOpen={cashSessionOpen}
      />

      {/* Modal de devolución a facturación */}
      <ReturnToBillingModal
        isOpen={returnToBillingModal.isOpen}
        onClose={() => setReturnToBillingModal({ isOpen: false, order: null })}
        order={returnToBillingModal.order}
        onSuccess={() => {
          setReturnToBillingModal({ isOpen: false, order: null });
          loadOrders();
        }}
      />





      <ReconciliationModal
        isOpen={reconciliationModal.isOpen}
        onClose={() => setReconciliationModal({ isOpen: false, order: null })}
        order={reconciliationModal.order}
        onSuccess={() => {
          // Refresh pending reconciliation list
          walletService.getPendingReconciliation().then(res => {
            setPendingReconciliation(res?.data || []);
          });
        }}
      />

      <PosValidationModal
        isOpen={posModal.isOpen}
        order={posModal.order}
        onClose={() => setPosModal({ isOpen: false, order: null })}
        onValidate={handlePosValidation}
      />

      {/* Sync RC Modal */}
      {
        syncingOrderId && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-xl p-6 w-[400px] border border-gray-100">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                <Icons.RefreshCw className="animate-spin text-blue-600" />
                Sincronizando Recibos de Caja
              </h3>

              <div className="space-y-4">
                <div className="w-full h-4 bg-gray-100 rounded-full overflow-hidden border border-gray-200 shadow-inner">
                  <div
                    className="h-full bg-gradient-to-r from-blue-500 to-indigo-600 transition-all duration-300 ease-out"
                    style={{ width: `${Math.max(5, syncRCProgress[syncingOrderId]?.progress || 0)}%` }}
                  />
                </div>

                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-600 font-medium">
                    {syncRCProgress[syncingOrderId]?.message || 'Conectando...'}
                  </span>
                  <span className="font-bold text-blue-700">
                    {syncRCProgress[syncingOrderId]?.progress || 0}%
                  </span>
                </div>

                <p className="text-xs text-gray-400 text-center mt-2">
                  Escaneando historial en Siigo (Hasta 10,000 documentos recientes)...
                </p>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal de Snapshot */}
      {/* Sync Progress Modal */}
      {
        syncModal.isOpen && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl p-8 max-w-sm w-full mx-4 transform transition-all scale-100">
              <div className="text-center">

                {/* Icon / status indicator */}
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-6">
                  {syncModal.status === 'processing' && (
                    <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  )}
                  {syncModal.status === 'success' && (
                    <svg className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                  {syncModal.status === 'error' && (
                    <svg className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  )}
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {syncModal.status === 'success' ? '¡Sincronización Completada!' :
                    syncModal.status === 'error' ? 'Error en Sincronización' :
                      'Sincronizando Pedido...'}
                </h3>

                <p className="text-sm text-gray-500 mb-6 min-h-[1.5em]">
                  {syncModal.message}
                </p>

                {/* Progress Bar */}
                <div className="w-full bg-gray-200 rounded-full h-4 mb-4 overflow-hidden">
                  <div
                    className={`h-4 rounded-full transition-all duration-500 ease-out ${syncModal.status === 'success' ? 'bg-green-500' :
                      syncModal.status === 'error' ? 'bg-red-500' : 'bg-blue-600'
                      }`}
                    style={{ width: `${Math.max(5, syncModal.progress)}%` }}
                  ></div>
                </div>

                <div className="flex justify-between text-xs text-gray-400 font-medium">
                  <span>0%</span>
                  <span>{Math.round(syncModal.progress)}%</span>
                  <span>100%</span>
                </div>

              </div>
            </div>
          </div>
        )
      }

      <LogisticsModal
        isOpen={logisticsModal.isOpen}
        onClose={() => setLogisticsModal({ isOpen: false, order: null })}
        order={logisticsModal.order}
        onProcess={handleLogisticsProcess}
      />
      {
        shippingModal.isOpen && (
          <ChangeShippingModal
            order={shippingModal.order}
            onClose={() => setShippingModal({ isOpen: false, order: null })}
            onSuccess={() => {
              loadOrders(undefined, false);
              window.dispatchEvent(new Event('orders:refresh'));
            }}
          />
        )
      }
      <RefundModal
        open={refundModal.isOpen}
        order={refundModal.order}
        onClose={() => setRefundModal({ isOpen: false, order: null })}
        onSaved={() => {
          loadOrders(undefined, false);
          window.dispatchEvent(new Event('orders:refresh'));
        }}
      />

      {/* Modal de recepción de pago en bodega */}
      <PickupPaymentModal
        isOpen={pickupPaymentModal.isOpen}
        order={pickupPaymentModal.order}
        onClose={() => setPickupPaymentModal({ isOpen: false, order: null })}
        onConfirm={confirmPickupPayment}
        cashSessionOpen={cashSessionOpen}
      />

      {/* Modal de eliminación de pedido SIIGO */}
      <DeleteSiigoOrderModal
        isOpen={deleteSiigoModal.isOpen}
        onClose={() => setDeleteSiigoModal({ isOpen: false, order: null, loading: false })}
        order={deleteSiigoModal.order}
        onConfirm={handleDeleteSiigoOrderConfirm}
        loading={deleteSiigoModal.loading}
      />

      {/* ─── Modal Guard: Método de Pago SIIGO ─── */}
      {paymentGuardModal.isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" style={{ animation: 'fadeInScale 0.25s ease-out' }}>
            {/* Header con gradiente */}
            <div style={{ background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)' }} className="px-6 py-5 text-center">
              <div className="mx-auto w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-3">
                <Icons.ShieldAlert className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-white text-lg font-bold">Método de Pago Incorrecto</h3>
              <p className="text-red-100 text-sm mt-1">No se puede procesar este pedido</p>
            </div>

            {/* Body */}
            <div className="px-6 py-5">
              {/* Método actual */}
              <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4">
                <p className="text-xs text-red-500 font-semibold uppercase tracking-wide mb-1">Método de pago actual en SIIGO</p>
                <p className="text-red-800 font-bold text-base">{paymentGuardModal.paymentMethod}</p>
              </div>

              {/* Método requerido */}
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-5">
                <p className="text-xs text-emerald-600 font-semibold uppercase tracking-wide mb-1">Método requerido</p>
                <p className="text-emerald-800 font-bold text-base">5672 - Pago a Crédito</p>
              </div>

              {/* Pasos */}
              <div className="space-y-3 mb-5">
                <p className="text-sm font-semibold text-gray-700">Pasos para corregir:</p>
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xs font-bold">1</span>
                  <p className="text-sm text-gray-600">Edite la factura en <strong>SIIGO</strong> y cambie el método de pago a <strong>"Pago a Crédito"</strong></p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xs font-bold">2</span>
                  <p className="text-sm text-gray-600">Regrese aquí y haga clic en <strong>"Sincronizar"</strong></p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xs font-bold">3</span>
                  <p className="text-sm text-gray-600">Vuelva a intentar procesar el pedido</p>
                </div>
              </div>

              {/* Info */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
                <p className="text-xs text-amber-700"><Icons.Info className="w-3.5 h-3.5 inline mr-1 mb-0.5" />Las facturas deben estar en <strong>"Pago a Crédito"</strong> para poder crear Recibos de Caja (RC) posteriormente.</p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 pb-5 flex gap-3">
              <button
                onClick={() => {
                  setPaymentGuardModal({ isOpen: false, order: null, paymentMethod: '' });
                  if (paymentGuardModal.order?.id) {
                    handleReloadFromSiigo(paymentGuardModal.order.id);
                  }
                }}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-medium text-sm transition-colors"
              >
                <Icons.RefreshCw className="w-4 h-4" />
                Sincronizar desde SIIGO
              </button>
              <button
                onClick={() => setPaymentGuardModal({ isOpen: false, order: null, paymentMethod: '' })}
                className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium text-sm transition-colors"
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación de entrega */}
      <DeliveryConfirmationModal
        isOpen={deliveryConfirmationModal.isOpen}
        onClose={() => setDeliveryConfirmationModal({ isOpen: false, order: null })}
        order={deliveryConfirmationModal.order}
        onConfirmStart={handleStartDelivery}
      />

      {/* Modal de línea de tiempo del pedido */}
      <OrderTimelineModal
        isOpen={timelineModal.isOpen}
        onClose={() => setTimelineModal({ isOpen: false, order: null })}
        order={timelineModal.order}
      />

      {/* Modal de Gestión Especial (bonito) */}
      <SpecialManagementModal
        isOpen={specialModal.isOpen}
        onClose={() => !specialModal.loading && setSpecialModal({ isOpen: false, order: null, loading: false })}
        order={specialModal.order}
        loading={specialModal.loading}
        onConfirm={handleConfirmSpecial}
      />

      {/* Modal genérico de motivo (rechazo / entrega fallida) */}
      <ReasonModal
        isOpen={reasonModal.isOpen}
        onClose={() => !reasonModal.loading && setReasonModal({ isOpen: false, order: null, mode: 'reject', loading: false })}
        order={reasonModal.order}
        mode={reasonModal.mode}
        loading={reasonModal.loading}
        onConfirm={handleReasonConfirm}
      />

      {/* Modal de registro de pago adhoc (mensajero) */}
      <AdhocPaymentModal
        isOpen={adhocPaymentModal.isOpen}
        onClose={() => setAdhocPaymentModal({ isOpen: false })}
        onConfirm={handleConfirmAdhocPayment}
      />

      {/* Modal: Cliente canceló pedido (acción rápida en listado) */}
      <ReasonModal
        isOpen={cancelModal.isOpen}
        onClose={() => !cancelModal.loading && setCancelModal({ isOpen: false, order: null, loading: false })}
        order={cancelModal.order}
        mode="reason"
        loading={cancelModal.loading}
        onConfirm={handleConfirmCancelByCustomer}
      />
      {/* Modal Subir Comprobante */}
      <UploadEvidenceModal
        isOpen={uploadEvidenceModal.open}
        onClose={() => setUploadEvidenceModal({ open: false, order: null, file: null })}
        order={uploadEvidenceModal.order}
        onSuccess={() => {
          loadOrders();
          setUploadEvidenceModal({ open: false, order: null, file: null });
        }}
      />
      <SnapshotViewerModal
        isOpen={snapshotModal.isOpen}
        onClose={() => setSnapshotModal({ isOpen: false, orderId: null })}
        orderId={snapshotModal.orderId}
      />
      {/* Modal Generar Guía */}
      <ShippingLabelModal
        isOpen={labelModal.isOpen}
        onClose={() => setLabelModal({ isOpen: false, order: null })}
        order={labelModal.order}
        onConfirm={(count) => {
          openGuideInNewTab(labelModal.order, count);
        }}
      />
      {/* Multi-Invoice RC Dialog */}
      <MultiInvoiceRCDialog
        isOpen={multiRcDialogOpen}
        toggle={() => setMultiRcDialogOpen(false)}
        onSuccess={() => {
          toast.success('RC Multi-Pedido creado exitosamente');
          loadOrders(); // Refresh orders list
        }}
      />
      {/* Abono Parcial Dialog */}
      <AbonoParcialesDialog
        isOpen={abonoDialogOpen}
        toggle={() => setAbonoDialogOpen(false)}
        onSuccess={() => loadOrders()}
      />
    </div >
  );
};

// Obtener color del estado
function getStatusColor(status, order = null) {
  // Prioridad: Pendiente de comprobante (si se pasa el objeto order)
  if (order && (order.is_pending_payment_evidence === true || order.is_pending_payment_evidence === 1 || order.is_pending_payment_evidence === '1')) {
    return 'bg-orange-100 text-orange-800';
  }

  const colors = {
    pendiente_por_facturacion: 'bg-yellow-100 text-yellow-800',
    revision_cartera: 'bg-blue-100 text-blue-800',
    en_logistica: 'bg-purple-100 text-purple-800',
    en_empaque: 'bg-orange-100 text-orange-800',
    empacado: 'bg-cyan-100 text-cyan-800',
    en_reparto: 'bg-indigo-100 text-indigo-800',
    listo_para_recoger: 'bg-green-100 text-green-800',
    entregado_transportadora: 'bg-green-100 text-green-800',
    entregado_cliente: 'bg-green-100 text-green-800',
    entregado_bodega: 'bg-green-100 text-green-800',
    entregado: 'bg-green-100 text-green-800',
    no_entregado: 'bg-orange-100 text-orange-800',
    gestion_especial: 'bg-red-100 text-red-800',
    cancelado: 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

// Obtener etiqueta del estado
function getStatusLabel(status, order = null) {
  // Prioridad: Pendiente de comprobante (si se pasa el objeto order)
  if (order && (order.is_pending_payment_evidence === true || order.is_pending_payment_evidence === 1 || order.is_pending_payment_evidence === '1')) {
    return 'Pendiente Comprobante';
  }

  const labels = {
    pendiente_por_facturacion: 'Pendiente por Facturación',
    revision_cartera: 'Revisión por Cartera',
    en_logistica: 'En Logística',
    en_empaque: 'En Empaque',
    empacado: 'Empacado',
    en_reparto: 'En Reparto',
    listo_para_recoger: 'Listo para Recoger en Bodega',
    entregado_transportadora: 'Entregado a Transportadora',
    entregado_cliente: 'Entregado a Cliente',
    entregado_bodega: 'Entregado en Bodega',
    entregado: 'Entregado',
    no_entregado: 'Retornado',
    gestion_especial: 'Gestión Especial',
    cancelado: 'Cancelado'
  };
  return labels[status] || status;
}

// Etiqueta corta para móvil (mensajero)
function getStatusShort(status) {
  const map = {
    listo_para_entrega: 'Listo',
    en_reparto: 'En ruta',
    entregado_cliente: 'Entregado',
    entregado_bodega: 'Entregado',
    entregado_transportadora: 'En transportadora'
  };
  return map[status] || (getStatusLabel(status) || '').split(' ')[0];
}

// Helper para obtener el monto correcto según el endpoint usado
function getOrderAmount(order) {
  // Priorizar net_value si existe (Total a Pagar)
  if (order.net_value !== undefined && order.net_value !== null) {
    return parseFloat(order.net_value);
  }
  // Para mensajeros, el campo se llama 'total'
  // Para otros roles, el campo se llama 'total_amount'
  return parseFloat(order.total ?? order.total_amount ?? 0);
}

// Obtener etiqueta del método de envío
function getDeliveryMethodLabel(method) {
  const labels = {
    domicilio_ciudad: 'Domicilio Ciudad',
    domicilio_nacional: 'Domicilio Nacional',
    recogida_tienda: 'Recogida en Tienda',
    envio_nacional: 'Envío Nacional',
    envio_internacional: 'Envío Internacional',
    contraentrega: 'Contraentrega'
  };
  return labels[method] || method || 'No especificado';
}

// Obtener color del método de envío
function getDeliveryMethodColor(method) {
  const colors = {
    domicilio_ciudad: 'bg-blue-100 text-blue-800',
    domicilio_nacional: 'bg-purple-100 text-purple-800',
    recogida_tienda: 'bg-green-100 text-green-800',
    envio_nacional: 'bg-orange-100 text-orange-800',
    envio_internacional: 'bg-red-100 text-red-800',
    contraentrega: 'bg-yellow-100 text-yellow-800'
  };
  return colors[method] || 'bg-gray-100 text-gray-800';
}

// Formato de moneda para monto a cobrar en móvil
// formatCurrencyCOP imported from utils/formatters

// Dirección de entrega (mejor esfuerzo)
function getOrderAddress(order) {
  return (
    order?.delivery_address ||
    order?.shipping_address ||
    order?.customer_address ||
    order?.address ||
    order?.direccion ||
    ''
  );
}

// Ciudad del pedido (mejor esfuerzo)
function getOrderCity(order) {
  return (
    order?.city || order?.customer_city || order?.shipping_city || order?.ciudad || ''
  );
}

// Link a Google Maps para la dirección
function getMapsUrl(order) {
  const addr = (getOrderAddress(order) || '').trim();
  const city = (getOrderCity(order) || '').trim();
  const q = [addr, city].filter(Boolean).join(', ');
  if (!q) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

// Motivo de Gestión Especial (solo devuelve el motivo, nunca observaciones de SIIGO)
function getSpecialReason(order) {
  const status = String(order?.status || '').toLowerCase();
  if (status !== 'gestion_especial') return '';

  // 1) Campos explícitos de gestión especial (si el backend los enviara)
  const special = __getRawFromPaths(order, [
    'special_management_note',
    'special_reason',
    'special_notes',
    'special_management_reason',
    'special_management.reason',
    'special_management.notes',
    'gestion_especial_motivo',
    'gestion_especial_notas',
    'admin_notes',
    'review_notes'
  ]);
  if (special) {
    const m = /gesti[oó]n especial:\s*(.*)/i.exec(String(special));
    return (m && m[1]) ? m[1].trim() : String(special);
  }

  // 2) Parsear desde 'notes' el segmento "GESTIÓN ESPECIAL: ..." cuando se guarda como texto plano
  const rawNotes = __firstNonEmpty(
    order?.notes,
    order?.observations,
    order?.order_notes,
    order?.general_notes
  );
  if (rawNotes) {
    const m2 = /gesti[oó]n especial:\s*(.*)/i.exec(String(rawNotes));
    if (m2 && m2[1]) {
      return m2[1].trim();
    }
  }
  return '';
}

// Observaciones del pedido (mejor esfuerzo)
function getOrderNotes(order) {
  // Si el pedido está en Gestión Especial, priorizar el motivo específico
  const status = String(order?.status || '').toLowerCase();
  if (status === 'gestion_especial') {
    // 1) Campos explícitos de gestión especial (si el backend los enviara)
    const special = __getRawFromPaths(order, [
      'special_management_note',
      'special_reason',
      'special_notes',
      'special_management_reason',
      'special_management.notes',
      'special_management.reason',
      'gestion_especial_motivo',
      'gestion_especial_notas',
      'admin_notes',
      'review_notes'
    ]);
    if (special) {
      // Si viene con prefijo "GESTIÓN ESPECIAL: ", extraer solo el motivo
      const m = /gesti[oó]n especial:\s*(.*)/i.exec(String(special));
      return (m && m[1]) ? m[1].trim() : special;
    }
    // 2) Parsear desde 'notes' el segmento "GESTIÓN ESPECIAL: ..." cuando se guarda como texto plano
    const rawNotes = __firstNonEmpty(
      order?.notes,
      order?.observations,
      order?.order_notes,
      order?.general_notes
    );
    if (rawNotes) {
      const m2 = /gesti[oó]n especial:\s*(.*)/i.exec(String(rawNotes));
      if (m2 && m2[1]) {
        return m2[1].trim();
      }
    }
  }
  // Fallbacks generales (incluye observaciones SIIGO en último lugar)
  return __getRawFromPaths(order, [
    // Motivos/Notas de Gestión Especial (prioridad alta si existieran)
    'special_management_note',
    'special_reason',
    'special_notes',
    'special_management_reason',
    'special_management.notes',
    'special_management.reason',
    'gestion_especial_motivo',
    'gestion_especial_notas',
    'admin_notes',
    'review_notes',
    // Genéricas
    'notes', 'observations', 'order_notes', 'general_notes', 'logistics_notes', 'shipping_notes',
    'comentarios', 'observaciones', 'customer_notes',
    'metadata.notes', 'meta.notes',
    // SIIGO (por si el backend lo expone como campo plano)
    'siigo_observations',
    'siigo.notes'
  ]);
}

// Helpers para mostrar en columna "Mensajero" una vista más amplia (transportadora/bodega)
function isBodegaDelivered(order) {
  return (
    (['recoge_bodega', 'recoge_posterior', 'recogida_tienda'].includes(order?.delivery_method)) &&
    (
      ['entregado_bodega', 'entregado_cliente', 'entregado', 'completado', 'finalizado'].includes(order?.status) ||
      Boolean(order?.delivered_at) || Boolean(order?.is_delivered)
    )
  );
}

function isCarrierFlow(order) {
  const method = String(order?.delivery_method || '').toLowerCase();
  const hasCarrier = Number(order?.carrier_id || 0) > 0 || Boolean(order?.carrier_name);
  return (
    String(order?.status || '').toLowerCase() === 'entregado_transportadora' ||
    hasCarrier ||
    ['envio_nacional', 'envio_internacional'].includes(method)
  );
}

function getCourierDisplay(order) {
  if (isCarrierFlow(order)) {
    return order?.carrier_name || 'Transportadora';
  }
  if (isBodegaDelivered(order)) {
    return 'Bodega';
  }
  return (
    order?.assigned_messenger_name ||
    order?.messenger_name ||
    (order?.assigned_messenger_id ? `Mensajero ID: ${order.assigned_messenger_id}` : '-')
  );
}

function isMessengerFlow(order) {
  return !isCarrierFlow(order) && !isBodegaDelivered(order);
}



/* payment helpers now imported from ../utils/payments */

/* electronic provider label/badge helpers now imported from ../utils/payments */

/* detectProviderFromString now provided by utils/payments if needed */

/* deepScanProvider no longer needed here */

/* resolveElectronicType imported from ../utils/payments */

/* getProviderHint imported from ../utils/payments */

/**
 * Robust raw value helpers for payment method and electronic provider.
 * - Supports nested paths like "payment.payment_method"
 * - Returns first non-empty normalized string
 * - Filters out placeholders like "undefined", "null", "N/A"
      */
function __toText(val) {
  if (val == null) return '';
  if (typeof val === 'string') return val.trim();
  if (typeof val === 'number') return String(val);
  if (typeof val === 'boolean') return val ? 'true' : 'false';
  if (typeof val === 'object') {
    if (typeof val.label === 'string') return val.label.trim();
    // Common "raw" map-like shapes
    if (typeof val.value === 'string') return val.value.trim();
  }
  return '';
}

function __firstNonEmpty(...vals) {
  for (const v of vals) {
    const s = __toText(v);
    const low = s.toLowerCase();
    if (s && low !== 'undefined' && low !== 'null' && low !== 'n/a' && low !== 'na') {
      return s;
    }
  }
  return '';
}

function __getPath(obj, path) {
  try {
    return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
  } catch {
    return undefined;
  }
}

function __getRawFromPaths(obj, paths) {
  for (const p of paths) {
    const v = __getPath(obj, p);
    const s = __firstNonEmpty(v);
    if (s) return s;
  }
  return '';
}

function getRawPaymentMethod(order) {
  const paths = [
    // flat
    'payment_method', 'PaymentMethod', 'paymentMethod',
    'payment_method_raw', 'paymentMethodRaw',
    'payment_term', 'paymentTerm',
    'payment_condition', 'paymentCondition',
    'payment_type', 'paymentType',
    'payment', 'metodo_pago', 'metodoPago', 'METODO_PAGO',
    // nested generic
    'payment.payment_method', 'payment.method', 'payment.details.method',
    'paymentInfo.method', 'payment_info.method', 'payment_info.payment_method',
    // siigo/invoice
    'siigo.payment_method', 'siigo_payment_method',
    'siigoInvoiceData.payment_method', 'invoice_data.payment_method',
    // metadata
    'metadata.payment_method', 'meta.payment_method'
  ];
  return __getRawFromPaths(order, paths);
}

function getRawElectronicProvider(order) {
  const paths = [
    // flat
    'electronic_payment_type', 'electronic_payment_provider', 'payment_provider',
    'electronicPaymentType', 'electronicPaymentProvider', 'paymentProvider',
    // nested generic
    'payment.electronic.provider', 'payment.provider',
    'paymentInfo.provider', 'payment_info.provider',
    // siigo/invoice
    'siigo.electronic_payment_type', 'siigo.electronic_payment_provider', 'siigo_payment_provider',
    'invoice_data.payment_provider',
    // metadata
    'metadata.payment_provider', 'meta.payment_provider'
  ];
  return __getRawFromPaths(order, paths);
}

export default OrdersPage;
// Cache bust 1769989150
